export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
  Long: any;
  Time: any;
  Upload: any;
  Void: any;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type ApplicationConfig = {
  __typename?: 'ApplicationConfig';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  payment_stripe_key?: Maybe<Scalars['String']>;
  enable_payments?: Maybe<Scalars['Boolean']>;
};

export type ApplicationConfigInput = {
  payment_stripe_key?: Maybe<Scalars['String']>;
  enable_payments?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Bookmark = {
  __typename?: 'Bookmark';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  type?: Maybe<Enum_Bookmark_Type>;
  item_id?: Maybe<Scalars['Int']>;
  category?: Maybe<Enum_Bookmark_Category>;
  person_profile?: Maybe<PersonProfile>;
};

export type BookmarkAggregator = {
  __typename?: 'BookmarkAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<BookmarkAggregatorSum>;
  avg?: Maybe<BookmarkAggregatorAvg>;
  min?: Maybe<BookmarkAggregatorMin>;
  max?: Maybe<BookmarkAggregatorMax>;
};

export type BookmarkAggregatorAvg = {
  __typename?: 'BookmarkAggregatorAvg';
  item_id?: Maybe<Scalars['Float']>;
};

export type BookmarkAggregatorMax = {
  __typename?: 'BookmarkAggregatorMax';
  item_id?: Maybe<Scalars['Float']>;
};

export type BookmarkAggregatorMin = {
  __typename?: 'BookmarkAggregatorMin';
  item_id?: Maybe<Scalars['Float']>;
};

export type BookmarkAggregatorSum = {
  __typename?: 'BookmarkAggregatorSum';
  item_id?: Maybe<Scalars['Float']>;
};

export type BookmarkConnection = {
  __typename?: 'BookmarkConnection';
  values?: Maybe<Array<Maybe<Bookmark>>>;
  groupBy?: Maybe<BookmarkGroupBy>;
  aggregate?: Maybe<BookmarkAggregator>;
};

export type BookmarkConnectionCategory = {
  __typename?: 'BookmarkConnectionCategory';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookmarkConnection>;
};

export type BookmarkConnectionCreated_At = {
  __typename?: 'BookmarkConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookmarkConnection>;
};

export type BookmarkConnectionId = {
  __typename?: 'BookmarkConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookmarkConnection>;
};

export type BookmarkConnectionItem_Id = {
  __typename?: 'BookmarkConnectionItem_id';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<BookmarkConnection>;
};

export type BookmarkConnectionPerson_Profile = {
  __typename?: 'BookmarkConnectionPerson_profile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookmarkConnection>;
};

export type BookmarkConnectionType = {
  __typename?: 'BookmarkConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookmarkConnection>;
};

export type BookmarkConnectionUpdated_At = {
  __typename?: 'BookmarkConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookmarkConnection>;
};

export type BookmarkGroupBy = {
  __typename?: 'BookmarkGroupBy';
  id?: Maybe<Array<Maybe<BookmarkConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BookmarkConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BookmarkConnectionUpdated_At>>>;
  type?: Maybe<Array<Maybe<BookmarkConnectionType>>>;
  item_id?: Maybe<Array<Maybe<BookmarkConnectionItem_Id>>>;
  category?: Maybe<Array<Maybe<BookmarkConnectionCategory>>>;
  person_profile?: Maybe<Array<Maybe<BookmarkConnectionPerson_Profile>>>;
};

export type BookmarkInput = {
  type?: Maybe<Enum_Bookmark_Type>;
  item_id?: Maybe<Scalars['Int']>;
  category?: Maybe<Enum_Bookmark_Category>;
  person_profile?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type BusinessUseCase = {
  __typename?: 'BusinessUseCase';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type BusinessUseCaseAggregator = {
  __typename?: 'BusinessUseCaseAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BusinessUseCaseConnection = {
  __typename?: 'BusinessUseCaseConnection';
  values?: Maybe<Array<Maybe<BusinessUseCase>>>;
  groupBy?: Maybe<BusinessUseCaseGroupBy>;
  aggregate?: Maybe<BusinessUseCaseAggregator>;
};

export type BusinessUseCaseConnectionCreated_At = {
  __typename?: 'BusinessUseCaseConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BusinessUseCaseConnection>;
};

export type BusinessUseCaseConnectionId = {
  __typename?: 'BusinessUseCaseConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BusinessUseCaseConnection>;
};

export type BusinessUseCaseConnectionName = {
  __typename?: 'BusinessUseCaseConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BusinessUseCaseConnection>;
};

export type BusinessUseCaseConnectionUpdated_At = {
  __typename?: 'BusinessUseCaseConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BusinessUseCaseConnection>;
};

export type BusinessUseCaseGroupBy = {
  __typename?: 'BusinessUseCaseGroupBy';
  id?: Maybe<Array<Maybe<BusinessUseCaseConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BusinessUseCaseConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BusinessUseCaseConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<BusinessUseCaseConnectionName>>>;
};

export type BusinessUseCaseInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CareerInput = {
  job_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Careers = {
  __typename?: 'Careers';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  job_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type CareersAggregator = {
  __typename?: 'CareersAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CareersConnection = {
  __typename?: 'CareersConnection';
  values?: Maybe<Array<Maybe<Careers>>>;
  groupBy?: Maybe<CareersGroupBy>;
  aggregate?: Maybe<CareersAggregator>;
};

export type CareersConnectionCreated_At = {
  __typename?: 'CareersConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CareersConnection>;
};

export type CareersConnectionDescription = {
  __typename?: 'CareersConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CareersConnection>;
};

export type CareersConnectionId = {
  __typename?: 'CareersConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CareersConnection>;
};

export type CareersConnectionJob_Title = {
  __typename?: 'CareersConnectionJob_title';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CareersConnection>;
};

export type CareersConnectionPublished_At = {
  __typename?: 'CareersConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CareersConnection>;
};

export type CareersConnectionUpdated_At = {
  __typename?: 'CareersConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CareersConnection>;
};

export type CareersGroupBy = {
  __typename?: 'CareersGroupBy';
  id?: Maybe<Array<Maybe<CareersConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CareersConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CareersConnectionUpdated_At>>>;
  job_title?: Maybe<Array<Maybe<CareersConnectionJob_Title>>>;
  description?: Maybe<Array<Maybe<CareersConnectionDescription>>>;
  published_at?: Maybe<Array<Maybe<CareersConnectionPublished_At>>>;
};

export type CatalystAllocation = {
  __typename?: 'CatalystAllocation';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  users_permissions_user?: Maybe<UsersPermissionsUser>;
  startup_profile?: Maybe<StartupProfile>;
  corporate_profiles?: Maybe<Array<Maybe<Corporate>>>;
};


export type CatalystAllocationCorporate_ProfilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CatalystAllocationAggregator = {
  __typename?: 'CatalystAllocationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CatalystAllocationConnection = {
  __typename?: 'CatalystAllocationConnection';
  values?: Maybe<Array<Maybe<CatalystAllocation>>>;
  groupBy?: Maybe<CatalystAllocationGroupBy>;
  aggregate?: Maybe<CatalystAllocationAggregator>;
};

export type CatalystAllocationConnectionCreated_At = {
  __typename?: 'CatalystAllocationConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalystAllocationConnection>;
};

export type CatalystAllocationConnectionId = {
  __typename?: 'CatalystAllocationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalystAllocationConnection>;
};

export type CatalystAllocationConnectionStartup_Profile = {
  __typename?: 'CatalystAllocationConnectionStartup_profile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalystAllocationConnection>;
};

export type CatalystAllocationConnectionUpdated_At = {
  __typename?: 'CatalystAllocationConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalystAllocationConnection>;
};

export type CatalystAllocationConnectionUsers_Permissions_User = {
  __typename?: 'CatalystAllocationConnectionUsers_permissions_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalystAllocationConnection>;
};

export type CatalystAllocationGroupBy = {
  __typename?: 'CatalystAllocationGroupBy';
  id?: Maybe<Array<Maybe<CatalystAllocationConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CatalystAllocationConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CatalystAllocationConnectionUpdated_At>>>;
  users_permissions_user?: Maybe<Array<Maybe<CatalystAllocationConnectionUsers_Permissions_User>>>;
  startup_profile?: Maybe<Array<Maybe<CatalystAllocationConnectionStartup_Profile>>>;
};

export type CatalystAllocationInput = {
  users_permissions_user?: Maybe<Scalars['ID']>;
  corporate_profiles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  startup_profile?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CatalystConversationInput = {
  users_permissions_user?: Maybe<Scalars['ID']>;
  conversation?: Maybe<Scalars['ID']>;
  active?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CatalystConversations = {
  __typename?: 'CatalystConversations';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  users_permissions_user?: Maybe<UsersPermissionsUser>;
  conversation?: Maybe<Conversations>;
  active?: Maybe<Scalars['Boolean']>;
};

export type CatalystConversationsAggregator = {
  __typename?: 'CatalystConversationsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CatalystConversationsConnection = {
  __typename?: 'CatalystConversationsConnection';
  values?: Maybe<Array<Maybe<CatalystConversations>>>;
  groupBy?: Maybe<CatalystConversationsGroupBy>;
  aggregate?: Maybe<CatalystConversationsAggregator>;
};

export type CatalystConversationsConnectionActive = {
  __typename?: 'CatalystConversationsConnectionActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CatalystConversationsConnection>;
};

export type CatalystConversationsConnectionConversation = {
  __typename?: 'CatalystConversationsConnectionConversation';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalystConversationsConnection>;
};

export type CatalystConversationsConnectionCreated_At = {
  __typename?: 'CatalystConversationsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalystConversationsConnection>;
};

export type CatalystConversationsConnectionId = {
  __typename?: 'CatalystConversationsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalystConversationsConnection>;
};

export type CatalystConversationsConnectionUpdated_At = {
  __typename?: 'CatalystConversationsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalystConversationsConnection>;
};

export type CatalystConversationsConnectionUsers_Permissions_User = {
  __typename?: 'CatalystConversationsConnectionUsers_permissions_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalystConversationsConnection>;
};

export type CatalystConversationsGroupBy = {
  __typename?: 'CatalystConversationsGroupBy';
  id?: Maybe<Array<Maybe<CatalystConversationsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CatalystConversationsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CatalystConversationsConnectionUpdated_At>>>;
  users_permissions_user?: Maybe<Array<Maybe<CatalystConversationsConnectionUsers_Permissions_User>>>;
  conversation?: Maybe<Array<Maybe<CatalystConversationsConnectionConversation>>>;
  active?: Maybe<Array<Maybe<CatalystConversationsConnectionActive>>>;
};

export type Chat = {
  __typename?: 'Chat';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  category?: Maybe<Enum_Chat_Category>;
  reference_id?: Maybe<Scalars['String']>;
  users?: Maybe<Scalars['JSON']>;
  chat_messages?: Maybe<Array<Maybe<ChatMessages>>>;
};


export type ChatChat_MessagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ChatAggregator = {
  __typename?: 'ChatAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ChatConnection = {
  __typename?: 'ChatConnection';
  values?: Maybe<Array<Maybe<Chat>>>;
  groupBy?: Maybe<ChatGroupBy>;
  aggregate?: Maybe<ChatAggregator>;
};

export type ChatConnectionCategory = {
  __typename?: 'ChatConnectionCategory';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ChatConnection>;
};

export type ChatConnectionCreated_At = {
  __typename?: 'ChatConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ChatConnection>;
};

export type ChatConnectionId = {
  __typename?: 'ChatConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ChatConnection>;
};

export type ChatConnectionReference_Id = {
  __typename?: 'ChatConnectionReference_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ChatConnection>;
};

export type ChatConnectionUpdated_At = {
  __typename?: 'ChatConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ChatConnection>;
};

export type ChatConnectionUsers = {
  __typename?: 'ChatConnectionUsers';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<ChatConnection>;
};

export type ChatGroupBy = {
  __typename?: 'ChatGroupBy';
  id?: Maybe<Array<Maybe<ChatConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ChatConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ChatConnectionUpdated_At>>>;
  category?: Maybe<Array<Maybe<ChatConnectionCategory>>>;
  reference_id?: Maybe<Array<Maybe<ChatConnectionReference_Id>>>;
  users?: Maybe<Array<Maybe<ChatConnectionUsers>>>;
};

export type ChatInput = {
  category?: Maybe<Enum_Chat_Category>;
  reference_id?: Maybe<Scalars['String']>;
  users?: Maybe<Scalars['JSON']>;
  chat_messages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ChatMessageInput = {
  body: Scalars['String'];
  from_user?: Maybe<Scalars['ID']>;
  chat?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ChatMessages = {
  __typename?: 'ChatMessages';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  body: Scalars['String'];
  from_user?: Maybe<UsersPermissionsUser>;
  chat?: Maybe<Chat>;
};

export type ChatMessagesAggregator = {
  __typename?: 'ChatMessagesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ChatMessagesConnection = {
  __typename?: 'ChatMessagesConnection';
  values?: Maybe<Array<Maybe<ChatMessages>>>;
  groupBy?: Maybe<ChatMessagesGroupBy>;
  aggregate?: Maybe<ChatMessagesAggregator>;
};

export type ChatMessagesConnectionBody = {
  __typename?: 'ChatMessagesConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ChatMessagesConnection>;
};

export type ChatMessagesConnectionChat = {
  __typename?: 'ChatMessagesConnectionChat';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ChatMessagesConnection>;
};

export type ChatMessagesConnectionCreated_At = {
  __typename?: 'ChatMessagesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ChatMessagesConnection>;
};

export type ChatMessagesConnectionFrom_User = {
  __typename?: 'ChatMessagesConnectionFrom_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ChatMessagesConnection>;
};

export type ChatMessagesConnectionId = {
  __typename?: 'ChatMessagesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ChatMessagesConnection>;
};

export type ChatMessagesConnectionUpdated_At = {
  __typename?: 'ChatMessagesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ChatMessagesConnection>;
};

export type ChatMessagesGroupBy = {
  __typename?: 'ChatMessagesGroupBy';
  id?: Maybe<Array<Maybe<ChatMessagesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ChatMessagesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ChatMessagesConnectionUpdated_At>>>;
  body?: Maybe<Array<Maybe<ChatMessagesConnectionBody>>>;
  from_user?: Maybe<Array<Maybe<ChatMessagesConnectionFrom_User>>>;
  chat?: Maybe<Array<Maybe<ChatMessagesConnectionChat>>>;
};

export type ComponentConversationFormFormAgreement = {
  __typename?: 'ComponentConversationFormFormAgreement';
  id: Scalars['ID'];
  client_name?: Maybe<Scalars['String']>;
  client_company?: Maybe<Scalars['String']>;
  client_address?: Maybe<Scalars['String']>;
  client_agree?: Maybe<Scalars['Boolean']>;
  supplier_name?: Maybe<Scalars['String']>;
  supplier_company?: Maybe<Scalars['String']>;
  supplier_address?: Maybe<Scalars['String']>;
  supplier_agree?: Maybe<Scalars['Boolean']>;
  supplier_email?: Maybe<Scalars['String']>;
  client_email?: Maybe<Scalars['String']>;
  uploaded_contracts?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentConversationFormFormAgreementUploaded_ContractsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentConversationFormFormAgreementInput = {
  client_name?: Maybe<Scalars['String']>;
  client_company?: Maybe<Scalars['String']>;
  client_address?: Maybe<Scalars['String']>;
  client_agree?: Maybe<Scalars['Boolean']>;
  supplier_name?: Maybe<Scalars['String']>;
  supplier_company?: Maybe<Scalars['String']>;
  supplier_address?: Maybe<Scalars['String']>;
  supplier_agree?: Maybe<Scalars['Boolean']>;
  supplier_email?: Maybe<Scalars['String']>;
  client_email?: Maybe<Scalars['String']>;
  uploaded_contracts?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentConversationFormFormBusinessUseCase = {
  __typename?: 'ComponentConversationFormFormBusinessUseCase';
  id: Scalars['ID'];
  business_challenge?: Maybe<Scalars['String']>;
  idea?: Maybe<Scalars['String']>;
  objectives?: Maybe<Scalars['String']>;
  corporate_tasks?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  other_solutions?: Maybe<Scalars['String']>;
  successful_outcome?: Maybe<Scalars['String']>;
  risks?: Maybe<Scalars['String']>;
  description_project?: Maybe<Scalars['String']>;
  how_to_resolve?: Maybe<Scalars['String']>;
  technology_solution_models?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<Goals>>>;
};


export type ComponentConversationFormFormBusinessUseCaseGoalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentConversationFormFormBusinessUseCaseInput = {
  business_challenge?: Maybe<Scalars['String']>;
  idea?: Maybe<Scalars['String']>;
  objectives?: Maybe<Scalars['String']>;
  corporate_tasks?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  other_solutions?: Maybe<Scalars['String']>;
  successful_outcome?: Maybe<Scalars['String']>;
  risks?: Maybe<Scalars['String']>;
  description_project?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  how_to_resolve?: Maybe<Scalars['String']>;
  technology_solution_models?: Maybe<Scalars['String']>;
};

export type ComponentConversationFormFormProposal = {
  __typename?: 'ComponentConversationFormFormProposal';
  id: Scalars['ID'];
  price?: Maybe<Scalars['Long']>;
  currency?: Maybe<Scalars['String']>;
  deliverables?: Maybe<Scalars['String']>;
  proposal?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentConversationFormFormProposalProposalArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentConversationFormFormProposalInput = {
  proposal?: Maybe<Array<Maybe<Scalars['ID']>>>;
  price?: Maybe<Scalars['Long']>;
  currency?: Maybe<Scalars['String']>;
  deliverables?: Maybe<Scalars['String']>;
};

export type ComponentConversationFormFormScope = {
  __typename?: 'ComponentConversationFormFormScope';
  id: Scalars['ID'];
  timing_from?: Maybe<Scalars['Date']>;
  timing_to?: Maybe<Scalars['Date']>;
  team_startup?: Maybe<Array<Maybe<ComponentConversationFormFormScopePerson>>>;
  team_corporate?: Maybe<Array<Maybe<ComponentConversationFormFormScopePerson>>>;
  budget_from?: Maybe<Scalars['Long']>;
  budget_to?: Maybe<Scalars['Long']>;
  budget_currency?: Maybe<Scalars['String']>;
  technical_requirements_startup?: Maybe<ComponentConversationFormFormScopeRequirements>;
  technical_requirements_corporate?: Maybe<ComponentConversationFormFormScopeRequirements>;
  legal_requirements_startup?: Maybe<ComponentConversationFormFormScopeRequirements>;
  legal_requirements_corporate?: Maybe<ComponentConversationFormFormScopeRequirements>;
  other_requirements_startup?: Maybe<ComponentConversationFormFormScopeRequirements>;
  other_requirements_corporate?: Maybe<ComponentConversationFormFormScopeRequirements>;
  kpis?: Maybe<Scalars['JSON']>;
};

export type ComponentConversationFormFormScopeInput = {
  timing_from?: Maybe<Scalars['Date']>;
  timing_to?: Maybe<Scalars['Date']>;
  team_startup?: Maybe<Array<Maybe<ComponentConversationFormFormScopePersonInput>>>;
  team_corporate?: Maybe<Array<Maybe<ComponentConversationFormFormScopePersonInput>>>;
  budget_from?: Maybe<Scalars['Long']>;
  budget_to?: Maybe<Scalars['Long']>;
  budget_currency?: Maybe<Scalars['String']>;
  technical_requirements_startup?: Maybe<ComponentConversationFormFormScopeRequirementInput>;
  technical_requirements_corporate?: Maybe<ComponentConversationFormFormScopeRequirementInput>;
  legal_requirements_startup?: Maybe<ComponentConversationFormFormScopeRequirementInput>;
  legal_requirements_corporate?: Maybe<ComponentConversationFormFormScopeRequirementInput>;
  other_requirements_startup?: Maybe<ComponentConversationFormFormScopeRequirementInput>;
  other_requirements_corporate?: Maybe<ComponentConversationFormFormScopeRequirementInput>;
  kpis?: Maybe<Scalars['JSON']>;
};

export type ComponentConversationFormFormScopePerson = {
  __typename?: 'ComponentConversationFormFormScopePerson';
  id: Scalars['ID'];
  role?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<UploadFile>;
};

export type ComponentConversationFormFormScopePersonInput = {
  role?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['ID']>;
};

export type ComponentConversationFormFormScopeRequirementInput = {
  requirement?: Maybe<Scalars['String']>;
  attachment?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentConversationFormFormScopeRequirements = {
  __typename?: 'ComponentConversationFormFormScopeRequirements';
  id: Scalars['ID'];
  requirement?: Maybe<Scalars['String']>;
  attachment?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentConversationFormFormScopeRequirementsAttachmentArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentGenericLinkInput = {
  website?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
};

export type ComponentGenericLinks = {
  __typename?: 'ComponentGenericLinks';
  id: Scalars['ID'];
  website?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
};

export type ComponentPricingTechnologySolutionPricingModel = {
  __typename?: 'ComponentPricingTechnologySolutionPricingModel';
  id: Scalars['ID'];
  pricing_model?: Maybe<PricingModel>;
  min_budget?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type ComponentPricingTechnologySolutionPricingModelInput = {
  pricing_model?: Maybe<Scalars['ID']>;
  min_budget?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type ComponentRegionPricingRegionPriceInput = {
  region?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type ComponentRegionPricingRegionPrices = {
  __typename?: 'ComponentRegionPricingRegionPrices';
  id: Scalars['ID'];
  region?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type ComponentServiceCollaborationDatePeriod = {
  __typename?: 'ComponentServiceCollaborationDatePeriod';
  id: Scalars['ID'];
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
};

export type ComponentServiceCollaborationDatePeriodInput = {
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
};

export type ComponentServiceCollaborationDeliverableInput = {
  proposals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comments?: Maybe<Scalars['String']>;
};

export type ComponentServiceCollaborationDeliverables = {
  __typename?: 'ComponentServiceCollaborationDeliverables';
  id: Scalars['ID'];
  comments?: Maybe<Scalars['String']>;
  proposals?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentServiceCollaborationDeliverablesProposalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentServiceCollaborationFeedback = {
  __typename?: 'ComponentServiceCollaborationFeedback';
  id: Scalars['ID'];
  feedback?: Maybe<Scalars['String']>;
  need_rework?: Maybe<Scalars['Boolean']>;
  rating?: Maybe<Scalars['Float']>;
};

export type ComponentServiceCollaborationFeedbackInput = {
  feedback?: Maybe<Scalars['String']>;
  need_rework?: Maybe<Scalars['Boolean']>;
  rating?: Maybe<Scalars['Float']>;
};

export type ComponentServiceCollaborationMethodology = {
  __typename?: 'ComponentServiceCollaborationMethodology';
  id: Scalars['ID'];
  content?: Maybe<Scalars['String']>;
};

export type ComponentServiceCollaborationMethodologyInput = {
  content?: Maybe<Scalars['String']>;
};

export type ComponentServiceCollaborationPerson = {
  __typename?: 'ComponentServiceCollaborationPerson';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  profile_image?: Maybe<UploadFile>;
  email?: Maybe<Scalars['String']>;
};

export type ComponentServiceCollaborationPersonInput = {
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  profile_image?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
};

export type ComponentServiceCollaborationScope = {
  __typename?: 'ComponentServiceCollaborationScope';
  id: Scalars['ID'];
  client_team?: Maybe<Array<Maybe<ComponentServiceCollaborationPerson>>>;
  alkelio_team?: Maybe<Array<Maybe<ComponentServiceCollaborationPerson>>>;
  project_timing?: Maybe<ComponentServiceCollaborationDatePeriod>;
  info?: Maybe<Array<Maybe<ComponentServiceCollaborationTextWithFiles>>>;
  calender_project?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentServiceCollaborationScopeCalender_ProjectArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentServiceCollaborationScopeInput = {
  client_team?: Maybe<Array<Maybe<ComponentServiceCollaborationPersonInput>>>;
  alkelio_team?: Maybe<Array<Maybe<ComponentServiceCollaborationPersonInput>>>;
  project_timing?: Maybe<ComponentServiceCollaborationDatePeriodInput>;
  calender_project?: Maybe<Array<Maybe<Scalars['ID']>>>;
  info?: Maybe<Array<Maybe<ComponentServiceCollaborationTextWithFileInput>>>;
};

export type ComponentServiceCollaborationStructure = {
  __typename?: 'ComponentServiceCollaborationStructure';
  id: Scalars['ID'];
  content?: Maybe<Scalars['String']>;
};

export type ComponentServiceCollaborationStructureInput = {
  content?: Maybe<Scalars['String']>;
};

export type ComponentServiceCollaborationTeam = {
  __typename?: 'ComponentServiceCollaborationTeam';
  id: Scalars['ID'];
  member?: Maybe<Array<Maybe<ComponentServiceCollaborationPerson>>>;
};

export type ComponentServiceCollaborationTeamInput = {
  member?: Maybe<Array<Maybe<ComponentServiceCollaborationPersonInput>>>;
};

export type ComponentServiceCollaborationTextWithFileInput = {
  response?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  question_from_catalyst?: Maybe<Scalars['String']>;
};

export type ComponentServiceCollaborationTextWithFiles = {
  __typename?: 'ComponentServiceCollaborationTextWithFiles';
  id: Scalars['ID'];
  response?: Maybe<Scalars['String']>;
  question_from_catalyst?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentServiceCollaborationTextWithFilesAttachmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentServicePackageAdHocServiceSelection = {
  __typename?: 'ComponentServicePackageAdHocServiceSelection';
  id: Scalars['ID'];
  adhoc_service_id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type ComponentServicePackageAdHocServiceSelectionInput = {
  adhoc_service_id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type ComponentServicePackageServicePackagePaymentMode = {
  __typename?: 'ComponentServicePackageServicePackagePaymentMode';
  id: Scalars['ID'];
  payment_interval?: Maybe<Enum_Componentservicepackageservicepackagepaymentmode_Payment_Interval>;
  price?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Int']>;
  credit_refresh_interval?: Maybe<Enum_Componentservicepackageservicepackagepaymentmode_Credit_Refresh_Interval>;
};

export type ComponentServicePackageServicePackagePaymentModeInput = {
  payment_interval?: Maybe<Enum_Componentservicepackageservicepackagepaymentmode_Payment_Interval>;
  price?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Int']>;
  credit_refresh_interval?: Maybe<Enum_Componentservicepackageservicepackagepaymentmode_Credit_Refresh_Interval>;
};

export type ComponentTechnologySolutionCaseStudies = {
  __typename?: 'ComponentTechnologySolutionCaseStudies';
  id: Scalars['ID'];
  have_case_studies?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  page_url?: Maybe<Scalars['String']>;
  free_text?: Maybe<Scalars['String']>;
  uploads?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentTechnologySolutionCaseStudiesUploadsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentTechnologySolutionCaseStudyInput = {
  have_case_studies?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  page_url?: Maybe<Scalars['String']>;
  free_text?: Maybe<Scalars['String']>;
  uploads?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentTechnologySolutionInvestInformation = {
  __typename?: 'ComponentTechnologySolutionInvestInformation';
  id: Scalars['ID'];
  amount_to_raise?: Maybe<Scalars['Long']>;
  amount_to_raise_currency?: Maybe<Scalars['String']>;
  documents_business_plans?: Maybe<Array<Maybe<UploadFile>>>;
  documents_investor_pitch_deck?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentTechnologySolutionInvestInformationDocuments_Business_PlansArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ComponentTechnologySolutionInvestInformationDocuments_Investor_Pitch_DeckArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentTechnologySolutionInvestInformationInput = {
  documents_business_plans?: Maybe<Array<Maybe<Scalars['ID']>>>;
  documents_investor_pitch_deck?: Maybe<Array<Maybe<Scalars['ID']>>>;
  amount_to_raise?: Maybe<Scalars['Long']>;
  amount_to_raise_currency?: Maybe<Scalars['String']>;
};

export type ComponentTechnologySolutionProjectBudget = {
  __typename?: 'ComponentTechnologySolutionProjectBudget';
  id: Scalars['ID'];
  budget?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  option?: Maybe<Scalars['String']>;
};

export type ComponentTechnologySolutionProjectBudgetInput = {
  budget?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  option?: Maybe<Scalars['String']>;
};

export type ComponentTechnologySolutionTestimonial = {
  __typename?: 'ComponentTechnologySolutionTestimonial';
  id: Scalars['ID'];
  have_testimonials?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  page_url?: Maybe<Scalars['String']>;
  free_text?: Maybe<Scalars['String']>;
  uploads?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentTechnologySolutionTestimonialUploadsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentTechnologySolutionTestimonialInput = {
  have_testimonials?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  page_url?: Maybe<Scalars['String']>;
  free_text?: Maybe<Scalars['String']>;
  uploads?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ConversationAgreementInput = {
  client_name?: Maybe<Scalars['String']>;
  client_company?: Maybe<Scalars['String']>;
  client_address?: Maybe<Scalars['String']>;
  client_agree?: Maybe<Scalars['Boolean']>;
  client_email?: Maybe<Scalars['String']>;
  supplier_name?: Maybe<Scalars['String']>;
  supplier_company?: Maybe<Scalars['String']>;
  supplier_address?: Maybe<Scalars['String']>;
  supplier_agree?: Maybe<Scalars['Boolean']>;
  supplier_email?: Maybe<Scalars['String']>;
  uploaded_contracts?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ConversationAgreementPdf = {
  __typename?: 'ConversationAgreementPdf';
  fileId: Scalars['ID'];
  url: Scalars['String'];
  name: Scalars['String'];
  mime: Scalars['String'];
};

export type ConversationInput = {
  hashtag?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  conversation_messages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  business_use_case?: Maybe<ComponentConversationFormFormBusinessUseCaseInput>;
  scope?: Maybe<ComponentConversationFormFormScopeInput>;
  proposal?: Maybe<ComponentConversationFormFormProposalInput>;
  agreement?: Maybe<ComponentConversationFormFormAgreementInput>;
  technology_request?: Maybe<Scalars['ID']>;
  technology_solution?: Maybe<Scalars['ID']>;
  current_section?: Maybe<Scalars['String']>;
  nda_signed_startup?: Maybe<Scalars['Boolean']>;
  nda_signed_corporate?: Maybe<Scalars['Boolean']>;
  catalyst_conversation?: Maybe<Scalars['ID']>;
  nda_signed_startup_date?: Maybe<Scalars['DateTime']>;
  nda_signed_corporate_date?: Maybe<Scalars['DateTime']>;
  nda_signed_startup_by?: Maybe<Scalars['String']>;
  nda_signed_corporate_by?: Maybe<Scalars['String']>;
  nda_corporate_upload?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  body?: Maybe<Scalars['String']>;
  sent_datetime?: Maybe<Scalars['DateTime']>;
  conversation?: Maybe<Conversations>;
  by_user?: Maybe<UsersPermissionsUser>;
};

export type ConversationMessageAggregator = {
  __typename?: 'ConversationMessageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ConversationMessageConnection = {
  __typename?: 'ConversationMessageConnection';
  values?: Maybe<Array<Maybe<ConversationMessage>>>;
  groupBy?: Maybe<ConversationMessageGroupBy>;
  aggregate?: Maybe<ConversationMessageAggregator>;
};

export type ConversationMessageConnectionBody = {
  __typename?: 'ConversationMessageConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ConversationMessageConnection>;
};

export type ConversationMessageConnectionBy_User = {
  __typename?: 'ConversationMessageConnectionBy_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationMessageConnection>;
};

export type ConversationMessageConnectionConversation = {
  __typename?: 'ConversationMessageConnectionConversation';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationMessageConnection>;
};

export type ConversationMessageConnectionCreated_At = {
  __typename?: 'ConversationMessageConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ConversationMessageConnection>;
};

export type ConversationMessageConnectionId = {
  __typename?: 'ConversationMessageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationMessageConnection>;
};

export type ConversationMessageConnectionSent_Datetime = {
  __typename?: 'ConversationMessageConnectionSent_datetime';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ConversationMessageConnection>;
};

export type ConversationMessageConnectionUpdated_At = {
  __typename?: 'ConversationMessageConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ConversationMessageConnection>;
};

export type ConversationMessageGroupBy = {
  __typename?: 'ConversationMessageGroupBy';
  id?: Maybe<Array<Maybe<ConversationMessageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ConversationMessageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ConversationMessageConnectionUpdated_At>>>;
  body?: Maybe<Array<Maybe<ConversationMessageConnectionBody>>>;
  sent_datetime?: Maybe<Array<Maybe<ConversationMessageConnectionSent_Datetime>>>;
  conversation?: Maybe<Array<Maybe<ConversationMessageConnectionConversation>>>;
  by_user?: Maybe<Array<Maybe<ConversationMessageConnectionBy_User>>>;
};

export type ConversationMessageInput = {
  body?: Maybe<Scalars['String']>;
  sent_datetime?: Maybe<Scalars['DateTime']>;
  conversation?: Maybe<Scalars['ID']>;
  by_user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ConversationStageComplete = {
  __typename?: 'ConversationStageComplete';
  business_use_case?: Maybe<Scalars['Boolean']>;
  scope?: Maybe<Scalars['Boolean']>;
  proposal?: Maybe<Scalars['Boolean']>;
  agreement?: Maybe<Scalars['Boolean']>;
};

export type ConversationStages = {
  __typename?: 'ConversationStages';
  business_use_case: Scalars['Boolean'];
  scope: Scalars['Boolean'];
  proposal: Scalars['Boolean'];
  agreement: Scalars['Boolean'];
};

export type ConversationStartupCorp = {
  __typename?: 'ConversationStartupCorp';
  conversation_stages_complete: ConversationStages;
  conversation: Conversations;
  startup_profile: StartupProfile;
  corporate_profile: Corporate;
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tech_request_name?: Maybe<Scalars['String']>;
  conversation_stages_complete: ConversationStageComplete;
  nda_signed_by_both: Scalars['Boolean'];
  nda_signed: Scalars['Boolean'];
  nda_corporate_upload?: Maybe<UploadFile>;
  nda_signed_by_startup?: Maybe<Scalars['Boolean']>;
  nda_signed_by_corporate?: Maybe<Scalars['Boolean']>;
};

export type Conversations = {
  __typename?: 'Conversations';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  hashtag?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  business_use_case?: Maybe<ComponentConversationFormFormBusinessUseCase>;
  scope?: Maybe<ComponentConversationFormFormScope>;
  proposal?: Maybe<ComponentConversationFormFormProposal>;
  agreement?: Maybe<ComponentConversationFormFormAgreement>;
  technology_request?: Maybe<TechnologyRequest>;
  technology_solution?: Maybe<TechnologySolution>;
  current_section?: Maybe<Scalars['String']>;
  nda_signed_startup?: Maybe<Scalars['Boolean']>;
  nda_signed_corporate?: Maybe<Scalars['Boolean']>;
  catalyst_conversation?: Maybe<CatalystConversations>;
  nda_signed_startup_date?: Maybe<Scalars['DateTime']>;
  nda_signed_corporate_date?: Maybe<Scalars['DateTime']>;
  nda_signed_startup_by?: Maybe<Scalars['String']>;
  nda_signed_corporate_by?: Maybe<Scalars['String']>;
  nda_corporate_upload?: Maybe<UploadFile>;
  conversation_messages?: Maybe<Array<Maybe<ConversationMessage>>>;
};


export type ConversationsConversation_MessagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ConversationsAggregator = {
  __typename?: 'ConversationsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ConversationsConnection = {
  __typename?: 'ConversationsConnection';
  values?: Maybe<Array<Maybe<Conversations>>>;
  groupBy?: Maybe<ConversationsGroupBy>;
  aggregate?: Maybe<ConversationsAggregator>;
};

export type ConversationsConnectionActive = {
  __typename?: 'ConversationsConnectionActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionAgreement = {
  __typename?: 'ConversationsConnectionAgreement';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionBusiness_Use_Case = {
  __typename?: 'ConversationsConnectionBusiness_use_case';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionCatalyst_Conversation = {
  __typename?: 'ConversationsConnectionCatalyst_conversation';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionCreated_At = {
  __typename?: 'ConversationsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionCurrent_Section = {
  __typename?: 'ConversationsConnectionCurrent_section';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionHashtag = {
  __typename?: 'ConversationsConnectionHashtag';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionId = {
  __typename?: 'ConversationsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionNda_Corporate_Upload = {
  __typename?: 'ConversationsConnectionNda_corporate_upload';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionNda_Signed_Corporate = {
  __typename?: 'ConversationsConnectionNda_signed_corporate';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionNda_Signed_Corporate_By = {
  __typename?: 'ConversationsConnectionNda_signed_corporate_by';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionNda_Signed_Corporate_Date = {
  __typename?: 'ConversationsConnectionNda_signed_corporate_date';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionNda_Signed_Startup = {
  __typename?: 'ConversationsConnectionNda_signed_startup';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionNda_Signed_Startup_By = {
  __typename?: 'ConversationsConnectionNda_signed_startup_by';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionNda_Signed_Startup_Date = {
  __typename?: 'ConversationsConnectionNda_signed_startup_date';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionProposal = {
  __typename?: 'ConversationsConnectionProposal';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionScope = {
  __typename?: 'ConversationsConnectionScope';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionTechnology_Request = {
  __typename?: 'ConversationsConnectionTechnology_request';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionTechnology_Solution = {
  __typename?: 'ConversationsConnectionTechnology_solution';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsConnectionUpdated_At = {
  __typename?: 'ConversationsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ConversationsConnection>;
};

export type ConversationsGroupBy = {
  __typename?: 'ConversationsGroupBy';
  id?: Maybe<Array<Maybe<ConversationsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ConversationsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ConversationsConnectionUpdated_At>>>;
  hashtag?: Maybe<Array<Maybe<ConversationsConnectionHashtag>>>;
  active?: Maybe<Array<Maybe<ConversationsConnectionActive>>>;
  business_use_case?: Maybe<Array<Maybe<ConversationsConnectionBusiness_Use_Case>>>;
  scope?: Maybe<Array<Maybe<ConversationsConnectionScope>>>;
  proposal?: Maybe<Array<Maybe<ConversationsConnectionProposal>>>;
  agreement?: Maybe<Array<Maybe<ConversationsConnectionAgreement>>>;
  technology_request?: Maybe<Array<Maybe<ConversationsConnectionTechnology_Request>>>;
  technology_solution?: Maybe<Array<Maybe<ConversationsConnectionTechnology_Solution>>>;
  current_section?: Maybe<Array<Maybe<ConversationsConnectionCurrent_Section>>>;
  nda_signed_startup?: Maybe<Array<Maybe<ConversationsConnectionNda_Signed_Startup>>>;
  nda_signed_corporate?: Maybe<Array<Maybe<ConversationsConnectionNda_Signed_Corporate>>>;
  catalyst_conversation?: Maybe<Array<Maybe<ConversationsConnectionCatalyst_Conversation>>>;
  nda_signed_startup_date?: Maybe<Array<Maybe<ConversationsConnectionNda_Signed_Startup_Date>>>;
  nda_signed_corporate_date?: Maybe<Array<Maybe<ConversationsConnectionNda_Signed_Corporate_Date>>>;
  nda_signed_startup_by?: Maybe<Array<Maybe<ConversationsConnectionNda_Signed_Startup_By>>>;
  nda_signed_corporate_by?: Maybe<Array<Maybe<ConversationsConnectionNda_Signed_Corporate_By>>>;
  nda_corporate_upload?: Maybe<Array<Maybe<ConversationsConnectionNda_Corporate_Upload>>>;
};

export type Corporate = {
  __typename?: 'Corporate';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  country?: Maybe<Scalars['String']>;
  avatar?: Maybe<UploadFile>;
  psuedo_name?: Maybe<Scalars['String']>;
  country_jurisdiction?: Maybe<Scalars['String']>;
  employee_count_range?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  worked_with_startups?: Maybe<Scalars['Boolean']>;
  links?: Maybe<ComponentGenericLinks>;
  esg_rating?: Maybe<Enum_Corporate_Esg_Rating>;
  person_profiles?: Maybe<Array<Maybe<PersonProfile>>>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  technology_requests?: Maybe<Array<Maybe<TechnologyRequest>>>;
};


export type CorporatePerson_ProfilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CorporateIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CorporateTechnology_RequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CorporateAggregator = {
  __typename?: 'CorporateAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CorporateAggregatorSum>;
  avg?: Maybe<CorporateAggregatorAvg>;
  min?: Maybe<CorporateAggregatorMin>;
  max?: Maybe<CorporateAggregatorMax>;
};

export type CorporateAggregatorAvg = {
  __typename?: 'CorporateAggregatorAvg';
  rating?: Maybe<Scalars['Float']>;
};

export type CorporateAggregatorMax = {
  __typename?: 'CorporateAggregatorMax';
  rating?: Maybe<Scalars['Float']>;
};

export type CorporateAggregatorMin = {
  __typename?: 'CorporateAggregatorMin';
  rating?: Maybe<Scalars['Float']>;
};

export type CorporateAggregatorSum = {
  __typename?: 'CorporateAggregatorSum';
  rating?: Maybe<Scalars['Float']>;
};

export type CorporateConnection = {
  __typename?: 'CorporateConnection';
  values?: Maybe<Array<Maybe<Corporate>>>;
  groupBy?: Maybe<CorporateGroupBy>;
  aggregate?: Maybe<CorporateAggregator>;
};

export type CorporateConnectionAvatar = {
  __typename?: 'CorporateConnectionAvatar';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionCountry = {
  __typename?: 'CorporateConnectionCountry';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionCountry_Jurisdiction = {
  __typename?: 'CorporateConnectionCountry_jurisdiction';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionCreated_At = {
  __typename?: 'CorporateConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionDescription = {
  __typename?: 'CorporateConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionEmployee_Count_Range = {
  __typename?: 'CorporateConnectionEmployee_count_range';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionEsg_Rating = {
  __typename?: 'CorporateConnectionEsg_rating';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionId = {
  __typename?: 'CorporateConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionLinks = {
  __typename?: 'CorporateConnectionLinks';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionLogo = {
  __typename?: 'CorporateConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionName = {
  __typename?: 'CorporateConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionPsuedo_Name = {
  __typename?: 'CorporateConnectionPsuedo_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionRating = {
  __typename?: 'CorporateConnectionRating';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionUpdated_At = {
  __typename?: 'CorporateConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateConnectionWorked_With_Startups = {
  __typename?: 'CorporateConnectionWorked_with_startups';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateConnection>;
};

export type CorporateDepartment = {
  __typename?: 'CorporateDepartment';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type CorporateDepartmentAggregator = {
  __typename?: 'CorporateDepartmentAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CorporateDepartmentConnection = {
  __typename?: 'CorporateDepartmentConnection';
  values?: Maybe<Array<Maybe<CorporateDepartment>>>;
  groupBy?: Maybe<CorporateDepartmentGroupBy>;
  aggregate?: Maybe<CorporateDepartmentAggregator>;
};

export type CorporateDepartmentConnectionCreated_At = {
  __typename?: 'CorporateDepartmentConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CorporateDepartmentConnection>;
};

export type CorporateDepartmentConnectionId = {
  __typename?: 'CorporateDepartmentConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CorporateDepartmentConnection>;
};

export type CorporateDepartmentConnectionName = {
  __typename?: 'CorporateDepartmentConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateDepartmentConnection>;
};

export type CorporateDepartmentConnectionUpdated_At = {
  __typename?: 'CorporateDepartmentConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CorporateDepartmentConnection>;
};

export type CorporateDepartmentGroupBy = {
  __typename?: 'CorporateDepartmentGroupBy';
  id?: Maybe<Array<Maybe<CorporateDepartmentConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CorporateDepartmentConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CorporateDepartmentConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<CorporateDepartmentConnectionName>>>;
};

export type CorporateDepartmentInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CorporateFindOneTechnologySolution = {
  __typename?: 'CorporateFindOneTechnologySolution';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  purpose_poc?: Maybe<Scalars['Boolean']>;
  purpose_sell?: Maybe<Scalars['Boolean']>;
  purpose_lease?: Maybe<Scalars['Boolean']>;
  has_ip?: Maybe<Scalars['Boolean']>;
  is_whitelabel?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  has_api?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  hero_image?: Maybe<UploadFile>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  spin_off_source?: Maybe<Scalars['String']>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  key_features?: Maybe<Scalars['String']>;
  reason_to_sell?: Maybe<Scalars['String']>;
  assets_to_sell?: Maybe<Scalars['String']>;
  is_consumer_data_collected?: Maybe<Scalars['Boolean']>;
  is_tech_transferrable?: Maybe<Scalars['Boolean']>;
  is_others?: Maybe<Scalars['String']>;
  purpose_certify?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['String']>;
  is_published?: Maybe<Scalars['Boolean']>;
  benefits_description?: Maybe<Scalars['String']>;
  purpose_investment?: Maybe<Scalars['Boolean']>;
  technology_readiness?: Maybe<Scalars['String']>;
  use?: Maybe<Scalars['Boolean']>;
  is_consumer_data_collected_remarks?: Maybe<Scalars['String']>;
  is_tech_transferrable_remarks?: Maybe<Scalars['String']>;
  startup_profile?: Maybe<CorporateViewStartupProfile>;
  technology_solution_pricing_model?: Maybe<Array<Maybe<ComponentPricingTechnologySolutionPricingModel>>>;
  purpose_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  purpose_explore?: Maybe<Scalars['Boolean']>;
  testimonial?: Maybe<CorporateViewTestimonial>;
  case_studies?: Maybe<CorporateViewCaseStudies>;
  tested_by_alkelio?: Maybe<Scalars['Boolean']>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  sdg_objectives?: Maybe<Array<Maybe<SdgObjectives>>>;
  technology_types?: Maybe<Array<Maybe<TechnologyType>>>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  business_use_cases?: Maybe<Array<Maybe<BusinessUseCase>>>;
  corporate_departments?: Maybe<Array<Maybe<CorporateDepartment>>>;
  pricing_models?: Maybe<Array<Maybe<PricingModel>>>;
};


export type CorporateFindOneTechnologySolutionTechnology_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CorporateFindOneTechnologySolutionIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CorporateFindOneTechnologySolutionBusiness_Use_CasesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CorporateFindOneTechnologySolutionCorporate_DepartmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CorporateFindOneTechnologySolutionPricing_ModelsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CorporateGroupBy = {
  __typename?: 'CorporateGroupBy';
  id?: Maybe<Array<Maybe<CorporateConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CorporateConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CorporateConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<CorporateConnectionName>>>;
  description?: Maybe<Array<Maybe<CorporateConnectionDescription>>>;
  logo?: Maybe<Array<Maybe<CorporateConnectionLogo>>>;
  country?: Maybe<Array<Maybe<CorporateConnectionCountry>>>;
  avatar?: Maybe<Array<Maybe<CorporateConnectionAvatar>>>;
  psuedo_name?: Maybe<Array<Maybe<CorporateConnectionPsuedo_Name>>>;
  country_jurisdiction?: Maybe<Array<Maybe<CorporateConnectionCountry_Jurisdiction>>>;
  employee_count_range?: Maybe<Array<Maybe<CorporateConnectionEmployee_Count_Range>>>;
  rating?: Maybe<Array<Maybe<CorporateConnectionRating>>>;
  worked_with_startups?: Maybe<Array<Maybe<CorporateConnectionWorked_With_Startups>>>;
  links?: Maybe<Array<Maybe<CorporateConnectionLinks>>>;
  esg_rating?: Maybe<Array<Maybe<CorporateConnectionEsg_Rating>>>;
};

export type CorporateInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  person_profiles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  country?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  avatar?: Maybe<Scalars['ID']>;
  psuedo_name?: Maybe<Scalars['String']>;
  country_jurisdiction?: Maybe<Scalars['String']>;
  employee_count_range?: Maybe<Scalars['String']>;
  technology_requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rating?: Maybe<Scalars['Float']>;
  worked_with_startups?: Maybe<Scalars['Boolean']>;
  links?: Maybe<ComponentGenericLinkInput>;
  esg_rating?: Maybe<Enum_Corporate_Esg_Rating>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CorporateViewCaseStudies = {
  __typename?: 'CorporateViewCaseStudies';
  have_case_studies?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type CorporateViewStartupProfile = {
  __typename?: 'CorporateViewStartupProfile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  start_date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  avatar?: Maybe<UploadFile>;
  psuedo_name?: Maybe<Scalars['String']>;
  operating_locations?: Maybe<Scalars['String']>;
  employee_count?: Maybe<Scalars['Int']>;
  worked_with_corporates?: Maybe<Scalars['Boolean']>;
  clients?: Maybe<Scalars['String']>;
  incubators_accelerators?: Maybe<Scalars['String']>;
  investment_received?: Maybe<Scalars['Long']>;
  maturity_level?: Maybe<MaturityLevel>;
  client_count?: Maybe<Scalars['Int']>;
  employee_count_range?: Maybe<Scalars['String']>;
  went_incubator_accelerator?: Maybe<Scalars['Boolean']>;
  investment_received_currency?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  esg_rating?: Maybe<Scalars['String']>;
};


export type CorporateViewStartupProfileIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CorporateViewTestimonial = {
  __typename?: 'CorporateViewTestimonial';
  have_testimonials?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type CountTechSolutionMatches = {
  __typename?: 'CountTechSolutionMatches';
  count?: Maybe<Scalars['Int']>;
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  full_name?: Maybe<Scalars['String']>;
  iso_code?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type CountryAggregator = {
  __typename?: 'CountryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  values?: Maybe<Array<Maybe<Country>>>;
  groupBy?: Maybe<CountryGroupBy>;
  aggregate?: Maybe<CountryAggregator>;
};

export type CountryConnectionCreated_At = {
  __typename?: 'CountryConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionFull_Name = {
  __typename?: 'CountryConnectionFull_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionId = {
  __typename?: 'CountryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionIso_Code = {
  __typename?: 'CountryConnectionIso_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionPublished_At = {
  __typename?: 'CountryConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionUpdated_At = {
  __typename?: 'CountryConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryGroupBy = {
  __typename?: 'CountryGroupBy';
  id?: Maybe<Array<Maybe<CountryConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CountryConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CountryConnectionUpdated_At>>>;
  full_name?: Maybe<Array<Maybe<CountryConnectionFull_Name>>>;
  iso_code?: Maybe<Array<Maybe<CountryConnectionIso_Code>>>;
  published_at?: Maybe<Array<Maybe<CountryConnectionPublished_At>>>;
};

export type CountryInput = {
  full_name?: Maybe<Scalars['String']>;
  iso_code?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreatePaymentIntent = {
  items: Array<Maybe<PaymentItem>>;
  currency: Scalars['String'];
  method: Scalars['String'];
};

export type CreatePaymentIntentPayload = {
  __typename?: 'CreatePaymentIntentPayload';
  method: Scalars['String'];
  client_secret?: Maybe<Scalars['String']>;
};

export type CreditInput = {
  value?: Maybe<Scalars['Int']>;
  date_start?: Maybe<Scalars['DateTime']>;
  date_expire?: Maybe<Scalars['DateTime']>;
  uid?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Credits = {
  __typename?: 'Credits';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  value?: Maybe<Scalars['Int']>;
  date_start?: Maybe<Scalars['DateTime']>;
  date_expire?: Maybe<Scalars['DateTime']>;
  uid?: Maybe<Scalars['String']>;
};

export type CreditsAggregator = {
  __typename?: 'CreditsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CreditsAggregatorSum>;
  avg?: Maybe<CreditsAggregatorAvg>;
  min?: Maybe<CreditsAggregatorMin>;
  max?: Maybe<CreditsAggregatorMax>;
};

export type CreditsAggregatorAvg = {
  __typename?: 'CreditsAggregatorAvg';
  value?: Maybe<Scalars['Float']>;
};

export type CreditsAggregatorMax = {
  __typename?: 'CreditsAggregatorMax';
  value?: Maybe<Scalars['Float']>;
};

export type CreditsAggregatorMin = {
  __typename?: 'CreditsAggregatorMin';
  value?: Maybe<Scalars['Float']>;
};

export type CreditsAggregatorSum = {
  __typename?: 'CreditsAggregatorSum';
  value?: Maybe<Scalars['Float']>;
};

export type CreditsConnection = {
  __typename?: 'CreditsConnection';
  values?: Maybe<Array<Maybe<Credits>>>;
  groupBy?: Maybe<CreditsGroupBy>;
  aggregate?: Maybe<CreditsAggregator>;
};

export type CreditsConnectionCreated_At = {
  __typename?: 'CreditsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CreditsConnection>;
};

export type CreditsConnectionDate_Expire = {
  __typename?: 'CreditsConnectionDate_expire';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CreditsConnection>;
};

export type CreditsConnectionDate_Start = {
  __typename?: 'CreditsConnectionDate_start';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CreditsConnection>;
};

export type CreditsConnectionId = {
  __typename?: 'CreditsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CreditsConnection>;
};

export type CreditsConnectionUid = {
  __typename?: 'CreditsConnectionUid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CreditsConnection>;
};

export type CreditsConnectionUpdated_At = {
  __typename?: 'CreditsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CreditsConnection>;
};

export type CreditsConnectionValue = {
  __typename?: 'CreditsConnectionValue';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CreditsConnection>;
};

export type CreditsGroupBy = {
  __typename?: 'CreditsGroupBy';
  id?: Maybe<Array<Maybe<CreditsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CreditsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CreditsConnectionUpdated_At>>>;
  value?: Maybe<Array<Maybe<CreditsConnectionValue>>>;
  date_start?: Maybe<Array<Maybe<CreditsConnectionDate_Start>>>;
  date_expire?: Maybe<Array<Maybe<CreditsConnectionDate_Expire>>>;
  uid?: Maybe<Array<Maybe<CreditsConnectionUid>>>;
};



export type DeductCreditPayload = {
  __typename?: 'DeductCreditPayload';
  balance: Scalars['Int'];
  success: Scalars['Boolean'];
  conversationId?: Maybe<Scalars['ID']>;
};

export type DeductCreditStartConversationInput = {
  fromType: Scalars['String'];
  techSolutionId: Scalars['ID'];
  techRequestId: Scalars['ID'];
};

export type DocumentSharing = {
  __typename?: 'DocumentSharing';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  document?: Maybe<UploadFile>;
  title?: Maybe<Scalars['String']>;
  users_permissions_users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type DocumentSharingUsers_Permissions_UsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type DocumentSharingAggregator = {
  __typename?: 'DocumentSharingAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DocumentSharingConnection = {
  __typename?: 'DocumentSharingConnection';
  values?: Maybe<Array<Maybe<DocumentSharing>>>;
  groupBy?: Maybe<DocumentSharingGroupBy>;
  aggregate?: Maybe<DocumentSharingAggregator>;
};

export type DocumentSharingConnectionCreated_At = {
  __typename?: 'DocumentSharingConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DocumentSharingConnection>;
};

export type DocumentSharingConnectionDocument = {
  __typename?: 'DocumentSharingConnectionDocument';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DocumentSharingConnection>;
};

export type DocumentSharingConnectionId = {
  __typename?: 'DocumentSharingConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DocumentSharingConnection>;
};

export type DocumentSharingConnectionTitle = {
  __typename?: 'DocumentSharingConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DocumentSharingConnection>;
};

export type DocumentSharingConnectionUpdated_At = {
  __typename?: 'DocumentSharingConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DocumentSharingConnection>;
};

export type DocumentSharingGroupBy = {
  __typename?: 'DocumentSharingGroupBy';
  id?: Maybe<Array<Maybe<DocumentSharingConnectionId>>>;
  created_at?: Maybe<Array<Maybe<DocumentSharingConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<DocumentSharingConnectionUpdated_At>>>;
  document?: Maybe<Array<Maybe<DocumentSharingConnectionDocument>>>;
  title?: Maybe<Array<Maybe<DocumentSharingConnectionTitle>>>;
};

export type DocumentSharingInput = {
  document?: Maybe<Scalars['ID']>;
  users_permissions_users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  title?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum Enum_Bookmark_Category {
  Save = 'save',
  Reject = 'reject'
}

export enum Enum_Bookmark_Type {
  TechnologySolution = 'technology_solution',
  TechnologySolutionMatch = 'technology_solution_match',
  TechnologyRequest = 'technology_request',
  TechnologyRequestMatch = 'technology_request_match'
}

export enum Enum_Chat_Category {
  ServiceCollaboration = 'service_collaboration',
  Conversation = 'conversation'
}

export enum Enum_Componentservicepackageservicepackagepaymentmode_Credit_Refresh_Interval {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Onetime = 'ONETIME'
}

export enum Enum_Componentservicepackageservicepackagepaymentmode_Payment_Interval {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Onetime = 'ONETIME'
}

export enum Enum_Corporate_Esg_Rating {
  Aaa = 'AAA',
  Aa = 'AA',
  A = 'A',
  Bbb = 'BBB',
  Bb = 'BB',
  B = 'B',
  Ccc = 'CCC'
}

export enum Enum_Personprofile_Profile_Type {
  Corporate = 'CORPORATE',
  Startup = 'STARTUP',
  Catalyst = 'CATALYST'
}

export enum Enum_Rating_Article_Type {
  TechnologySolution = 'technology_solution',
  CorporateProfile = 'corporate_profile',
  StartupProfile = 'startup_profile'
}

export enum Enum_Servicepackage_Role_Type {
  Startup = 'STARTUP',
  Corporate = 'CORPORATE'
}

export enum Enum_Services_Role {
  Startup = 'STARTUP',
  Corporate = 'CORPORATE'
}

export enum Enum_Startupprofile_Esg_Rating {
  Aaa = 'AAA',
  Aa = 'AA',
  A = 'A',
  Bbb = 'BBB',
  Bb = 'BB',
  B = 'B',
  Ccc = 'CCC'
}

export enum Enum_Transactions_Status {
  Created = 'CREATED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED'
}

export enum Enum_Transactions_Type {
  Payment = 'PAYMENT',
  Credit = 'CREDIT',
  Service = 'SERVICE'
}

export type Enquiries = {
  __typename?: 'Enquiries';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type EnquiriesAggregator = {
  __typename?: 'EnquiriesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EnquiriesConnection = {
  __typename?: 'EnquiriesConnection';
  values?: Maybe<Array<Maybe<Enquiries>>>;
  groupBy?: Maybe<EnquiriesGroupBy>;
  aggregate?: Maybe<EnquiriesAggregator>;
};

export type EnquiriesConnectionCreated_At = {
  __typename?: 'EnquiriesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EnquiriesConnection>;
};

export type EnquiriesConnectionEmail = {
  __typename?: 'EnquiriesConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnquiriesConnection>;
};

export type EnquiriesConnectionFirst_Name = {
  __typename?: 'EnquiriesConnectionFirst_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnquiriesConnection>;
};

export type EnquiriesConnectionId = {
  __typename?: 'EnquiriesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EnquiriesConnection>;
};

export type EnquiriesConnectionLast_Name = {
  __typename?: 'EnquiriesConnectionLast_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnquiriesConnection>;
};

export type EnquiriesConnectionMessage = {
  __typename?: 'EnquiriesConnectionMessage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EnquiriesConnection>;
};

export type EnquiriesConnectionUpdated_At = {
  __typename?: 'EnquiriesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EnquiriesConnection>;
};

export type EnquiriesGroupBy = {
  __typename?: 'EnquiriesGroupBy';
  id?: Maybe<Array<Maybe<EnquiriesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<EnquiriesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<EnquiriesConnectionUpdated_At>>>;
  first_name?: Maybe<Array<Maybe<EnquiriesConnectionFirst_Name>>>;
  last_name?: Maybe<Array<Maybe<EnquiriesConnectionLast_Name>>>;
  email?: Maybe<Array<Maybe<EnquiriesConnectionEmail>>>;
  message?: Maybe<Array<Maybe<EnquiriesConnectionMessage>>>;
};

export type EnquiryInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EvalMatchMakeResultInput = {
  technologyRequestId: Scalars['ID'];
  technologySolutionId: Scalars['ID'];
};

export type EvalMatchResult = {
  __typename?: 'EvalMatchResult';
  technology_request?: Maybe<TechnologyRequest>;
  technology_solution?: Maybe<TechnologySolution>;
  technology_types?: Maybe<Array<Scalars['ID']>>;
  industries?: Maybe<Array<Scalars['ID']>>;
  corporate_departments?: Maybe<Array<Scalars['ID']>>;
  business_use_cases?: Maybe<Array<Scalars['ID']>>;
  sdg_objectives?: Maybe<Array<Scalars['ID']>>;
  match_purpose_poc?: Maybe<Scalars['Boolean']>;
  match_purpose_sell?: Maybe<Scalars['Boolean']>;
  match_purpose_lease?: Maybe<Scalars['Boolean']>;
  match_has_ip?: Maybe<Scalars['Boolean']>;
  match_can_whitelabel?: Maybe<Scalars['Boolean']>;
  match_has_api?: Maybe<Scalars['Boolean']>;
  match_is_plugandplay?: Maybe<Scalars['Boolean']>;
  match_is_gdpr?: Maybe<Scalars['Boolean']>;
  match_is_cloud?: Maybe<Scalars['Boolean']>;
  match_sdg_driven?: Maybe<Scalars['Boolean']>;
  match_rating_from_tech_req?: Maybe<Scalars['Float']>;
  match_rating_from_tech_solution?: Maybe<Scalars['Float']>;
  total_criteria_count_from_tech_req?: Maybe<Scalars['Int']>;
  total_criteria_count_from_tech_solution?: Maybe<Scalars['Int']>;
  matched_criteria_count?: Maybe<Scalars['Int']>;
  compound_key?: Maybe<Scalars['String']>;
};

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type FindMatchMakingResultWithRolePayload = {
  __typename?: 'FindMatchMakingResultWithRolePayload';
  id: Scalars['ID'];
  is_saved?: Maybe<Scalars['Boolean']>;
  is_rejected?: Maybe<Scalars['Boolean']>;
  technology_request?: Maybe<TechnologyRequest>;
  technology_solution?: Maybe<TechnologySolution>;
  technology_types?: Maybe<Array<Scalars['ID']>>;
  industries?: Maybe<Array<Scalars['ID']>>;
  corporate_departments?: Maybe<Array<Scalars['ID']>>;
  business_use_cases?: Maybe<Array<Scalars['ID']>>;
  sdg_objectives?: Maybe<Array<Scalars['ID']>>;
  match_purpose_poc?: Maybe<Scalars['Boolean']>;
  match_purpose_sell?: Maybe<Scalars['Boolean']>;
  match_purpose_lease?: Maybe<Scalars['Boolean']>;
  match_has_ip?: Maybe<Scalars['Boolean']>;
  match_can_whitelabel?: Maybe<Scalars['Boolean']>;
  match_has_api?: Maybe<Scalars['Boolean']>;
  match_is_plugandplay?: Maybe<Scalars['Boolean']>;
  match_is_gdpr?: Maybe<Scalars['Boolean']>;
  match_is_cloud?: Maybe<Scalars['Boolean']>;
  match_sdg_driven?: Maybe<Scalars['Boolean']>;
  match_rating?: Maybe<Scalars['Float']>;
  compound_key?: Maybe<Scalars['String']>;
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  uuid?: Maybe<Scalars['String']>;
};

export type GetChatMessagesPayload = {
  __typename?: 'GetChatMessagesPayload';
  totalMessages: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  size: Scalars['Int'];
  messages?: Maybe<Array<Maybe<ChatMessages>>>;
};

export type GetOrCreateChatMessagesWithCategoryInput = {
  category: Enum_Chat_Category;
  referenceId: Scalars['ID'];
  page: Scalars['Int'];
  size: Scalars['Int'];
};

export type GetServicesPayload = {
  __typename?: 'GetServicesPayload';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  price?: Maybe<Scalars['Float']>;
};

export type GoalInput = {
  Name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Goals = {
  __typename?: 'Goals';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Name?: Maybe<Scalars['String']>;
};

export type GoalsAggregator = {
  __typename?: 'GoalsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GoalsConnection = {
  __typename?: 'GoalsConnection';
  values?: Maybe<Array<Maybe<Goals>>>;
  groupBy?: Maybe<GoalsGroupBy>;
  aggregate?: Maybe<GoalsAggregator>;
};

export type GoalsConnectionCreated_At = {
  __typename?: 'GoalsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GoalsConnection>;
};

export type GoalsConnectionId = {
  __typename?: 'GoalsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<GoalsConnection>;
};

export type GoalsConnectionName = {
  __typename?: 'GoalsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GoalsConnection>;
};

export type GoalsConnectionUpdated_At = {
  __typename?: 'GoalsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GoalsConnection>;
};

export type GoalsGroupBy = {
  __typename?: 'GoalsGroupBy';
  id?: Maybe<Array<Maybe<GoalsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<GoalsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<GoalsConnectionUpdated_At>>>;
  Name?: Maybe<Array<Maybe<GoalsConnectionName>>>;
};

export type ImageAttachment = {
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ImpactArea = {
  __typename?: 'ImpactArea';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type ImpactAreaAggregator = {
  __typename?: 'ImpactAreaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ImpactAreaConnection = {
  __typename?: 'ImpactAreaConnection';
  values?: Maybe<Array<Maybe<ImpactArea>>>;
  groupBy?: Maybe<ImpactAreaGroupBy>;
  aggregate?: Maybe<ImpactAreaAggregator>;
};

export type ImpactAreaConnectionCreated_At = {
  __typename?: 'ImpactAreaConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ImpactAreaConnection>;
};

export type ImpactAreaConnectionId = {
  __typename?: 'ImpactAreaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ImpactAreaConnection>;
};

export type ImpactAreaConnectionName = {
  __typename?: 'ImpactAreaConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ImpactAreaConnection>;
};

export type ImpactAreaConnectionUpdated_At = {
  __typename?: 'ImpactAreaConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ImpactAreaConnection>;
};

export type ImpactAreaGroupBy = {
  __typename?: 'ImpactAreaGroupBy';
  id?: Maybe<Array<Maybe<ImpactAreaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ImpactAreaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ImpactAreaConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<ImpactAreaConnectionName>>>;
};

export type ImpactAreaInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Industry = {
  __typename?: 'Industry';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type IndustryAggregator = {
  __typename?: 'IndustryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type IndustryConnection = {
  __typename?: 'IndustryConnection';
  values?: Maybe<Array<Maybe<Industry>>>;
  groupBy?: Maybe<IndustryGroupBy>;
  aggregate?: Maybe<IndustryAggregator>;
};

export type IndustryConnectionCreated_At = {
  __typename?: 'IndustryConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<IndustryConnection>;
};

export type IndustryConnectionId = {
  __typename?: 'IndustryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<IndustryConnection>;
};

export type IndustryConnectionName = {
  __typename?: 'IndustryConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<IndustryConnection>;
};

export type IndustryConnectionUpdated_At = {
  __typename?: 'IndustryConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<IndustryConnection>;
};

export type IndustryGroupBy = {
  __typename?: 'IndustryGroupBy';
  id?: Maybe<Array<Maybe<IndustryConnectionId>>>;
  created_at?: Maybe<Array<Maybe<IndustryConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<IndustryConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<IndustryConnectionName>>>;
};

export type IndustryInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type InputId = {
  id: Scalars['ID'];
};


export type JobPosting = {
  __typename?: 'JobPosting';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  job_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type JobPostingAggregator = {
  __typename?: 'JobPostingAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type JobPostingConnection = {
  __typename?: 'JobPostingConnection';
  values?: Maybe<Array<Maybe<JobPosting>>>;
  groupBy?: Maybe<JobPostingGroupBy>;
  aggregate?: Maybe<JobPostingAggregator>;
};

export type JobPostingConnectionCreated_At = {
  __typename?: 'JobPostingConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<JobPostingConnection>;
};

export type JobPostingConnectionDescription = {
  __typename?: 'JobPostingConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<JobPostingConnection>;
};

export type JobPostingConnectionId = {
  __typename?: 'JobPostingConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<JobPostingConnection>;
};

export type JobPostingConnectionJob_Title = {
  __typename?: 'JobPostingConnectionJob_title';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<JobPostingConnection>;
};

export type JobPostingConnectionPublished_At = {
  __typename?: 'JobPostingConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<JobPostingConnection>;
};

export type JobPostingConnectionUpdated_At = {
  __typename?: 'JobPostingConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<JobPostingConnection>;
};

export type JobPostingGroupBy = {
  __typename?: 'JobPostingGroupBy';
  id?: Maybe<Array<Maybe<JobPostingConnectionId>>>;
  created_at?: Maybe<Array<Maybe<JobPostingConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<JobPostingConnectionUpdated_At>>>;
  job_title?: Maybe<Array<Maybe<JobPostingConnectionJob_Title>>>;
  description?: Maybe<Array<Maybe<JobPostingConnectionDescription>>>;
  published_at?: Maybe<Array<Maybe<JobPostingConnectionPublished_At>>>;
};

export type JobPostingInput = {
  job_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type MatchItemSummary = {
  __typename?: 'MatchItemSummary';
  id: Scalars['ID'];
  is_saved?: Maybe<Scalars['Boolean']>;
  is_rejectd?: Maybe<Scalars['Boolean']>;
  technology_request?: Maybe<TechnologyRequest>;
  technology_solution?: Maybe<TechnologySolution>;
  match_purpose_poc?: Maybe<Scalars['Boolean']>;
  match_purpose_sell?: Maybe<Scalars['Boolean']>;
  match_purpose_lease?: Maybe<Scalars['Boolean']>;
  match_has_ip?: Maybe<Scalars['Boolean']>;
  match_can_whitelabel?: Maybe<Scalars['Boolean']>;
  match_has_api?: Maybe<Scalars['Boolean']>;
  match_is_plugandplay?: Maybe<Scalars['Boolean']>;
  match_is_gdpr?: Maybe<Scalars['Boolean']>;
  match_is_cloud?: Maybe<Scalars['Boolean']>;
  match_sdg_driven?: Maybe<Scalars['Boolean']>;
  match_rating?: Maybe<Scalars['Float']>;
};

export type MatchMakingResult = {
  __typename?: 'MatchMakingResult';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  is_saved?: Maybe<Scalars['Boolean']>;
  is_rejected?: Maybe<Scalars['Boolean']>;
  match_purpose_poc?: Maybe<Scalars['Boolean']>;
  match_purpose_sell?: Maybe<Scalars['Boolean']>;
  match_purpose_lease?: Maybe<Scalars['Boolean']>;
  match_has_ip?: Maybe<Scalars['Boolean']>;
  match_can_whitelabel?: Maybe<Scalars['Boolean']>;
  match_has_api?: Maybe<Scalars['Boolean']>;
  match_is_plugandplay?: Maybe<Scalars['Boolean']>;
  match_is_gdpr?: Maybe<Scalars['Boolean']>;
  match_is_cloud?: Maybe<Scalars['Boolean']>;
  is_manual_match?: Maybe<Scalars['Boolean']>;
  technology_request?: Maybe<TechnologyRequest>;
  technology_solution?: Maybe<TechnologySolution>;
  match_rating_from_tech_req?: Maybe<Scalars['Float']>;
  match_rating_from_tech_solution?: Maybe<Scalars['Float']>;
  match_sdg_driven?: Maybe<Scalars['Boolean']>;
  technology_types?: Maybe<Array<Maybe<TechnologyType>>>;
  business_use_cases?: Maybe<Array<Maybe<BusinessUseCase>>>;
  corporate_departments?: Maybe<Array<Maybe<CorporateDepartment>>>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  sdg_objectives?: Maybe<Array<Maybe<SdgObjectives>>>;
};


export type MatchMakingResultTechnology_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MatchMakingResultBusiness_Use_CasesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MatchMakingResultCorporate_DepartmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MatchMakingResultIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MatchMakingResultSdg_ObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type MatchMakingResultAggregator = {
  __typename?: 'MatchMakingResultAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<MatchMakingResultAggregatorSum>;
  avg?: Maybe<MatchMakingResultAggregatorAvg>;
  min?: Maybe<MatchMakingResultAggregatorMin>;
  max?: Maybe<MatchMakingResultAggregatorMax>;
};

export type MatchMakingResultAggregatorAvg = {
  __typename?: 'MatchMakingResultAggregatorAvg';
  match_rating_from_tech_req?: Maybe<Scalars['Float']>;
  match_rating_from_tech_solution?: Maybe<Scalars['Float']>;
};

export type MatchMakingResultAggregatorMax = {
  __typename?: 'MatchMakingResultAggregatorMax';
  match_rating_from_tech_req?: Maybe<Scalars['Float']>;
  match_rating_from_tech_solution?: Maybe<Scalars['Float']>;
};

export type MatchMakingResultAggregatorMin = {
  __typename?: 'MatchMakingResultAggregatorMin';
  match_rating_from_tech_req?: Maybe<Scalars['Float']>;
  match_rating_from_tech_solution?: Maybe<Scalars['Float']>;
};

export type MatchMakingResultAggregatorSum = {
  __typename?: 'MatchMakingResultAggregatorSum';
  match_rating_from_tech_req?: Maybe<Scalars['Float']>;
  match_rating_from_tech_solution?: Maybe<Scalars['Float']>;
};

export type MatchMakingResultConnection = {
  __typename?: 'MatchMakingResultConnection';
  values?: Maybe<Array<Maybe<MatchMakingResult>>>;
  groupBy?: Maybe<MatchMakingResultGroupBy>;
  aggregate?: Maybe<MatchMakingResultAggregator>;
};

export type MatchMakingResultConnectionCreated_At = {
  __typename?: 'MatchMakingResultConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionId = {
  __typename?: 'MatchMakingResultConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionIs_Manual_Match = {
  __typename?: 'MatchMakingResultConnectionIs_manual_match';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionIs_Rejected = {
  __typename?: 'MatchMakingResultConnectionIs_rejected';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionIs_Saved = {
  __typename?: 'MatchMakingResultConnectionIs_saved';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Can_Whitelabel = {
  __typename?: 'MatchMakingResultConnectionMatch_can_whitelabel';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Has_Api = {
  __typename?: 'MatchMakingResultConnectionMatch_has_api';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Has_Ip = {
  __typename?: 'MatchMakingResultConnectionMatch_has_ip';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Is_Cloud = {
  __typename?: 'MatchMakingResultConnectionMatch_is_cloud';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Is_Gdpr = {
  __typename?: 'MatchMakingResultConnectionMatch_is_gdpr';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Is_Plugandplay = {
  __typename?: 'MatchMakingResultConnectionMatch_is_plugandplay';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Purpose_Lease = {
  __typename?: 'MatchMakingResultConnectionMatch_purpose_lease';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Purpose_Poc = {
  __typename?: 'MatchMakingResultConnectionMatch_purpose_poc';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Purpose_Sell = {
  __typename?: 'MatchMakingResultConnectionMatch_purpose_sell';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Rating_From_Tech_Req = {
  __typename?: 'MatchMakingResultConnectionMatch_rating_from_tech_req';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Rating_From_Tech_Solution = {
  __typename?: 'MatchMakingResultConnectionMatch_rating_from_tech_solution';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionMatch_Sdg_Driven = {
  __typename?: 'MatchMakingResultConnectionMatch_sdg_driven';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionTechnology_Request = {
  __typename?: 'MatchMakingResultConnectionTechnology_request';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionTechnology_Solution = {
  __typename?: 'MatchMakingResultConnectionTechnology_solution';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultConnectionUpdated_At = {
  __typename?: 'MatchMakingResultConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MatchMakingResultConnection>;
};

export type MatchMakingResultGroupBy = {
  __typename?: 'MatchMakingResultGroupBy';
  id?: Maybe<Array<Maybe<MatchMakingResultConnectionId>>>;
  created_at?: Maybe<Array<Maybe<MatchMakingResultConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<MatchMakingResultConnectionUpdated_At>>>;
  is_saved?: Maybe<Array<Maybe<MatchMakingResultConnectionIs_Saved>>>;
  is_rejected?: Maybe<Array<Maybe<MatchMakingResultConnectionIs_Rejected>>>;
  match_purpose_poc?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Purpose_Poc>>>;
  match_purpose_sell?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Purpose_Sell>>>;
  match_purpose_lease?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Purpose_Lease>>>;
  match_has_ip?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Has_Ip>>>;
  match_can_whitelabel?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Can_Whitelabel>>>;
  match_has_api?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Has_Api>>>;
  match_is_plugandplay?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Is_Plugandplay>>>;
  match_is_gdpr?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Is_Gdpr>>>;
  match_is_cloud?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Is_Cloud>>>;
  is_manual_match?: Maybe<Array<Maybe<MatchMakingResultConnectionIs_Manual_Match>>>;
  technology_request?: Maybe<Array<Maybe<MatchMakingResultConnectionTechnology_Request>>>;
  technology_solution?: Maybe<Array<Maybe<MatchMakingResultConnectionTechnology_Solution>>>;
  match_rating_from_tech_req?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Rating_From_Tech_Req>>>;
  match_rating_from_tech_solution?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Rating_From_Tech_Solution>>>;
  match_sdg_driven?: Maybe<Array<Maybe<MatchMakingResultConnectionMatch_Sdg_Driven>>>;
};

export type MatchMakingResultInput = {
  is_saved?: Maybe<Scalars['Boolean']>;
  is_rejected?: Maybe<Scalars['Boolean']>;
  technology_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  business_use_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  corporate_departments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  match_purpose_poc?: Maybe<Scalars['Boolean']>;
  match_purpose_sell?: Maybe<Scalars['Boolean']>;
  match_purpose_lease?: Maybe<Scalars['Boolean']>;
  match_has_ip?: Maybe<Scalars['Boolean']>;
  match_can_whitelabel?: Maybe<Scalars['Boolean']>;
  match_has_api?: Maybe<Scalars['Boolean']>;
  match_is_plugandplay?: Maybe<Scalars['Boolean']>;
  match_is_gdpr?: Maybe<Scalars['Boolean']>;
  match_is_cloud?: Maybe<Scalars['Boolean']>;
  compound_key: Scalars['String'];
  is_manual_match?: Maybe<Scalars['Boolean']>;
  technology_request?: Maybe<Scalars['ID']>;
  technology_solution?: Maybe<Scalars['ID']>;
  match_rating_from_tech_req?: Maybe<Scalars['Float']>;
  match_rating_from_tech_solution?: Maybe<Scalars['Float']>;
  match_sdg_driven?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type MatchPayload = {
  __typename?: 'MatchPayload';
  jobId?: Maybe<Scalars['String']>;
  results?: Maybe<MatchResults>;
  messages?: Maybe<Scalars['String']>;
};

export type MatchResults = {
  __typename?: 'MatchResults';
  matches?: Maybe<Array<Maybe<MatchItemSummary>>>;
};

export type MatchesCsv = {
  __typename?: 'MatchesCSV';
  fileId: Scalars['ID'];
  url: Scalars['String'];
  name: Scalars['String'];
  mime: Scalars['String'];
};

export type MaturityLevel = {
  __typename?: 'MaturityLevel';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type MaturityLevelAggregator = {
  __typename?: 'MaturityLevelAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MaturityLevelConnection = {
  __typename?: 'MaturityLevelConnection';
  values?: Maybe<Array<Maybe<MaturityLevel>>>;
  groupBy?: Maybe<MaturityLevelGroupBy>;
  aggregate?: Maybe<MaturityLevelAggregator>;
};

export type MaturityLevelConnectionCreated_At = {
  __typename?: 'MaturityLevelConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MaturityLevelConnection>;
};

export type MaturityLevelConnectionId = {
  __typename?: 'MaturityLevelConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MaturityLevelConnection>;
};

export type MaturityLevelConnectionName = {
  __typename?: 'MaturityLevelConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MaturityLevelConnection>;
};

export type MaturityLevelConnectionUpdated_At = {
  __typename?: 'MaturityLevelConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MaturityLevelConnection>;
};

export type MaturityLevelGroupBy = {
  __typename?: 'MaturityLevelGroupBy';
  id?: Maybe<Array<Maybe<MaturityLevelConnectionId>>>;
  created_at?: Maybe<Array<Maybe<MaturityLevelConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<MaturityLevelConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<MaturityLevelConnectionName>>>;
};

export type MaturityLevelInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Message = {
  __typename?: 'Message';
  id: Scalars['ID'];
  subject: Scalars['String'];
  content: Scalars['String'];
  readStatus: Scalars['Boolean'];
  createdOn: Scalars['String'];
};

export type MessageAuthor = {
  __typename?: 'MessageAuthor';
  name: Scalars['String'];
  profileImage: Scalars['String'];
};

export type MessageWithUser = {
  __typename?: 'MessageWithUser';
  id: Scalars['ID'];
  subject: Scalars['String'];
  content: Scalars['String'];
  readStatus: Scalars['Boolean'];
  createdOn: Scalars['String'];
  from?: Maybe<MessageAuthor>;
};

export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | StartupProfileSummary | TechnologySolutionSummary | CorporateProfileSummary | TechnologyRequestSummary | TechnologySolutionMatchSummary | TechnologyRequestMatchSummary | BookmarkContent | FindCurrentUserBookmarksContentPayload | GetChatMessagesPayload | ConversationStages | ConversationStartupCorp | ConversationAgreementPdf | StartConversationPayload | MyCorporateTechnologyRequest | MyCorporateProfile | DeductCreditPayload | MatchResults | MatchPayload | MatchItemSummary | EvalMatchResult | SearchMatchesPayload | MatchesCsv | FindMatchMakingResultWithRolePayload | Message | MessageAuthor | MessageWithUser | PagedMessages | FindOnboardingSessionByUuidPayload | UpdateOnboardingSessionByUuidPayload | CompleteOnboardingSessionByUuidPayload | TryGetNewOnboardingSessionPayload | CreatePaymentIntentPayload | ConversationStageComplete | ConversationSummary | MyProfile | RedeemStartConversationPayload | ForgotPasswordResponse | GetServicesPayload | MyStartupProfile | CorporateViewStartupProfile | CorporateViewTestimonial | CorporateViewCaseStudies | CorporateFindOneTechnologySolution | CountTechSolutionMatches | UseVerificationPayload | ApplicationConfig | UpdateApplicationConfigPayload | DeleteApplicationConfigPayload | Bookmark | BookmarkConnection | BookmarkAggregator | BookmarkAggregatorSum | BookmarkAggregatorAvg | BookmarkAggregatorMin | BookmarkAggregatorMax | BookmarkGroupBy | BookmarkConnectionId | BookmarkConnectionCreated_At | BookmarkConnectionUpdated_At | BookmarkConnectionType | BookmarkConnectionItem_Id | BookmarkConnectionCategory | BookmarkConnectionPerson_Profile | CreateBookmarkPayload | UpdateBookmarkPayload | DeleteBookmarkPayload | BusinessUseCase | BusinessUseCaseConnection | BusinessUseCaseAggregator | BusinessUseCaseGroupBy | BusinessUseCaseConnectionId | BusinessUseCaseConnectionCreated_At | BusinessUseCaseConnectionUpdated_At | BusinessUseCaseConnectionName | CreateBusinessUseCasePayload | UpdateBusinessUseCasePayload | DeleteBusinessUseCasePayload | Careers | CareersConnection | CareersAggregator | CareersGroupBy | CareersConnectionId | CareersConnectionCreated_At | CareersConnectionUpdated_At | CareersConnectionJob_Title | CareersConnectionDescription | CareersConnectionPublished_At | CreateCareerPayload | UpdateCareerPayload | DeleteCareerPayload | CatalystAllocation | CatalystAllocationConnection | CatalystAllocationAggregator | CatalystAllocationGroupBy | CatalystAllocationConnectionId | CatalystAllocationConnectionCreated_At | CatalystAllocationConnectionUpdated_At | CatalystAllocationConnectionUsers_Permissions_User | CatalystAllocationConnectionStartup_Profile | CreateCatalystAllocationPayload | UpdateCatalystAllocationPayload | DeleteCatalystAllocationPayload | CatalystConversations | CatalystConversationsConnection | CatalystConversationsAggregator | CatalystConversationsGroupBy | CatalystConversationsConnectionId | CatalystConversationsConnectionCreated_At | CatalystConversationsConnectionUpdated_At | CatalystConversationsConnectionUsers_Permissions_User | CatalystConversationsConnectionConversation | CatalystConversationsConnectionActive | CreateCatalystConversationPayload | UpdateCatalystConversationPayload | DeleteCatalystConversationPayload | ChatMessages | ChatMessagesConnection | ChatMessagesAggregator | ChatMessagesGroupBy | ChatMessagesConnectionId | ChatMessagesConnectionCreated_At | ChatMessagesConnectionUpdated_At | ChatMessagesConnectionBody | ChatMessagesConnectionFrom_User | ChatMessagesConnectionChat | CreateChatMessagePayload | UpdateChatMessagePayload | DeleteChatMessagePayload | Chat | ChatConnection | ChatAggregator | ChatGroupBy | ChatConnectionId | ChatConnectionCreated_At | ChatConnectionUpdated_At | ChatConnectionCategory | ChatConnectionReference_Id | ChatConnectionUsers | CreateChatPayload | UpdateChatPayload | DeleteChatPayload | ConversationMessage | ConversationMessageConnection | ConversationMessageAggregator | ConversationMessageGroupBy | ConversationMessageConnectionId | ConversationMessageConnectionCreated_At | ConversationMessageConnectionUpdated_At | ConversationMessageConnectionBody | ConversationMessageConnectionSent_Datetime | ConversationMessageConnectionConversation | ConversationMessageConnectionBy_User | CreateConversationMessagePayload | UpdateConversationMessagePayload | DeleteConversationMessagePayload | Conversations | ConversationsConnection | ConversationsAggregator | ConversationsGroupBy | ConversationsConnectionId | ConversationsConnectionCreated_At | ConversationsConnectionUpdated_At | ConversationsConnectionHashtag | ConversationsConnectionActive | ConversationsConnectionBusiness_Use_Case | ConversationsConnectionScope | ConversationsConnectionProposal | ConversationsConnectionAgreement | ConversationsConnectionTechnology_Request | ConversationsConnectionTechnology_Solution | ConversationsConnectionCurrent_Section | ConversationsConnectionNda_Signed_Startup | ConversationsConnectionNda_Signed_Corporate | ConversationsConnectionCatalyst_Conversation | ConversationsConnectionNda_Signed_Startup_Date | ConversationsConnectionNda_Signed_Corporate_Date | ConversationsConnectionNda_Signed_Startup_By | ConversationsConnectionNda_Signed_Corporate_By | ConversationsConnectionNda_Corporate_Upload | CreateConversationPayload | UpdateConversationPayload | DeleteConversationPayload | CorporateDepartment | CorporateDepartmentConnection | CorporateDepartmentAggregator | CorporateDepartmentGroupBy | CorporateDepartmentConnectionId | CorporateDepartmentConnectionCreated_At | CorporateDepartmentConnectionUpdated_At | CorporateDepartmentConnectionName | CreateCorporateDepartmentPayload | UpdateCorporateDepartmentPayload | DeleteCorporateDepartmentPayload | Corporate | CorporateConnection | CorporateAggregator | CorporateAggregatorSum | CorporateAggregatorAvg | CorporateAggregatorMin | CorporateAggregatorMax | CorporateGroupBy | CorporateConnectionId | CorporateConnectionCreated_At | CorporateConnectionUpdated_At | CorporateConnectionName | CorporateConnectionDescription | CorporateConnectionLogo | CorporateConnectionCountry | CorporateConnectionAvatar | CorporateConnectionPsuedo_Name | CorporateConnectionCountry_Jurisdiction | CorporateConnectionEmployee_Count_Range | CorporateConnectionRating | CorporateConnectionWorked_With_Startups | CorporateConnectionLinks | CorporateConnectionEsg_Rating | CreateCorporatePayload | UpdateCorporatePayload | DeleteCorporatePayload | Country | CountryConnection | CountryAggregator | CountryGroupBy | CountryConnectionId | CountryConnectionCreated_At | CountryConnectionUpdated_At | CountryConnectionFull_Name | CountryConnectionIso_Code | CountryConnectionPublished_At | CreateCountryPayload | UpdateCountryPayload | DeleteCountryPayload | Credits | CreditsConnection | CreditsAggregator | CreditsAggregatorSum | CreditsAggregatorAvg | CreditsAggregatorMin | CreditsAggregatorMax | CreditsGroupBy | CreditsConnectionId | CreditsConnectionCreated_At | CreditsConnectionUpdated_At | CreditsConnectionValue | CreditsConnectionDate_Start | CreditsConnectionDate_Expire | CreditsConnectionUid | CreateCreditPayload | UpdateCreditPayload | DeleteCreditPayload | DocumentSharing | DocumentSharingConnection | DocumentSharingAggregator | DocumentSharingGroupBy | DocumentSharingConnectionId | DocumentSharingConnectionCreated_At | DocumentSharingConnectionUpdated_At | DocumentSharingConnectionDocument | DocumentSharingConnectionTitle | CreateDocumentSharingPayload | UpdateDocumentSharingPayload | DeleteDocumentSharingPayload | Enquiries | EnquiriesConnection | EnquiriesAggregator | EnquiriesGroupBy | EnquiriesConnectionId | EnquiriesConnectionCreated_At | EnquiriesConnectionUpdated_At | EnquiriesConnectionFirst_Name | EnquiriesConnectionLast_Name | EnquiriesConnectionEmail | EnquiriesConnectionMessage | CreateEnquiryPayload | UpdateEnquiryPayload | DeleteEnquiryPayload | Goals | GoalsConnection | GoalsAggregator | GoalsGroupBy | GoalsConnectionId | GoalsConnectionCreated_At | GoalsConnectionUpdated_At | GoalsConnectionName | CreateGoalPayload | UpdateGoalPayload | DeleteGoalPayload | ImpactArea | ImpactAreaConnection | ImpactAreaAggregator | ImpactAreaGroupBy | ImpactAreaConnectionId | ImpactAreaConnectionCreated_At | ImpactAreaConnectionUpdated_At | ImpactAreaConnectionName | CreateImpactAreaPayload | UpdateImpactAreaPayload | DeleteImpactAreaPayload | Industry | IndustryConnection | IndustryAggregator | IndustryGroupBy | IndustryConnectionId | IndustryConnectionCreated_At | IndustryConnectionUpdated_At | IndustryConnectionName | CreateIndustryPayload | UpdateIndustryPayload | DeleteIndustryPayload | JobPosting | JobPostingConnection | JobPostingAggregator | JobPostingGroupBy | JobPostingConnectionId | JobPostingConnectionCreated_At | JobPostingConnectionUpdated_At | JobPostingConnectionJob_Title | JobPostingConnectionDescription | JobPostingConnectionPublished_At | CreateJobPostingPayload | UpdateJobPostingPayload | DeleteJobPostingPayload | MatchMakingResult | MatchMakingResultConnection | MatchMakingResultAggregator | MatchMakingResultAggregatorSum | MatchMakingResultAggregatorAvg | MatchMakingResultAggregatorMin | MatchMakingResultAggregatorMax | MatchMakingResultGroupBy | MatchMakingResultConnectionId | MatchMakingResultConnectionCreated_At | MatchMakingResultConnectionUpdated_At | MatchMakingResultConnectionIs_Saved | MatchMakingResultConnectionIs_Rejected | MatchMakingResultConnectionMatch_Purpose_Poc | MatchMakingResultConnectionMatch_Purpose_Sell | MatchMakingResultConnectionMatch_Purpose_Lease | MatchMakingResultConnectionMatch_Has_Ip | MatchMakingResultConnectionMatch_Can_Whitelabel | MatchMakingResultConnectionMatch_Has_Api | MatchMakingResultConnectionMatch_Is_Plugandplay | MatchMakingResultConnectionMatch_Is_Gdpr | MatchMakingResultConnectionMatch_Is_Cloud | MatchMakingResultConnectionIs_Manual_Match | MatchMakingResultConnectionTechnology_Request | MatchMakingResultConnectionTechnology_Solution | MatchMakingResultConnectionMatch_Rating_From_Tech_Req | MatchMakingResultConnectionMatch_Rating_From_Tech_Solution | MatchMakingResultConnectionMatch_Sdg_Driven | CreateMatchMakingResultPayload | UpdateMatchMakingResultPayload | DeleteMatchMakingResultPayload | MaturityLevel | MaturityLevelConnection | MaturityLevelAggregator | MaturityLevelGroupBy | MaturityLevelConnectionId | MaturityLevelConnectionCreated_At | MaturityLevelConnectionUpdated_At | MaturityLevelConnectionName | CreateMaturityLevelPayload | UpdateMaturityLevelPayload | DeleteMaturityLevelPayload | NewsArticle | NewsArticleConnection | NewsArticleAggregator | NewsArticleGroupBy | NewsArticleConnectionId | NewsArticleConnectionCreated_At | NewsArticleConnectionUpdated_At | NewsArticleConnectionHeadline | NewsArticleConnectionBody | NewsArticleConnectionSummary | NewsArticleConnectionMain_Image | NewsArticleConnectionPublished_At | CreateNewsArticlePayload | UpdateNewsArticlePayload | DeleteNewsArticlePayload | NotificationPreferences | NotificationPreferencesConnection | NotificationPreferencesAggregator | NotificationPreferencesGroupBy | NotificationPreferencesConnectionId | NotificationPreferencesConnectionCreated_At | NotificationPreferencesConnectionUpdated_At | NotificationPreferencesConnectionTeam_Notifications | NotificationPreferencesConnectionPlatform_Notifications | NotificationPreferencesConnectionPotential_Partner | NotificationPreferencesConnectionPartner_Collaboration | NotificationPreferencesConnectionChat | NotificationPreferencesConnectionActivity | CreateNotificationPreferencePayload | UpdateNotificationPreferencePayload | DeleteNotificationPreferencePayload | OnBoardingSession | OnBoardingSessionConnection | OnBoardingSessionAggregator | OnBoardingSessionGroupBy | OnBoardingSessionConnectionId | OnBoardingSessionConnectionCreated_At | OnBoardingSessionConnectionUpdated_At | OnBoardingSessionConnectionPayload | OnBoardingSessionConnectionUuid | OnBoardingSessionConnectionCompleted | CreateOnBoardingSessionPayload | UpdateOnBoardingSessionPayload | DeleteOnBoardingSessionPayload | PersonProfile | PersonProfileConnection | PersonProfileAggregator | PersonProfileGroupBy | PersonProfileConnectionId | PersonProfileConnectionCreated_At | PersonProfileConnectionUpdated_At | PersonProfileConnectionFirst_Name | PersonProfileConnectionLast_Name | PersonProfileConnectionCorporate_Department | PersonProfileConnectionContact_Number | PersonProfileConnectionIs_Decisionmaker | PersonProfileConnectionPhoto | PersonProfileConnectionRole | PersonProfileConnectionUser | PersonProfileConnectionIs_Decision_Influencer | PersonProfileConnectionDecision_Role_Type | PersonProfileConnectionProfile_Type | CreatePersonProfilePayload | UpdatePersonProfilePayload | DeletePersonProfilePayload | PricingModel | PricingModelConnection | PricingModelAggregator | PricingModelGroupBy | PricingModelConnectionId | PricingModelConnectionCreated_At | PricingModelConnectionUpdated_At | PricingModelConnectionName | CreatePricingModelPayload | UpdatePricingModelPayload | DeletePricingModelPayload | PromoCodeConversation | PromoCodeConversationConnection | PromoCodeConversationAggregator | PromoCodeConversationGroupBy | PromoCodeConversationConnectionId | PromoCodeConversationConnectionCreated_At | PromoCodeConversationConnectionUpdated_At | PromoCodeConversationConnectionCode | CreatePromoCodeConversationPayload | UpdatePromoCodeConversationPayload | DeletePromoCodeConversationPayload | PromoCodeRedemptions | PromoCodeRedemptionsConnection | PromoCodeRedemptionsAggregator | PromoCodeRedemptionsGroupBy | PromoCodeRedemptionsConnectionId | PromoCodeRedemptionsConnectionCreated_At | PromoCodeRedemptionsConnectionUpdated_At | PromoCodeRedemptionsConnectionPromo_Code_Conversation | PromoCodeRedemptionsConnectionUsers_Permissions_User | CreatePromoCodeRedemptionPayload | UpdatePromoCodeRedemptionPayload | DeletePromoCodeRedemptionPayload | PromoCode | PromoCodeConnection | PromoCodeAggregator | PromoCodeAggregatorSum | PromoCodeAggregatorAvg | PromoCodeAggregatorMin | PromoCodeAggregatorMax | PromoCodeGroupBy | PromoCodeConnectionId | PromoCodeConnectionCreated_At | PromoCodeConnectionUpdated_At | PromoCodeConnectionCode | PromoCodeConnectionIssued_Date | PromoCodeConnectionClaimed | PromoCodeConnectionPromo_Matches | CreatePromoCodePayload | UpdatePromoCodePayload | DeletePromoCodePayload | PurchasedServices | PurchasedServicesConnection | PurchasedServicesAggregator | PurchasedServicesGroupBy | PurchasedServicesConnectionId | PurchasedServicesConnectionCreated_At | PurchasedServicesConnectionUpdated_At | PurchasedServicesConnectionUid | PurchasedServicesConnectionDate_Start | PurchasedServicesConnectionDate_Expire | CreatePurchasedServicePayload | UpdatePurchasedServicePayload | DeletePurchasedServicePayload | PurchasedSubscription | PurchasedSubscriptionConnection | PurchasedSubscriptionAggregator | PurchasedSubscriptionAggregatorSum | PurchasedSubscriptionAggregatorAvg | PurchasedSubscriptionAggregatorMin | PurchasedSubscriptionAggregatorMax | PurchasedSubscriptionGroupBy | PurchasedSubscriptionConnectionId | PurchasedSubscriptionConnectionCreated_At | PurchasedSubscriptionConnectionUpdated_At | PurchasedSubscriptionConnectionService_Package | PurchasedSubscriptionConnectionUser | PurchasedSubscriptionConnectionSpent | PurchasedSubscriptionConnectionBalance | PurchasedSubscriptionConnectionExpiry | CreatePurchasedSubscriptionPayload | UpdatePurchasedSubscriptionPayload | DeletePurchasedSubscriptionPayload | Rating | RatingConnection | RatingAggregator | RatingAggregatorSum | RatingAggregatorAvg | RatingAggregatorMin | RatingAggregatorMax | RatingGroupBy | RatingConnectionId | RatingConnectionCreated_At | RatingConnectionUpdated_At | RatingConnectionValue | RatingConnectionArticle_Type | RatingConnectionItem_Id | RatingConnectionComments | CreateRatingPayload | UpdateRatingPayload | DeleteRatingPayload | RegionServicePrice | RegionServicePriceConnection | RegionServicePriceAggregator | RegionServicePriceAggregatorSum | RegionServicePriceAggregatorAvg | RegionServicePriceAggregatorMin | RegionServicePriceAggregatorMax | RegionServicePriceGroupBy | RegionServicePriceConnectionId | RegionServicePriceConnectionCreated_At | RegionServicePriceConnectionUpdated_At | RegionServicePriceConnectionService | RegionServicePriceConnectionPrice | RegionServicePriceConnectionRegion_Code | RegionServicePriceConnectionPublished_At | CreateRegionServicePricePayload | UpdateRegionServicePricePayload | DeleteRegionServicePricePayload | Region | RegionConnection | RegionAggregator | RegionGroupBy | RegionConnectionId | RegionConnectionCreated_At | RegionConnectionUpdated_At | RegionConnectionCode | RegionConnectionName | RegionConnectionCurrency | RegionConnectionPublished_At | CreateRegionPayload | UpdateRegionPayload | DeleteRegionPayload | SdgObjectives | SdgObjectivesConnection | SdgObjectivesAggregator | SdgObjectivesGroupBy | SdgObjectivesConnectionId | SdgObjectivesConnectionCreated_At | SdgObjectivesConnectionUpdated_At | SdgObjectivesConnectionName | CreateSdgObjectivePayload | UpdateSdgObjectivePayload | DeleteSdgObjectivePayload | ServiceCollaboration | ServiceCollaborationConnection | ServiceCollaborationAggregator | ServiceCollaborationGroupBy | ServiceCollaborationConnectionId | ServiceCollaborationConnectionCreated_At | ServiceCollaborationConnectionUpdated_At | ServiceCollaborationConnectionService | ServiceCollaborationConnectionCatalyst | ServiceCollaborationConnectionClient | ServiceCollaborationConnectionScope | ServiceCollaborationConnectionDeliverables | ServiceCollaborationConnectionFeedback | ServiceCollaborationConnectionChat | ServiceCollaborationConnectionStartup_Profile | ServiceCollaborationConnectionCorporate_Profile | CreateServiceCollaborationPayload | UpdateServiceCollaborationPayload | DeleteServiceCollaborationPayload | ServicePackage | ServicePackageConnection | ServicePackageAggregator | ServicePackageGroupBy | ServicePackageConnectionId | ServicePackageConnectionCreated_At | ServicePackageConnectionUpdated_At | ServicePackageConnectionName | ServicePackageConnectionRole_Type | ServicePackageConnectionUnlimited_Credits | ServicePackageConnectionRegion_Code | ServicePackageConnectionSlug | CreateServicePackagePayload | UpdateServicePackagePayload | DeleteServicePackagePayload | ServicesInterest | ServicesInterestConnection | ServicesInterestAggregator | ServicesInterestGroupBy | ServicesInterestConnectionId | ServicesInterestConnectionCreated_At | ServicesInterestConnectionUpdated_At | ServicesInterestConnectionEmail | ServicesInterestConnectionServices | ServicesInterestConnectionRequested_Conversation_With | CreateServicesInterestPayload | UpdateServicesInterestPayload | DeleteServicesInterestPayload | Services | ServicesConnection | ServicesAggregator | ServicesAggregatorSum | ServicesAggregatorAvg | ServicesAggregatorMin | ServicesAggregatorMax | ServicesGroupBy | ServicesConnectionId | ServicesConnectionCreated_At | ServicesConnectionUpdated_At | ServicesConnectionTitle | ServicesConnectionDescription | ServicesConnectionRole | ServicesConnectionPrice | ServicesConnectionImage | ServicesConnectionSlug | ServicesConnectionService_Collaboration | ServicesConnectionPublished_At | CreateServicePayload | UpdateServicePayload | DeleteServicePayload | StartConversationTermsConditions | UpdateStartConversationTermsConditionPayload | DeleteStartConversationTermsConditionPayload | StartupProfile | StartupProfileConnection | StartupProfileAggregator | StartupProfileAggregatorSum | StartupProfileAggregatorAvg | StartupProfileAggregatorMin | StartupProfileAggregatorMax | StartupProfileGroupBy | StartupProfileConnectionId | StartupProfileConnectionCreated_At | StartupProfileConnectionUpdated_At | StartupProfileConnectionName | StartupProfileConnectionStart_Date | StartupProfileConnectionDescription | StartupProfileConnectionCountry | StartupProfileConnectionLogo | StartupProfileConnectionAvatar | StartupProfileConnectionPsuedo_Name | StartupProfileConnectionOperating_Locations | StartupProfileConnectionEmployee_Count | StartupProfileConnectionLinks | StartupProfileConnectionWorked_With_Corporates | StartupProfileConnectionClients | StartupProfileConnectionIncubators_Accelerators | StartupProfileConnectionInvestment_Received | StartupProfileConnectionMaturity_Level | StartupProfileConnectionRating | StartupProfileConnectionInvestment_Stage | StartupProfileConnectionClient_Count | StartupProfileConnectionEmployee_Count_Range | StartupProfileConnectionWent_Incubator_Accelerator | StartupProfileConnectionInvestment_Received_Currency | StartupProfileConnectionEsg_Rating | CreateStartupProfilePayload | UpdateStartupProfilePayload | DeleteStartupProfilePayload | TechnologyReadinessLevel | TechnologyReadinessLevelConnection | TechnologyReadinessLevelAggregator | TechnologyReadinessLevelGroupBy | TechnologyReadinessLevelConnectionId | TechnologyReadinessLevelConnectionCreated_At | TechnologyReadinessLevelConnectionUpdated_At | TechnologyReadinessLevelConnectionName | CreateTechnologyReadinessLevelPayload | UpdateTechnologyReadinessLevelPayload | DeleteTechnologyReadinessLevelPayload | TechnologyRequest | TechnologyRequestConnection | TechnologyRequestAggregator | TechnologyRequestAggregatorSum | TechnologyRequestAggregatorAvg | TechnologyRequestAggregatorMin | TechnologyRequestAggregatorMax | TechnologyRequestGroupBy | TechnologyRequestConnectionId | TechnologyRequestConnectionCreated_At | TechnologyRequestConnectionUpdated_At | TechnologyRequestConnectionName | TechnologyRequestConnectionHas_Ip | TechnologyRequestConnectionCan_Whitelabel | TechnologyRequestConnectionWant_Poc | TechnologyRequestConnectionWant_Seller | TechnologyRequestConnectionWant_Lease | TechnologyRequestConnectionHas_Api | TechnologyRequestConnectionIs_Plugandplay | TechnologyRequestConnectionBudget_Min | TechnologyRequestConnectionBudget_Max | TechnologyRequestConnectionBudget_Is_Disclose | TechnologyRequestConnectionBusiness_Challange_Description | TechnologyRequestConnectionProjected_Startdate | TechnologyRequestConnectionProjected_Complete_Date | TechnologyRequestConnectionCountry_Implementation | TechnologyRequestConnectionSpecifications | TechnologyRequestConnectionBusiness_Type | TechnologyRequestConnectionIs_Gdpr | TechnologyRequestConnectionIs_Cloud | TechnologyRequestConnectionTechnology_Solution_Model_B2b | TechnologyRequestConnectionTechnology_Solution_Model_B2c | TechnologyRequestConnectionTechnology_Solution_Model_B2b2c | TechnologyRequestConnectionTechnology_Solution_Model_Others | TechnologyRequestConnectionCurrency | TechnologyRequestConnectionStart_Date | TechnologyRequestConnectionEnd_Date | TechnologyRequestConnectionOther_Tech_Option | TechnologyRequestConnectionDescription_Project | TechnologyRequestConnectionDescription_How_To_Resolve_Problem | TechnologyRequestConnectionDescription_Customer | TechnologyRequestConnectionDescription_Successful_Outcome | TechnologyRequestConnectionDescription_Similiar_Solutions | TechnologyRequestConnectionDescription_Risk_Challenges | TechnologyRequestConnectionWant_Explore | TechnologyRequestConnectionBudget_Is_Poc | TechnologyRequestConnectionBudget_Is_Lease | TechnologyRequestConnectionHero_Image | TechnologyRequestConnectionIs_Published | TechnologyRequestConnectionBudget_Is_Buy | TechnologyRequestConnectionImpact_Level | TechnologyRequestConnectionImpact_Area | TechnologyRequestConnectionIs_Spin_Off | TechnologyRequestConnectionWant_Investment | TechnologyRequestConnectionIs_Others | TechnologyRequestConnectionCorporate_Profile | TechnologyRequestConnectionIs_Match_Triggered | TechnologyRequestConnectionWant_Access_Alkelio_Services | TechnologyRequestConnectionGoal_Other | TechnologyRequestConnectionIs_Completed | TechnologyRequestConnectionSdg_Driven | TechnologyRequestConnectionPublished_At | CreateTechnologyRequestPayload | UpdateTechnologyRequestPayload | DeleteTechnologyRequestPayload | TechnologySolution | TechnologySolutionConnection | TechnologySolutionAggregator | TechnologySolutionAggregatorSum | TechnologySolutionAggregatorAvg | TechnologySolutionAggregatorMin | TechnologySolutionAggregatorMax | TechnologySolutionGroupBy | TechnologySolutionConnectionId | TechnologySolutionConnectionCreated_At | TechnologySolutionConnectionUpdated_At | TechnologySolutionConnectionName | TechnologySolutionConnectionPurpose_Poc | TechnologySolutionConnectionPurpose_Sell | TechnologySolutionConnectionPurpose_Lease | TechnologySolutionConnectionHas_Ip | TechnologySolutionConnectionIs_Whitelabel | TechnologySolutionConnectionDescription | TechnologySolutionConnectionHas_Api | TechnologySolutionConnectionIs_Plugandplay | TechnologySolutionConnectionHero_Image | TechnologySolutionConnectionEmbed_Demo_Url | TechnologySolutionConnectionIs_Spin_Off | TechnologySolutionConnectionSpin_Off_Source | TechnologySolutionConnectionIs_Gdpr | TechnologySolutionConnectionIs_Cloud | TechnologySolutionConnectionKey_Features | TechnologySolutionConnectionVersions_Release_Dates | TechnologySolutionConnectionSupported_Operating_Systems | TechnologySolutionConnectionTotal_Investment | TechnologySolutionConnectionResources_Required | TechnologySolutionConnectionResource_Transfer_Details | TechnologySolutionConnectionLicensing_Type_Details | TechnologySolutionConnectionReason_To_Sell | TechnologySolutionConnectionAssets_To_Sell | TechnologySolutionConnectionIs_Consumer_Data_Collected | TechnologySolutionConnectionIs_Tech_Transferrable | TechnologySolutionConnectionPrice_Poc_Min | TechnologySolutionConnectionPrice_Poc_Max | TechnologySolutionConnectionPrice_Lease_Min | TechnologySolutionConnectionPrice_Lease_Max | TechnologySolutionConnectionDemo_Video | TechnologySolutionConnectionIs_Others | TechnologySolutionConnectionPurpose_Certify | TechnologySolutionConnectionCurrency | TechnologySolutionConnectionPrice_Sell_Min | TechnologySolutionConnectionPrice_Sell_Max | TechnologySolutionConnectionIs_Published | TechnologySolutionConnectionBenefits_Description | TechnologySolutionConnectionPurpose_Investment | TechnologySolutionConnectionTestimonial | TechnologySolutionConnectionInvest_Information | TechnologySolutionConnectionTechnology_Readiness | TechnologySolutionConnectionUse_Case_Count | TechnologySolutionConnectionUse | TechnologySolutionConnectionIs_Use_Case_On_Request | TechnologySolutionConnectionIs_Consumer_Data_Collected_Remarks | TechnologySolutionConnectionIs_Tech_Transferrable_Remarks | TechnologySolutionConnectionWant_To_Transfer_Resources | TechnologySolutionConnectionCompany_Performance_Annual_Sales | TechnologySolutionConnectionIs_Match_Triggered | TechnologySolutionConnectionStartup_Profile | TechnologySolutionConnectionRating | TechnologySolutionConnectionTested_By_Alkelio | TechnologySolutionConnectionPurpose_Access_Alkelio_Services | TechnologySolutionConnectionPurpose_Explore | TechnologySolutionConnectionIs_Completed | TechnologySolutionConnectionCase_Studies | TechnologySolutionConnectionSdg_Driven | TechnologySolutionConnectionPublished_At | CreateTechnologySolutionPayload | UpdateTechnologySolutionPayload | DeleteTechnologySolutionPayload | TechnologyType | TechnologyTypeConnection | TechnologyTypeAggregator | TechnologyTypeGroupBy | TechnologyTypeConnectionId | TechnologyTypeConnectionCreated_At | TechnologyTypeConnectionUpdated_At | TechnologyTypeConnectionName | CreateTechnologyTypePayload | UpdateTechnologyTypePayload | DeleteTechnologyTypePayload | Transactions | TransactionsConnection | TransactionsAggregator | TransactionsAggregatorSum | TransactionsAggregatorAvg | TransactionsAggregatorMin | TransactionsAggregatorMax | TransactionsGroupBy | TransactionsConnectionId | TransactionsConnectionCreated_At | TransactionsConnectionUpdated_At | TransactionsConnectionAmount | TransactionsConnectionUid | TransactionsConnectionStatus | TransactionsConnectionType | TransactionsConnectionCurrency | TransactionsConnectionMeta | TransactionsConnectionTitle | TransactionsConnectionExternal_Transaction_Id | CreateTransactionPayload | UpdateTransactionPayload | DeleteTransactionPayload | UserSubmittedGoals | UserSubmittedGoalsConnection | UserSubmittedGoalsAggregator | UserSubmittedGoalsGroupBy | UserSubmittedGoalsConnectionId | UserSubmittedGoalsConnectionCreated_At | UserSubmittedGoalsConnectionUpdated_At | UserSubmittedGoalsConnectionName | CreateUserSubmittedGoalPayload | UpdateUserSubmittedGoalPayload | DeleteUserSubmittedGoalPayload | VerificationAction | VerificationActionConnection | VerificationActionAggregator | VerificationActionGroupBy | VerificationActionConnectionId | VerificationActionConnectionCreated_At | VerificationActionConnectionUpdated_At | VerificationActionConnectionCode | VerificationActionConnectionUser | VerificationActionConnectionUuid | VerificationActionConnectionUsed | VerificationActionConnectionExpiresAt | CreateVerificationActionPayload | UpdateVerificationActionPayload | DeleteVerificationActionPayload | ViewCounts | ViewCountsConnection | ViewCountsAggregator | ViewCountsGroupBy | ViewCountsConnectionId | ViewCountsConnectionCreated_At | ViewCountsConnectionUpdated_At | ViewCountsConnectionCount | ViewCountsConnectionArticle_Id | CreateViewCountPayload | UpdateViewCountPayload | DeleteViewCountPayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | DeleteFilePayload | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionPerson_Profile | UsersPermissionsUserConnectionVerification_Action | UsersPermissionsUserConnectionCatalyst_Conversation | UsersPermissionsUserConnectionNotification_Preference | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentConversationFormFormAgreement | ComponentConversationFormFormBusinessUseCase | ComponentConversationFormFormProposal | ComponentConversationFormFormScopePerson | ComponentConversationFormFormScopeRequirements | ComponentConversationFormFormScope | ComponentGenericLinks | ComponentPricingTechnologySolutionPricingModel | ComponentRegionPricingRegionPrices | ComponentServiceCollaborationDatePeriod | ComponentServiceCollaborationDeliverables | ComponentServiceCollaborationFeedback | ComponentServiceCollaborationMethodology | ComponentServiceCollaborationPerson | ComponentServiceCollaborationScope | ComponentServiceCollaborationStructure | ComponentServiceCollaborationTeam | ComponentServiceCollaborationTextWithFiles | ComponentServicePackageAdHocServiceSelection | ComponentServicePackageServicePackagePaymentMode | ComponentTechnologySolutionCaseStudies | ComponentTechnologySolutionInvestInformation | ComponentTechnologySolutionProjectBudget | ComponentTechnologySolutionTestimonial;

export type Mutation = {
  __typename?: 'Mutation';
  updateApplicationConfig?: Maybe<UpdateApplicationConfigPayload>;
  deleteApplicationConfig?: Maybe<DeleteApplicationConfigPayload>;
  createBookmark?: Maybe<CreateBookmarkPayload>;
  updateBookmark?: Maybe<UpdateBookmarkPayload>;
  deleteBookmark?: Maybe<DeleteBookmarkPayload>;
  createBusinessUseCase?: Maybe<CreateBusinessUseCasePayload>;
  updateBusinessUseCase?: Maybe<UpdateBusinessUseCasePayload>;
  deleteBusinessUseCase?: Maybe<DeleteBusinessUseCasePayload>;
  createCareer?: Maybe<CreateCareerPayload>;
  updateCareer?: Maybe<UpdateCareerPayload>;
  deleteCareer?: Maybe<DeleteCareerPayload>;
  createCatalystAllocation?: Maybe<CreateCatalystAllocationPayload>;
  updateCatalystAllocation?: Maybe<UpdateCatalystAllocationPayload>;
  deleteCatalystAllocation?: Maybe<DeleteCatalystAllocationPayload>;
  createCatalystConversation?: Maybe<CreateCatalystConversationPayload>;
  updateCatalystConversation?: Maybe<UpdateCatalystConversationPayload>;
  deleteCatalystConversation?: Maybe<DeleteCatalystConversationPayload>;
  createChatMessage?: Maybe<CreateChatMessagePayload>;
  updateChatMessage?: Maybe<UpdateChatMessagePayload>;
  deleteChatMessage?: Maybe<DeleteChatMessagePayload>;
  createChat?: Maybe<CreateChatPayload>;
  updateChat?: Maybe<UpdateChatPayload>;
  deleteChat?: Maybe<DeleteChatPayload>;
  createConversationMessage?: Maybe<CreateConversationMessagePayload>;
  updateConversationMessage?: Maybe<UpdateConversationMessagePayload>;
  deleteConversationMessage?: Maybe<DeleteConversationMessagePayload>;
  createConversation?: Maybe<CreateConversationPayload>;
  updateConversation?: Maybe<UpdateConversationPayload>;
  deleteConversation?: Maybe<DeleteConversationPayload>;
  createCorporateDepartment?: Maybe<CreateCorporateDepartmentPayload>;
  updateCorporateDepartment?: Maybe<UpdateCorporateDepartmentPayload>;
  deleteCorporateDepartment?: Maybe<DeleteCorporateDepartmentPayload>;
  createCorporate?: Maybe<CreateCorporatePayload>;
  updateCorporate?: Maybe<UpdateCorporatePayload>;
  deleteCorporate?: Maybe<DeleteCorporatePayload>;
  createCountry?: Maybe<CreateCountryPayload>;
  updateCountry?: Maybe<UpdateCountryPayload>;
  deleteCountry?: Maybe<DeleteCountryPayload>;
  createCredit?: Maybe<CreateCreditPayload>;
  updateCredit?: Maybe<UpdateCreditPayload>;
  deleteCredit?: Maybe<DeleteCreditPayload>;
  createDocumentSharing?: Maybe<CreateDocumentSharingPayload>;
  updateDocumentSharing?: Maybe<UpdateDocumentSharingPayload>;
  deleteDocumentSharing?: Maybe<DeleteDocumentSharingPayload>;
  createEnquiry?: Maybe<CreateEnquiryPayload>;
  updateEnquiry?: Maybe<UpdateEnquiryPayload>;
  deleteEnquiry?: Maybe<DeleteEnquiryPayload>;
  createGoal?: Maybe<CreateGoalPayload>;
  updateGoal?: Maybe<UpdateGoalPayload>;
  deleteGoal?: Maybe<DeleteGoalPayload>;
  createImpactArea?: Maybe<CreateImpactAreaPayload>;
  updateImpactArea?: Maybe<UpdateImpactAreaPayload>;
  deleteImpactArea?: Maybe<DeleteImpactAreaPayload>;
  createIndustry?: Maybe<CreateIndustryPayload>;
  updateIndustry?: Maybe<UpdateIndustryPayload>;
  deleteIndustry?: Maybe<DeleteIndustryPayload>;
  createJobPosting?: Maybe<CreateJobPostingPayload>;
  updateJobPosting?: Maybe<UpdateJobPostingPayload>;
  deleteJobPosting?: Maybe<DeleteJobPostingPayload>;
  createMatchMakingResult?: Maybe<CreateMatchMakingResultPayload>;
  updateMatchMakingResult?: Maybe<UpdateMatchMakingResultPayload>;
  deleteMatchMakingResult?: Maybe<DeleteMatchMakingResultPayload>;
  createMaturityLevel?: Maybe<CreateMaturityLevelPayload>;
  updateMaturityLevel?: Maybe<UpdateMaturityLevelPayload>;
  deleteMaturityLevel?: Maybe<DeleteMaturityLevelPayload>;
  createNewsArticle?: Maybe<CreateNewsArticlePayload>;
  updateNewsArticle?: Maybe<UpdateNewsArticlePayload>;
  deleteNewsArticle?: Maybe<DeleteNewsArticlePayload>;
  createNotificationPreference?: Maybe<CreateNotificationPreferencePayload>;
  updateNotificationPreference?: Maybe<UpdateNotificationPreferencePayload>;
  deleteNotificationPreference?: Maybe<DeleteNotificationPreferencePayload>;
  createOnBoardingSession?: Maybe<CreateOnBoardingSessionPayload>;
  updateOnBoardingSession?: Maybe<UpdateOnBoardingSessionPayload>;
  deleteOnBoardingSession?: Maybe<DeleteOnBoardingSessionPayload>;
  createPersonProfile?: Maybe<CreatePersonProfilePayload>;
  updatePersonProfile?: Maybe<UpdatePersonProfilePayload>;
  deletePersonProfile?: Maybe<DeletePersonProfilePayload>;
  createPricingModel?: Maybe<CreatePricingModelPayload>;
  updatePricingModel?: Maybe<UpdatePricingModelPayload>;
  deletePricingModel?: Maybe<DeletePricingModelPayload>;
  createPromoCodeConversation?: Maybe<CreatePromoCodeConversationPayload>;
  updatePromoCodeConversation?: Maybe<UpdatePromoCodeConversationPayload>;
  deletePromoCodeConversation?: Maybe<DeletePromoCodeConversationPayload>;
  createPromoCodeRedemption?: Maybe<CreatePromoCodeRedemptionPayload>;
  updatePromoCodeRedemption?: Maybe<UpdatePromoCodeRedemptionPayload>;
  deletePromoCodeRedemption?: Maybe<DeletePromoCodeRedemptionPayload>;
  createPromoCode?: Maybe<CreatePromoCodePayload>;
  updatePromoCode?: Maybe<UpdatePromoCodePayload>;
  deletePromoCode?: Maybe<DeletePromoCodePayload>;
  createPurchasedService?: Maybe<CreatePurchasedServicePayload>;
  updatePurchasedService?: Maybe<UpdatePurchasedServicePayload>;
  deletePurchasedService?: Maybe<DeletePurchasedServicePayload>;
  createPurchasedSubscription?: Maybe<CreatePurchasedSubscriptionPayload>;
  updatePurchasedSubscription?: Maybe<UpdatePurchasedSubscriptionPayload>;
  deletePurchasedSubscription?: Maybe<DeletePurchasedSubscriptionPayload>;
  createRating?: Maybe<CreateRatingPayload>;
  updateRating?: Maybe<UpdateRatingPayload>;
  deleteRating?: Maybe<DeleteRatingPayload>;
  createRegionServicePrice?: Maybe<CreateRegionServicePricePayload>;
  updateRegionServicePrice?: Maybe<UpdateRegionServicePricePayload>;
  deleteRegionServicePrice?: Maybe<DeleteRegionServicePricePayload>;
  createRegion?: Maybe<CreateRegionPayload>;
  updateRegion?: Maybe<UpdateRegionPayload>;
  deleteRegion?: Maybe<DeleteRegionPayload>;
  createSdgObjective?: Maybe<CreateSdgObjectivePayload>;
  updateSdgObjective?: Maybe<UpdateSdgObjectivePayload>;
  deleteSdgObjective?: Maybe<DeleteSdgObjectivePayload>;
  createServiceCollaboration?: Maybe<CreateServiceCollaborationPayload>;
  updateServiceCollaboration?: Maybe<UpdateServiceCollaborationPayload>;
  deleteServiceCollaboration?: Maybe<DeleteServiceCollaborationPayload>;
  createServicePackage?: Maybe<CreateServicePackagePayload>;
  updateServicePackage?: Maybe<UpdateServicePackagePayload>;
  deleteServicePackage?: Maybe<DeleteServicePackagePayload>;
  createServicesInterest?: Maybe<CreateServicesInterestPayload>;
  updateServicesInterest?: Maybe<UpdateServicesInterestPayload>;
  deleteServicesInterest?: Maybe<DeleteServicesInterestPayload>;
  createService?: Maybe<CreateServicePayload>;
  updateService?: Maybe<UpdateServicePayload>;
  deleteService?: Maybe<DeleteServicePayload>;
  updateStartConversationTermsCondition?: Maybe<UpdateStartConversationTermsConditionPayload>;
  deleteStartConversationTermsCondition?: Maybe<DeleteStartConversationTermsConditionPayload>;
  createStartupProfile?: Maybe<CreateStartupProfilePayload>;
  updateStartupProfile?: Maybe<UpdateStartupProfilePayload>;
  deleteStartupProfile?: Maybe<DeleteStartupProfilePayload>;
  createTechnologyReadinessLevel?: Maybe<CreateTechnologyReadinessLevelPayload>;
  updateTechnologyReadinessLevel?: Maybe<UpdateTechnologyReadinessLevelPayload>;
  deleteTechnologyReadinessLevel?: Maybe<DeleteTechnologyReadinessLevelPayload>;
  createTechnologyRequest?: Maybe<CreateTechnologyRequestPayload>;
  updateTechnologyRequest?: Maybe<UpdateTechnologyRequestPayload>;
  deleteTechnologyRequest?: Maybe<DeleteTechnologyRequestPayload>;
  createTechnologySolution?: Maybe<CreateTechnologySolutionPayload>;
  updateTechnologySolution?: Maybe<UpdateTechnologySolutionPayload>;
  deleteTechnologySolution?: Maybe<DeleteTechnologySolutionPayload>;
  createTechnologyType?: Maybe<CreateTechnologyTypePayload>;
  updateTechnologyType?: Maybe<UpdateTechnologyTypePayload>;
  deleteTechnologyType?: Maybe<DeleteTechnologyTypePayload>;
  createTransaction?: Maybe<CreateTransactionPayload>;
  updateTransaction?: Maybe<UpdateTransactionPayload>;
  deleteTransaction?: Maybe<DeleteTransactionPayload>;
  createUserSubmittedGoal?: Maybe<CreateUserSubmittedGoalPayload>;
  updateUserSubmittedGoal?: Maybe<UpdateUserSubmittedGoalPayload>;
  deleteUserSubmittedGoal?: Maybe<DeleteUserSubmittedGoalPayload>;
  createVerificationAction?: Maybe<CreateVerificationActionPayload>;
  updateVerificationAction?: Maybe<UpdateVerificationActionPayload>;
  deleteVerificationAction?: Maybe<DeleteVerificationActionPayload>;
  createViewCount?: Maybe<CreateViewCountPayload>;
  updateViewCount?: Maybe<UpdateViewCountPayload>;
  deleteViewCount?: Maybe<DeleteViewCountPayload>;
  deleteFile?: Maybe<DeleteFilePayload>;
  createRole?: Maybe<CreateRolePayload>;
  updateRole?: Maybe<UpdateRolePayload>;
  deleteRole?: Maybe<DeleteRolePayload>;
  createUser?: Maybe<CreateUserPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  updateFileInfo: UploadFile;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  sendChatMessage?: Maybe<Scalars['Void']>;
  agreeConversationNDA?: Maybe<Scalars['Void']>;
  makeConversationAgreementPdf?: Maybe<ConversationAgreementPdf>;
  updateAgreement?: Maybe<ComponentConversationFormFormAgreement>;
  startConversation?: Maybe<StartConversationPayload>;
  updateConversationByRole?: Maybe<UpdateConversationPayload>;
  addTechnologyRequestToCorporateProfile?: Maybe<Scalars['Void']>;
  deductCredit: DeductCreditPayload;
  deductCreditStartConversation: DeductCreditPayload;
  sendContact?: Maybe<Scalars['Boolean']>;
  refreshMatches?: Maybe<MatchPayload>;
  flushMatches?: Maybe<Scalars['Void']>;
  triggerJobSendMatches?: Maybe<Scalars['Void']>;
  triggerJobMatchAll?: Maybe<Scalars['Void']>;
  setCurrentUserNotifications?: Maybe<Scalars['Void']>;
  syncUsersWithoutNotificationPref?: Maybe<Scalars['Void']>;
  createNotification?: Maybe<Scalars['Void']>;
  setCurrentUserMessageRead?: Maybe<Scalars['Void']>;
  setMessagesRead?: Maybe<Scalars['Void']>;
  updateOnboardingSessionByUUID?: Maybe<UpdateOnboardingSessionByUuidPayload>;
  updateOnboardingSessionStartupByUUID?: Maybe<UpdateOnboardingSessionByUuidPayload>;
  updateOnboardingSessionCorporateByUUID?: Maybe<UpdateOnboardingSessionByUuidPayload>;
  completeOnboardingSessionByUUID?: Maybe<CompleteOnboardingSessionByUuidPayload>;
  createPaymentIntent: CreatePaymentIntentPayload;
  updatePassword?: Maybe<Scalars['Void']>;
  redeemStartConversationCode?: Maybe<RedeemStartConversationPayload>;
  userForgotPassword?: Maybe<ForgotPasswordResponse>;
  userResetPassword?: Maybe<Scalars['Void']>;
  setPassword?: Maybe<Scalars['Void']>;
  updateMyServiceCollaboration?: Maybe<Scalars['Void']>;
  submitInterests?: Maybe<Scalars['Void']>;
  addTechSolutionToStartupProfile?: Maybe<Scalars['Void']>;
  updateTechSolution?: Maybe<UpdateTechnologySolutionPayload>;
  useVerificationCode?: Maybe<UseVerificationPayload>;
  regenerateVerificationCode?: Maybe<Scalars['Void']>;
  addCount?: Maybe<ViewCounts>;
};


export type MutationUpdateApplicationConfigArgs = {
  input?: Maybe<UpdateApplicationConfigInput>;
};


export type MutationCreateBookmarkArgs = {
  input?: Maybe<CreateBookmarkInput>;
};


export type MutationUpdateBookmarkArgs = {
  input?: Maybe<UpdateBookmarkInput>;
};


export type MutationDeleteBookmarkArgs = {
  input?: Maybe<DeleteBookmarkInput>;
};


export type MutationCreateBusinessUseCaseArgs = {
  input?: Maybe<CreateBusinessUseCaseInput>;
};


export type MutationUpdateBusinessUseCaseArgs = {
  input?: Maybe<UpdateBusinessUseCaseInput>;
};


export type MutationDeleteBusinessUseCaseArgs = {
  input?: Maybe<DeleteBusinessUseCaseInput>;
};


export type MutationCreateCareerArgs = {
  input?: Maybe<CreateCareerInput>;
};


export type MutationUpdateCareerArgs = {
  input?: Maybe<UpdateCareerInput>;
};


export type MutationDeleteCareerArgs = {
  input?: Maybe<DeleteCareerInput>;
};


export type MutationCreateCatalystAllocationArgs = {
  input?: Maybe<CreateCatalystAllocationInput>;
};


export type MutationUpdateCatalystAllocationArgs = {
  input?: Maybe<UpdateCatalystAllocationInput>;
};


export type MutationDeleteCatalystAllocationArgs = {
  input?: Maybe<DeleteCatalystAllocationInput>;
};


export type MutationCreateCatalystConversationArgs = {
  input?: Maybe<CreateCatalystConversationInput>;
};


export type MutationUpdateCatalystConversationArgs = {
  input?: Maybe<UpdateCatalystConversationInput>;
};


export type MutationDeleteCatalystConversationArgs = {
  input?: Maybe<DeleteCatalystConversationInput>;
};


export type MutationCreateChatMessageArgs = {
  input?: Maybe<CreateChatMessageInput>;
};


export type MutationUpdateChatMessageArgs = {
  input?: Maybe<UpdateChatMessageInput>;
};


export type MutationDeleteChatMessageArgs = {
  input?: Maybe<DeleteChatMessageInput>;
};


export type MutationCreateChatArgs = {
  input?: Maybe<CreateChatInput>;
};


export type MutationUpdateChatArgs = {
  input?: Maybe<UpdateChatInput>;
};


export type MutationDeleteChatArgs = {
  input?: Maybe<DeleteChatInput>;
};


export type MutationCreateConversationMessageArgs = {
  input?: Maybe<CreateConversationMessageInput>;
};


export type MutationUpdateConversationMessageArgs = {
  input?: Maybe<UpdateConversationMessageInput>;
};


export type MutationDeleteConversationMessageArgs = {
  input?: Maybe<DeleteConversationMessageInput>;
};


export type MutationCreateConversationArgs = {
  input?: Maybe<CreateConversationInput>;
};


export type MutationUpdateConversationArgs = {
  input?: Maybe<UpdateConversationInput>;
};


export type MutationDeleteConversationArgs = {
  input?: Maybe<DeleteConversationInput>;
};


export type MutationCreateCorporateDepartmentArgs = {
  input?: Maybe<CreateCorporateDepartmentInput>;
};


export type MutationUpdateCorporateDepartmentArgs = {
  input?: Maybe<UpdateCorporateDepartmentInput>;
};


export type MutationDeleteCorporateDepartmentArgs = {
  input?: Maybe<DeleteCorporateDepartmentInput>;
};


export type MutationCreateCorporateArgs = {
  input?: Maybe<CreateCorporateInput>;
};


export type MutationUpdateCorporateArgs = {
  input?: Maybe<UpdateCorporateInput>;
};


export type MutationDeleteCorporateArgs = {
  input?: Maybe<DeleteCorporateInput>;
};


export type MutationCreateCountryArgs = {
  input?: Maybe<CreateCountryInput>;
};


export type MutationUpdateCountryArgs = {
  input?: Maybe<UpdateCountryInput>;
};


export type MutationDeleteCountryArgs = {
  input?: Maybe<DeleteCountryInput>;
};


export type MutationCreateCreditArgs = {
  input?: Maybe<CreateCreditInput>;
};


export type MutationUpdateCreditArgs = {
  input?: Maybe<UpdateCreditInput>;
};


export type MutationDeleteCreditArgs = {
  input?: Maybe<DeleteCreditInput>;
};


export type MutationCreateDocumentSharingArgs = {
  input?: Maybe<CreateDocumentSharingInput>;
};


export type MutationUpdateDocumentSharingArgs = {
  input?: Maybe<UpdateDocumentSharingInput>;
};


export type MutationDeleteDocumentSharingArgs = {
  input?: Maybe<DeleteDocumentSharingInput>;
};


export type MutationCreateEnquiryArgs = {
  input?: Maybe<CreateEnquiryInput>;
};


export type MutationUpdateEnquiryArgs = {
  input?: Maybe<UpdateEnquiryInput>;
};


export type MutationDeleteEnquiryArgs = {
  input?: Maybe<DeleteEnquiryInput>;
};


export type MutationCreateGoalArgs = {
  input?: Maybe<CreateGoalInput>;
};


export type MutationUpdateGoalArgs = {
  input?: Maybe<UpdateGoalInput>;
};


export type MutationDeleteGoalArgs = {
  input?: Maybe<DeleteGoalInput>;
};


export type MutationCreateImpactAreaArgs = {
  input?: Maybe<CreateImpactAreaInput>;
};


export type MutationUpdateImpactAreaArgs = {
  input?: Maybe<UpdateImpactAreaInput>;
};


export type MutationDeleteImpactAreaArgs = {
  input?: Maybe<DeleteImpactAreaInput>;
};


export type MutationCreateIndustryArgs = {
  input?: Maybe<CreateIndustryInput>;
};


export type MutationUpdateIndustryArgs = {
  input?: Maybe<UpdateIndustryInput>;
};


export type MutationDeleteIndustryArgs = {
  input?: Maybe<DeleteIndustryInput>;
};


export type MutationCreateJobPostingArgs = {
  input?: Maybe<CreateJobPostingInput>;
};


export type MutationUpdateJobPostingArgs = {
  input?: Maybe<UpdateJobPostingInput>;
};


export type MutationDeleteJobPostingArgs = {
  input?: Maybe<DeleteJobPostingInput>;
};


export type MutationCreateMatchMakingResultArgs = {
  input?: Maybe<CreateMatchMakingResultInput>;
};


export type MutationUpdateMatchMakingResultArgs = {
  input?: Maybe<UpdateMatchMakingResultInput>;
};


export type MutationDeleteMatchMakingResultArgs = {
  input?: Maybe<DeleteMatchMakingResultInput>;
};


export type MutationCreateMaturityLevelArgs = {
  input?: Maybe<CreateMaturityLevelInput>;
};


export type MutationUpdateMaturityLevelArgs = {
  input?: Maybe<UpdateMaturityLevelInput>;
};


export type MutationDeleteMaturityLevelArgs = {
  input?: Maybe<DeleteMaturityLevelInput>;
};


export type MutationCreateNewsArticleArgs = {
  input?: Maybe<CreateNewsArticleInput>;
};


export type MutationUpdateNewsArticleArgs = {
  input?: Maybe<UpdateNewsArticleInput>;
};


export type MutationDeleteNewsArticleArgs = {
  input?: Maybe<DeleteNewsArticleInput>;
};


export type MutationCreateNotificationPreferenceArgs = {
  input?: Maybe<CreateNotificationPreferenceInput>;
};


export type MutationUpdateNotificationPreferenceArgs = {
  input?: Maybe<UpdateNotificationPreferenceInput>;
};


export type MutationDeleteNotificationPreferenceArgs = {
  input?: Maybe<DeleteNotificationPreferenceInput>;
};


export type MutationCreateOnBoardingSessionArgs = {
  input?: Maybe<CreateOnBoardingSessionInput>;
};


export type MutationUpdateOnBoardingSessionArgs = {
  input?: Maybe<UpdateOnBoardingSessionInput>;
};


export type MutationDeleteOnBoardingSessionArgs = {
  input?: Maybe<DeleteOnBoardingSessionInput>;
};


export type MutationCreatePersonProfileArgs = {
  input?: Maybe<CreatePersonProfileInput>;
};


export type MutationUpdatePersonProfileArgs = {
  input?: Maybe<UpdatePersonProfileInput>;
};


export type MutationDeletePersonProfileArgs = {
  input?: Maybe<DeletePersonProfileInput>;
};


export type MutationCreatePricingModelArgs = {
  input?: Maybe<CreatePricingModelInput>;
};


export type MutationUpdatePricingModelArgs = {
  input?: Maybe<UpdatePricingModelInput>;
};


export type MutationDeletePricingModelArgs = {
  input?: Maybe<DeletePricingModelInput>;
};


export type MutationCreatePromoCodeConversationArgs = {
  input?: Maybe<CreatePromoCodeConversationInput>;
};


export type MutationUpdatePromoCodeConversationArgs = {
  input?: Maybe<UpdatePromoCodeConversationInput>;
};


export type MutationDeletePromoCodeConversationArgs = {
  input?: Maybe<DeletePromoCodeConversationInput>;
};


export type MutationCreatePromoCodeRedemptionArgs = {
  input?: Maybe<CreatePromoCodeRedemptionInput>;
};


export type MutationUpdatePromoCodeRedemptionArgs = {
  input?: Maybe<UpdatePromoCodeRedemptionInput>;
};


export type MutationDeletePromoCodeRedemptionArgs = {
  input?: Maybe<DeletePromoCodeRedemptionInput>;
};


export type MutationCreatePromoCodeArgs = {
  input?: Maybe<CreatePromoCodeInput>;
};


export type MutationUpdatePromoCodeArgs = {
  input?: Maybe<UpdatePromoCodeInput>;
};


export type MutationDeletePromoCodeArgs = {
  input?: Maybe<DeletePromoCodeInput>;
};


export type MutationCreatePurchasedServiceArgs = {
  input?: Maybe<CreatePurchasedServiceInput>;
};


export type MutationUpdatePurchasedServiceArgs = {
  input?: Maybe<UpdatePurchasedServiceInput>;
};


export type MutationDeletePurchasedServiceArgs = {
  input?: Maybe<DeletePurchasedServiceInput>;
};


export type MutationCreatePurchasedSubscriptionArgs = {
  input?: Maybe<CreatePurchasedSubscriptionInput>;
};


export type MutationUpdatePurchasedSubscriptionArgs = {
  input?: Maybe<UpdatePurchasedSubscriptionInput>;
};


export type MutationDeletePurchasedSubscriptionArgs = {
  input?: Maybe<DeletePurchasedSubscriptionInput>;
};


export type MutationCreateRatingArgs = {
  input?: Maybe<CreateRatingInput>;
};


export type MutationUpdateRatingArgs = {
  input?: Maybe<UpdateRatingInput>;
};


export type MutationDeleteRatingArgs = {
  input?: Maybe<DeleteRatingInput>;
};


export type MutationCreateRegionServicePriceArgs = {
  input?: Maybe<CreateRegionServicePriceInput>;
};


export type MutationUpdateRegionServicePriceArgs = {
  input?: Maybe<UpdateRegionServicePriceInput>;
};


export type MutationDeleteRegionServicePriceArgs = {
  input?: Maybe<DeleteRegionServicePriceInput>;
};


export type MutationCreateRegionArgs = {
  input?: Maybe<CreateRegionInput>;
};


export type MutationUpdateRegionArgs = {
  input?: Maybe<UpdateRegionInput>;
};


export type MutationDeleteRegionArgs = {
  input?: Maybe<DeleteRegionInput>;
};


export type MutationCreateSdgObjectiveArgs = {
  input?: Maybe<CreateSdgObjectiveInput>;
};


export type MutationUpdateSdgObjectiveArgs = {
  input?: Maybe<UpdateSdgObjectiveInput>;
};


export type MutationDeleteSdgObjectiveArgs = {
  input?: Maybe<DeleteSdgObjectiveInput>;
};


export type MutationCreateServiceCollaborationArgs = {
  input?: Maybe<CreateServiceCollaborationInput>;
};


export type MutationUpdateServiceCollaborationArgs = {
  input?: Maybe<UpdateServiceCollaborationInput>;
};


export type MutationDeleteServiceCollaborationArgs = {
  input?: Maybe<DeleteServiceCollaborationInput>;
};


export type MutationCreateServicePackageArgs = {
  input?: Maybe<CreateServicePackageInput>;
};


export type MutationUpdateServicePackageArgs = {
  input?: Maybe<UpdateServicePackageInput>;
};


export type MutationDeleteServicePackageArgs = {
  input?: Maybe<DeleteServicePackageInput>;
};


export type MutationCreateServicesInterestArgs = {
  input?: Maybe<CreateServicesInterestInput>;
};


export type MutationUpdateServicesInterestArgs = {
  input?: Maybe<UpdateServicesInterestInput>;
};


export type MutationDeleteServicesInterestArgs = {
  input?: Maybe<DeleteServicesInterestInput>;
};


export type MutationCreateServiceArgs = {
  input?: Maybe<CreateServiceInput>;
};


export type MutationUpdateServiceArgs = {
  input?: Maybe<UpdateServiceInput>;
};


export type MutationDeleteServiceArgs = {
  input?: Maybe<DeleteServiceInput>;
};


export type MutationUpdateStartConversationTermsConditionArgs = {
  input?: Maybe<UpdateStartConversationTermsConditionInput>;
};


export type MutationCreateStartupProfileArgs = {
  input?: Maybe<CreateStartupProfileInput>;
};


export type MutationUpdateStartupProfileArgs = {
  input?: Maybe<UpdateStartupProfileInput>;
};


export type MutationDeleteStartupProfileArgs = {
  input?: Maybe<DeleteStartupProfileInput>;
};


export type MutationCreateTechnologyReadinessLevelArgs = {
  input?: Maybe<CreateTechnologyReadinessLevelInput>;
};


export type MutationUpdateTechnologyReadinessLevelArgs = {
  input?: Maybe<UpdateTechnologyReadinessLevelInput>;
};


export type MutationDeleteTechnologyReadinessLevelArgs = {
  input?: Maybe<DeleteTechnologyReadinessLevelInput>;
};


export type MutationCreateTechnologyRequestArgs = {
  input?: Maybe<CreateTechnologyRequestInput>;
};


export type MutationUpdateTechnologyRequestArgs = {
  input?: Maybe<UpdateTechnologyRequestInput>;
};


export type MutationDeleteTechnologyRequestArgs = {
  input?: Maybe<DeleteTechnologyRequestInput>;
};


export type MutationCreateTechnologySolutionArgs = {
  input?: Maybe<CreateTechnologySolutionInput>;
};


export type MutationUpdateTechnologySolutionArgs = {
  input?: Maybe<UpdateTechnologySolutionInput>;
};


export type MutationDeleteTechnologySolutionArgs = {
  input?: Maybe<DeleteTechnologySolutionInput>;
};


export type MutationCreateTechnologyTypeArgs = {
  input?: Maybe<CreateTechnologyTypeInput>;
};


export type MutationUpdateTechnologyTypeArgs = {
  input?: Maybe<UpdateTechnologyTypeInput>;
};


export type MutationDeleteTechnologyTypeArgs = {
  input?: Maybe<DeleteTechnologyTypeInput>;
};


export type MutationCreateTransactionArgs = {
  input?: Maybe<CreateTransactionInput>;
};


export type MutationUpdateTransactionArgs = {
  input?: Maybe<UpdateTransactionInput>;
};


export type MutationDeleteTransactionArgs = {
  input?: Maybe<DeleteTransactionInput>;
};


export type MutationCreateUserSubmittedGoalArgs = {
  input?: Maybe<CreateUserSubmittedGoalInput>;
};


export type MutationUpdateUserSubmittedGoalArgs = {
  input?: Maybe<UpdateUserSubmittedGoalInput>;
};


export type MutationDeleteUserSubmittedGoalArgs = {
  input?: Maybe<DeleteUserSubmittedGoalInput>;
};


export type MutationCreateVerificationActionArgs = {
  input?: Maybe<CreateVerificationActionInput>;
};


export type MutationUpdateVerificationActionArgs = {
  input?: Maybe<UpdateVerificationActionInput>;
};


export type MutationDeleteVerificationActionArgs = {
  input?: Maybe<DeleteVerificationActionInput>;
};


export type MutationCreateViewCountArgs = {
  input?: Maybe<CreateViewCountInput>;
};


export type MutationUpdateViewCountArgs = {
  input?: Maybe<UpdateViewCountInput>;
};


export type MutationDeleteViewCountArgs = {
  input?: Maybe<DeleteViewCountInput>;
};


export type MutationDeleteFileArgs = {
  input?: Maybe<DeleteFileInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  info?: Maybe<FileInfoInput>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationSendChatMessageArgs = {
  input?: Maybe<SendMessageInput>;
};


export type MutationAgreeConversationNdaArgs = {
  id: Scalars['ID'];
};


export type MutationMakeConversationAgreementPdfArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateAgreementArgs = {
  id: Scalars['ID'];
  agreement: ConversationAgreementInput;
};


export type MutationStartConversationArgs = {
  input: StartConversationInput;
};


export type MutationUpdateConversationByRoleArgs = {
  id: Scalars['ID'];
  input: EditConversationInput;
};


export type MutationAddTechnologyRequestToCorporateProfileArgs = {
  input?: Maybe<CreateTechnologyRequestInput>;
};


export type MutationDeductCreditStartConversationArgs = {
  input?: Maybe<DeductCreditStartConversationInput>;
};


export type MutationSendContactArgs = {
  input?: Maybe<CreateEnquiryInput>;
};


export type MutationRefreshMatchesArgs = {
  input?: Maybe<RefreshMatchesInput>;
};


export type MutationSetCurrentUserNotificationsArgs = {
  input: SettingsInput;
};


export type MutationCreateNotificationArgs = {
  input: NotificationMessageInput;
};


export type MutationSetCurrentUserMessageReadArgs = {
  id: Scalars['String'];
};


export type MutationSetMessagesReadArgs = {
  input?: Maybe<SetMessagesReadInput>;
};


export type MutationUpdateOnboardingSessionByUuidArgs = {
  input?: Maybe<UpdateOnboardingSessionByUuidInput>;
};


export type MutationUpdateOnboardingSessionStartupByUuidArgs = {
  input?: Maybe<OnboardingSessionStartupBody>;
};


export type MutationUpdateOnboardingSessionCorporateByUuidArgs = {
  input?: Maybe<OnboardingSessionCorporateBody>;
};


export type MutationCompleteOnboardingSessionByUuidArgs = {
  uuid: Scalars['String'];
};


export type MutationCreatePaymentIntentArgs = {
  input?: Maybe<CreatePaymentIntent>;
};


export type MutationUpdatePasswordArgs = {
  password?: Maybe<Scalars['String']>;
};


export type MutationRedeemStartConversationCodeArgs = {
  input: RedeemStartConversationInput;
};


export type MutationUserForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationUserResetPasswordArgs = {
  input?: Maybe<ResetPasswordInput>;
};


export type MutationSetPasswordArgs = {
  password: Scalars['String'];
};


export type MutationUpdateMyServiceCollaborationArgs = {
  input: UpdateMyServiceCollaborationInput;
};


export type MutationSubmitInterestsArgs = {
  input?: Maybe<SubmitInterestInput>;
};


export type MutationAddTechSolutionToStartupProfileArgs = {
  input?: Maybe<CreateTechnologySolutionInput>;
};


export type MutationUpdateTechSolutionArgs = {
  input?: Maybe<UpdateTechnologySolutionInput>;
};


export type MutationUseVerificationCodeArgs = {
  code: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationRegenerateVerificationCodeArgs = {
  uuid: Scalars['String'];
};


export type MutationAddCountArgs = {
  article_id: Scalars['String'];
};

export type MyCorporateProfile = {
  __typename?: 'MyCorporateProfile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  country?: Maybe<Scalars['String']>;
  avatar?: Maybe<UploadFile>;
  psuedo_name?: Maybe<Scalars['String']>;
  country_jurisdiction?: Maybe<Scalars['String']>;
  employee_count_range?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  worked_with_startups?: Maybe<Scalars['Boolean']>;
  links?: Maybe<ComponentGenericLinks>;
  person_profiles?: Maybe<Array<Maybe<PersonProfile>>>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  technology_requests?: Maybe<Array<Maybe<TechnologyRequest>>>;
  esg_rating?: Maybe<Scalars['String']>;
};


export type MyCorporateProfilePerson_ProfilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateProfileIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateProfileTechnology_RequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type MyCorporateTechnologyRequest = {
  __typename?: 'MyCorporateTechnologyRequest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  has_ip?: Maybe<Scalars['Boolean']>;
  can_whitelabel?: Maybe<Scalars['Boolean']>;
  want_poc?: Maybe<Scalars['Boolean']>;
  want_seller?: Maybe<Scalars['Boolean']>;
  want_lease?: Maybe<Scalars['Boolean']>;
  has_api?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  budget_min?: Maybe<Scalars['Float']>;
  budget_max?: Maybe<Scalars['Float']>;
  budget_is_disclose?: Maybe<Scalars['Boolean']>;
  business_challange_description?: Maybe<Scalars['String']>;
  projected_startdate?: Maybe<Scalars['Date']>;
  projected_complete_date?: Maybe<Scalars['Date']>;
  country_implementation?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  business_type?: Maybe<Scalars['String']>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_others?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
  other_tech_option?: Maybe<Scalars['String']>;
  description_project?: Maybe<Scalars['String']>;
  description_how_to_resolve_problem?: Maybe<Scalars['String']>;
  description_customer?: Maybe<Scalars['String']>;
  description_successful_outcome?: Maybe<Scalars['String']>;
  description_similiar_solutions?: Maybe<Scalars['String']>;
  description_risk_challenges?: Maybe<Scalars['String']>;
  want_explore?: Maybe<Scalars['Boolean']>;
  budget_is_poc?: Maybe<Scalars['Boolean']>;
  budget_is_lease?: Maybe<Scalars['Boolean']>;
  hero_image?: Maybe<UploadFile>;
  is_published?: Maybe<Scalars['Boolean']>;
  budget_is_buy?: Maybe<Scalars['Boolean']>;
  impact_level?: Maybe<Scalars['String']>;
  project_budget?: Maybe<Array<Maybe<ComponentTechnologySolutionProjectBudget>>>;
  impact_area?: Maybe<ImpactArea>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  want_investment?: Maybe<Scalars['Boolean']>;
  is_others?: Maybe<Scalars['String']>;
  corporate_profile?: Maybe<Corporate>;
  is_match_triggered?: Maybe<Scalars['Boolean']>;
  want_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  technology_types?: Maybe<Array<Maybe<TechnologyType>>>;
  business_use_cases?: Maybe<Array<Maybe<BusinessUseCase>>>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  corporate_departments?: Maybe<Array<Maybe<CorporateDepartment>>>;
  specification_files?: Maybe<Array<Maybe<UploadFile>>>;
  goals?: Maybe<Array<Maybe<Goals>>>;
  conversations?: Maybe<Array<Maybe<Conversations>>>;
  matched_result_count: Scalars['Int'];
  is_completed?: Maybe<Scalars['Boolean']>;
  sdg_objectives?: Maybe<Array<Maybe<SdgObjectives>>>;
};


export type MyCorporateTechnologyRequestTechnology_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateTechnologyRequestBusiness_Use_CasesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateTechnologyRequestIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateTechnologyRequestCorporate_DepartmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateTechnologyRequestSpecification_FilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateTechnologyRequestGoalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateTechnologyRequestConversationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyCorporateTechnologyRequestSdg_ObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type MyProfile = {
  __typename?: 'MyProfile';
  person?: Maybe<PersonProfile>;
  organisation_id?: Maybe<Scalars['ID']>;
  region_currency?: Maybe<Scalars['String']>;
};

export type MyStartupProfile = {
  __typename?: 'MyStartupProfile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  avatar?: Maybe<UploadFile>;
  psuedo_name?: Maybe<Scalars['String']>;
  operating_locations?: Maybe<Scalars['String']>;
  employee_count?: Maybe<Scalars['Int']>;
  links?: Maybe<ComponentGenericLinks>;
  worked_with_corporates?: Maybe<Scalars['Boolean']>;
  clients?: Maybe<Scalars['String']>;
  incubators_accelerators?: Maybe<Scalars['String']>;
  investment_received?: Maybe<Scalars['Long']>;
  maturity_level?: Maybe<MaturityLevel>;
  rating?: Maybe<Scalars['Float']>;
  investment_stage?: Maybe<Scalars['String']>;
  client_count?: Maybe<Scalars['Int']>;
  employee_count_range?: Maybe<Scalars['String']>;
  went_incubator_accelerator?: Maybe<Scalars['Boolean']>;
  investment_received_currency?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  person_profiles?: Maybe<Array<Maybe<PersonProfile>>>;
  technology_solutions?: Maybe<Array<Maybe<TechnologySolution>>>;
  catalyst_allocations?: Maybe<Array<Maybe<CatalystAllocation>>>;
  esg_rating?: Maybe<Scalars['String']>;
};


export type MyStartupProfileIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyStartupProfilePerson_ProfilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyStartupProfileTechnology_SolutionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MyStartupProfileCatalyst_AllocationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type NewsArticle = {
  __typename?: 'NewsArticle';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  headline?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  main_image?: Maybe<UploadFile>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type NewsArticleAggregator = {
  __typename?: 'NewsArticleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NewsArticleConnection = {
  __typename?: 'NewsArticleConnection';
  values?: Maybe<Array<Maybe<NewsArticle>>>;
  groupBy?: Maybe<NewsArticleGroupBy>;
  aggregate?: Maybe<NewsArticleAggregator>;
};

export type NewsArticleConnectionBody = {
  __typename?: 'NewsArticleConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NewsArticleConnection>;
};

export type NewsArticleConnectionCreated_At = {
  __typename?: 'NewsArticleConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NewsArticleConnection>;
};

export type NewsArticleConnectionHeadline = {
  __typename?: 'NewsArticleConnectionHeadline';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NewsArticleConnection>;
};

export type NewsArticleConnectionId = {
  __typename?: 'NewsArticleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NewsArticleConnection>;
};

export type NewsArticleConnectionMain_Image = {
  __typename?: 'NewsArticleConnectionMain_image';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NewsArticleConnection>;
};

export type NewsArticleConnectionPublished_At = {
  __typename?: 'NewsArticleConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NewsArticleConnection>;
};

export type NewsArticleConnectionSummary = {
  __typename?: 'NewsArticleConnectionSummary';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NewsArticleConnection>;
};

export type NewsArticleConnectionUpdated_At = {
  __typename?: 'NewsArticleConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NewsArticleConnection>;
};

export type NewsArticleGroupBy = {
  __typename?: 'NewsArticleGroupBy';
  id?: Maybe<Array<Maybe<NewsArticleConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NewsArticleConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NewsArticleConnectionUpdated_At>>>;
  headline?: Maybe<Array<Maybe<NewsArticleConnectionHeadline>>>;
  body?: Maybe<Array<Maybe<NewsArticleConnectionBody>>>;
  summary?: Maybe<Array<Maybe<NewsArticleConnectionSummary>>>;
  main_image?: Maybe<Array<Maybe<NewsArticleConnectionMain_Image>>>;
  published_at?: Maybe<Array<Maybe<NewsArticleConnectionPublished_At>>>;
};

export type NewsArticleInput = {
  headline?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  main_image?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type NotificationMessageInput = {
  topic: Scalars['String'];
  subTopic: Scalars['String'];
  subject: Scalars['String'];
  body: Scalars['String'];
  audience?: Maybe<Array<Scalars['String']>>;
};

export type NotificationPreferenceInput = {
  team_notifications?: Maybe<Scalars['String']>;
  platform_notifications?: Maybe<Scalars['String']>;
  potential_partner?: Maybe<Scalars['String']>;
  partner_collaboration?: Maybe<Scalars['String']>;
  chat?: Maybe<Scalars['String']>;
  activity?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  team_notifications?: Maybe<Scalars['String']>;
  platform_notifications?: Maybe<Scalars['String']>;
  potential_partner?: Maybe<Scalars['String']>;
  partner_collaboration?: Maybe<Scalars['String']>;
  chat?: Maybe<Scalars['String']>;
  activity?: Maybe<Scalars['String']>;
};

export type NotificationPreferencesAggregator = {
  __typename?: 'NotificationPreferencesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NotificationPreferencesConnection = {
  __typename?: 'NotificationPreferencesConnection';
  values?: Maybe<Array<Maybe<NotificationPreferences>>>;
  groupBy?: Maybe<NotificationPreferencesGroupBy>;
  aggregate?: Maybe<NotificationPreferencesAggregator>;
};

export type NotificationPreferencesConnectionActivity = {
  __typename?: 'NotificationPreferencesConnectionActivity';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesConnectionChat = {
  __typename?: 'NotificationPreferencesConnectionChat';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesConnectionCreated_At = {
  __typename?: 'NotificationPreferencesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesConnectionId = {
  __typename?: 'NotificationPreferencesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesConnectionPartner_Collaboration = {
  __typename?: 'NotificationPreferencesConnectionPartner_collaboration';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesConnectionPlatform_Notifications = {
  __typename?: 'NotificationPreferencesConnectionPlatform_notifications';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesConnectionPotential_Partner = {
  __typename?: 'NotificationPreferencesConnectionPotential_partner';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesConnectionTeam_Notifications = {
  __typename?: 'NotificationPreferencesConnectionTeam_notifications';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesConnectionUpdated_At = {
  __typename?: 'NotificationPreferencesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotificationPreferencesConnection>;
};

export type NotificationPreferencesGroupBy = {
  __typename?: 'NotificationPreferencesGroupBy';
  id?: Maybe<Array<Maybe<NotificationPreferencesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NotificationPreferencesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NotificationPreferencesConnectionUpdated_At>>>;
  team_notifications?: Maybe<Array<Maybe<NotificationPreferencesConnectionTeam_Notifications>>>;
  platform_notifications?: Maybe<Array<Maybe<NotificationPreferencesConnectionPlatform_Notifications>>>;
  potential_partner?: Maybe<Array<Maybe<NotificationPreferencesConnectionPotential_Partner>>>;
  partner_collaboration?: Maybe<Array<Maybe<NotificationPreferencesConnectionPartner_Collaboration>>>;
  chat?: Maybe<Array<Maybe<NotificationPreferencesConnectionChat>>>;
  activity?: Maybe<Array<Maybe<NotificationPreferencesConnectionActivity>>>;
};

export type OnBoardingSession = {
  __typename?: 'OnBoardingSession';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  payload?: Maybe<Scalars['JSON']>;
  uuid?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
};

export type OnBoardingSessionAggregator = {
  __typename?: 'OnBoardingSessionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OnBoardingSessionConnection = {
  __typename?: 'OnBoardingSessionConnection';
  values?: Maybe<Array<Maybe<OnBoardingSession>>>;
  groupBy?: Maybe<OnBoardingSessionGroupBy>;
  aggregate?: Maybe<OnBoardingSessionAggregator>;
};

export type OnBoardingSessionConnectionCompleted = {
  __typename?: 'OnBoardingSessionConnectionCompleted';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<OnBoardingSessionConnection>;
};

export type OnBoardingSessionConnectionCreated_At = {
  __typename?: 'OnBoardingSessionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OnBoardingSessionConnection>;
};

export type OnBoardingSessionConnectionId = {
  __typename?: 'OnBoardingSessionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OnBoardingSessionConnection>;
};

export type OnBoardingSessionConnectionPayload = {
  __typename?: 'OnBoardingSessionConnectionPayload';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<OnBoardingSessionConnection>;
};

export type OnBoardingSessionConnectionUpdated_At = {
  __typename?: 'OnBoardingSessionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OnBoardingSessionConnection>;
};

export type OnBoardingSessionConnectionUuid = {
  __typename?: 'OnBoardingSessionConnectionUuid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OnBoardingSessionConnection>;
};

export type OnBoardingSessionGroupBy = {
  __typename?: 'OnBoardingSessionGroupBy';
  id?: Maybe<Array<Maybe<OnBoardingSessionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<OnBoardingSessionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<OnBoardingSessionConnectionUpdated_At>>>;
  payload?: Maybe<Array<Maybe<OnBoardingSessionConnectionPayload>>>;
  uuid?: Maybe<Array<Maybe<OnBoardingSessionConnectionUuid>>>;
  completed?: Maybe<Array<Maybe<OnBoardingSessionConnectionCompleted>>>;
};

export type OnBoardingSessionInput = {
  payload?: Maybe<Scalars['JSON']>;
  uuid?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type OnboardingSessionCorporateBody = {
  uuid?: Maybe<Scalars['String']>;
  payload?: Maybe<OnboardingSessionCorporatePayloadInput>;
};

export type OnboardingSessionCorporatePayloadInput = {
  type?: Maybe<Scalars['String']>;
  user?: Maybe<OnboardingSessionPayload_User>;
  personProfile?: Maybe<OnboardingSessionCorporate_PersonProfile>;
  requests?: Maybe<OnboardingSessionCorporate_Requests>;
  technologyRequest?: Maybe<OnboardingSessionCorporate_TechnologyRequest>;
  corporateProfile?: Maybe<OnboardingSessionCorporate_CorporateProfile>;
  step?: Maybe<Scalars['Int']>;
};

export type OnboardingSessionCorporate_CorporateProfile = {
  name?: Maybe<Scalars['String']>;
  country_jurisdiction?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Scalars['Int']>>>;
  employee_count_range?: Maybe<Scalars['String']>;
  logo?: Maybe<ImageAttachment>;
  country?: Maybe<Scalars['String']>;
  esg_rating?: Maybe<Scalars['String']>;
};

export type OnboardingSessionCorporate_PersonProfile = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  corporate_department?: Maybe<Scalars['Int']>;
  contact_number?: Maybe<Scalars['String']>;
  photo?: Maybe<ImageAttachment>;
  role?: Maybe<Scalars['String']>;
  is_decisionmaker?: Maybe<Scalars['Boolean']>;
  is_decision_influencer?: Maybe<Scalars['Boolean']>;
  decision_role_type?: Maybe<Scalars['String']>;
  profile_type?: Maybe<Enum_Personprofile_Profile_Type>;
};

export type OnboardingSessionCorporate_Requests = {
  want_poc?: Maybe<Scalars['Boolean']>;
  want_lease?: Maybe<Scalars['Boolean']>;
  want_seller?: Maybe<Scalars['Boolean']>;
  want_explore?: Maybe<Scalars['Boolean']>;
  want_investment?: Maybe<Scalars['Boolean']>;
  want_access_alkelio_services?: Maybe<Scalars['Boolean']>;
};

export type OnboardingSessionCorporate_TechnologyRequest = {
  name?: Maybe<Scalars['String']>;
  description_project?: Maybe<Scalars['String']>;
  business_challange_description?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<Scalars['Int']>>>;
  has_api?: Maybe<Scalars['Boolean']>;
  has_ip?: Maybe<Scalars['Boolean']>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  can_whitelabel?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  is_others?: Maybe<Scalars['String']>;
  technology_solution_model_b2b?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_others?: Maybe<Scalars['String']>;
  impact_level?: Maybe<Scalars['String']>;
  impact_area?: Maybe<Scalars['Int']>;
  business_use_cases?: Maybe<Array<Maybe<Scalars['Int']>>>;
  technology_types?: Maybe<Array<Maybe<Scalars['Int']>>>;
  project_budget?: Maybe<Array<Maybe<OnboardingSessionCorporate_TechnologyRequest_Budget>>>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type OnboardingSessionCorporate_TechnologyRequest_Budget = {
  max_budget?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  option?: Maybe<Scalars['String']>;
};

export type OnboardingSessionPayload_User = {
  email?: Maybe<Scalars['String']>;
};

export type OnboardingSessionStartupBody = {
  uuid?: Maybe<Scalars['String']>;
  payload?: Maybe<OnboardingSessionStartupPayloadInput>;
};

export type OnboardingSessionStartupPayloadInput = {
  type?: Maybe<Scalars['String']>;
  user?: Maybe<OnboardingSessionPayload_User>;
  personProfile?: Maybe<OnboardingSessionStartup_PersonProfile>;
  requests?: Maybe<OnboardingSessionStartup_Requests>;
  technologySolution?: Maybe<OnboardingSessionStartup_TechnologySolution>;
  startupProfile?: Maybe<OnboardingSessionStartup_StartupProfile>;
  step?: Maybe<Scalars['Int']>;
};

export type OnboardingSessionStartup_PersonProfile = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  contact_number?: Maybe<Scalars['String']>;
  photo?: Maybe<ImageAttachment>;
  role?: Maybe<Scalars['String']>;
  profile_type?: Maybe<Enum_Personprofile_Profile_Type>;
};

export type OnboardingSessionStartup_Requests = {
  purpose_poc?: Maybe<Scalars['Boolean']>;
  purpose_lease?: Maybe<Scalars['Boolean']>;
  purpose_sell?: Maybe<Scalars['Boolean']>;
  purpose_investment?: Maybe<Scalars['Boolean']>;
  purpose_certify?: Maybe<Scalars['Boolean']>;
  purpose_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  purpose_explore?: Maybe<Scalars['Boolean']>;
};

export type OnboardingSessionStartup_StartupProfile = {
  name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Scalars['Int']>>>;
  start_date?: Maybe<Scalars['Date']>;
  client_count?: Maybe<Scalars['Int']>;
  employee_count?: Maybe<Scalars['Int']>;
  logo?: Maybe<ImageAttachment>;
  operating_locations?: Maybe<Scalars['String']>;
  maturity_level?: Maybe<Scalars['Int']>;
  went_incubator_accelerator?: Maybe<Scalars['Boolean']>;
  investment_received?: Maybe<Scalars['Int']>;
  investment_received_currency?: Maybe<Scalars['String']>;
  esg_rating?: Maybe<Scalars['String']>;
};

export type OnboardingSessionStartup_TechnologySolution = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  has_api?: Maybe<Scalars['Boolean']>;
  has_ip?: Maybe<Scalars['Boolean']>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_whitelabel?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  spin_off_source?: Maybe<Scalars['String']>;
  technology_readiness?: Maybe<Scalars['String']>;
  technology_types?: Maybe<Array<Maybe<Scalars['Int']>>>;
  business_use_cases?: Maybe<Array<Maybe<Scalars['Int']>>>;
  industries?: Maybe<Array<Maybe<Scalars['Int']>>>;
  corporate_departments?: Maybe<Array<Maybe<Scalars['Int']>>>;
  technology_solution_pricing_model?: Maybe<Array<Maybe<OnboardingSessionStartup_TechnologySolution_PricingModels>>>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type OnboardingSessionStartup_TechnologySolution_PricingModels = {
  pricing_model?: Maybe<Scalars['Int']>;
  min_budget?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  option?: Maybe<Scalars['String']>;
};

export type PagedMessages = {
  __typename?: 'PagedMessages';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
  result?: Maybe<Array<MessageWithUser>>;
};

export type PaymentItem = {
  itemId: Scalars['String'];
  type: PaymentItemType;
  quantity: Scalars['Int'];
};

export enum PaymentItemType {
  Credit = 'CREDIT',
  Service = 'SERVICE'
}

export type PersonProfile = {
  __typename?: 'PersonProfile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  corporate_department?: Maybe<CorporateDepartment>;
  contact_number?: Maybe<Scalars['String']>;
  is_decisionmaker?: Maybe<Scalars['Boolean']>;
  photo?: Maybe<UploadFile>;
  role?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  is_decision_influencer?: Maybe<Scalars['Boolean']>;
  decision_role_type?: Maybe<Scalars['String']>;
  profile_type?: Maybe<Enum_Personprofile_Profile_Type>;
  industry_interests?: Maybe<Array<Maybe<Industry>>>;
  bookmarks?: Maybe<Array<Maybe<Bookmark>>>;
};


export type PersonProfileIndustry_InterestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type PersonProfileBookmarksArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PersonProfileAggregator = {
  __typename?: 'PersonProfileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PersonProfileConnection = {
  __typename?: 'PersonProfileConnection';
  values?: Maybe<Array<Maybe<PersonProfile>>>;
  groupBy?: Maybe<PersonProfileGroupBy>;
  aggregate?: Maybe<PersonProfileAggregator>;
};

export type PersonProfileConnectionContact_Number = {
  __typename?: 'PersonProfileConnectionContact_number';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionCorporate_Department = {
  __typename?: 'PersonProfileConnectionCorporate_department';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionCreated_At = {
  __typename?: 'PersonProfileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionDecision_Role_Type = {
  __typename?: 'PersonProfileConnectionDecision_role_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionFirst_Name = {
  __typename?: 'PersonProfileConnectionFirst_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionId = {
  __typename?: 'PersonProfileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionIs_Decision_Influencer = {
  __typename?: 'PersonProfileConnectionIs_decision_influencer';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionIs_Decisionmaker = {
  __typename?: 'PersonProfileConnectionIs_decisionmaker';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionLast_Name = {
  __typename?: 'PersonProfileConnectionLast_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionPhoto = {
  __typename?: 'PersonProfileConnectionPhoto';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionProfile_Type = {
  __typename?: 'PersonProfileConnectionProfile_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionRole = {
  __typename?: 'PersonProfileConnectionRole';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionUpdated_At = {
  __typename?: 'PersonProfileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileConnectionUser = {
  __typename?: 'PersonProfileConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PersonProfileConnection>;
};

export type PersonProfileGroupBy = {
  __typename?: 'PersonProfileGroupBy';
  id?: Maybe<Array<Maybe<PersonProfileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PersonProfileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PersonProfileConnectionUpdated_At>>>;
  first_name?: Maybe<Array<Maybe<PersonProfileConnectionFirst_Name>>>;
  last_name?: Maybe<Array<Maybe<PersonProfileConnectionLast_Name>>>;
  corporate_department?: Maybe<Array<Maybe<PersonProfileConnectionCorporate_Department>>>;
  contact_number?: Maybe<Array<Maybe<PersonProfileConnectionContact_Number>>>;
  is_decisionmaker?: Maybe<Array<Maybe<PersonProfileConnectionIs_Decisionmaker>>>;
  photo?: Maybe<Array<Maybe<PersonProfileConnectionPhoto>>>;
  role?: Maybe<Array<Maybe<PersonProfileConnectionRole>>>;
  user?: Maybe<Array<Maybe<PersonProfileConnectionUser>>>;
  is_decision_influencer?: Maybe<Array<Maybe<PersonProfileConnectionIs_Decision_Influencer>>>;
  decision_role_type?: Maybe<Array<Maybe<PersonProfileConnectionDecision_Role_Type>>>;
  profile_type?: Maybe<Array<Maybe<PersonProfileConnectionProfile_Type>>>;
};

export type PersonProfileInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  corporate_department?: Maybe<Scalars['ID']>;
  contact_number?: Maybe<Scalars['String']>;
  is_decisionmaker?: Maybe<Scalars['Boolean']>;
  photo?: Maybe<Scalars['ID']>;
  role?: Maybe<Scalars['String']>;
  industry_interests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user?: Maybe<Scalars['ID']>;
  is_decision_influencer?: Maybe<Scalars['Boolean']>;
  decision_role_type?: Maybe<Scalars['String']>;
  profile_type?: Maybe<Enum_Personprofile_Profile_Type>;
  bookmarks?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PricingModel = {
  __typename?: 'PricingModel';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type PricingModelAggregator = {
  __typename?: 'PricingModelAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PricingModelConnection = {
  __typename?: 'PricingModelConnection';
  values?: Maybe<Array<Maybe<PricingModel>>>;
  groupBy?: Maybe<PricingModelGroupBy>;
  aggregate?: Maybe<PricingModelAggregator>;
};

export type PricingModelConnectionCreated_At = {
  __typename?: 'PricingModelConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PricingModelConnection>;
};

export type PricingModelConnectionId = {
  __typename?: 'PricingModelConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PricingModelConnection>;
};

export type PricingModelConnectionName = {
  __typename?: 'PricingModelConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PricingModelConnection>;
};

export type PricingModelConnectionUpdated_At = {
  __typename?: 'PricingModelConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PricingModelConnection>;
};

export type PricingModelGroupBy = {
  __typename?: 'PricingModelGroupBy';
  id?: Maybe<Array<Maybe<PricingModelConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PricingModelConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PricingModelConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<PricingModelConnectionName>>>;
};

export type PricingModelInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PromoCode = {
  __typename?: 'PromoCode';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  issued_date?: Maybe<Scalars['DateTime']>;
  claimed?: Maybe<Scalars['Boolean']>;
  promo_matches?: Maybe<Scalars['Int']>;
};

export type PromoCodeAggregator = {
  __typename?: 'PromoCodeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<PromoCodeAggregatorSum>;
  avg?: Maybe<PromoCodeAggregatorAvg>;
  min?: Maybe<PromoCodeAggregatorMin>;
  max?: Maybe<PromoCodeAggregatorMax>;
};

export type PromoCodeAggregatorAvg = {
  __typename?: 'PromoCodeAggregatorAvg';
  promo_matches?: Maybe<Scalars['Float']>;
};

export type PromoCodeAggregatorMax = {
  __typename?: 'PromoCodeAggregatorMax';
  promo_matches?: Maybe<Scalars['Float']>;
};

export type PromoCodeAggregatorMin = {
  __typename?: 'PromoCodeAggregatorMin';
  promo_matches?: Maybe<Scalars['Float']>;
};

export type PromoCodeAggregatorSum = {
  __typename?: 'PromoCodeAggregatorSum';
  promo_matches?: Maybe<Scalars['Float']>;
};

export type PromoCodeConnection = {
  __typename?: 'PromoCodeConnection';
  values?: Maybe<Array<Maybe<PromoCode>>>;
  groupBy?: Maybe<PromoCodeGroupBy>;
  aggregate?: Maybe<PromoCodeAggregator>;
};

export type PromoCodeConnectionClaimed = {
  __typename?: 'PromoCodeConnectionClaimed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<PromoCodeConnection>;
};

export type PromoCodeConnectionCode = {
  __typename?: 'PromoCodeConnectionCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PromoCodeConnection>;
};

export type PromoCodeConnectionCreated_At = {
  __typename?: 'PromoCodeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PromoCodeConnection>;
};

export type PromoCodeConnectionId = {
  __typename?: 'PromoCodeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PromoCodeConnection>;
};

export type PromoCodeConnectionIssued_Date = {
  __typename?: 'PromoCodeConnectionIssued_date';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PromoCodeConnection>;
};

export type PromoCodeConnectionPromo_Matches = {
  __typename?: 'PromoCodeConnectionPromo_matches';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PromoCodeConnection>;
};

export type PromoCodeConnectionUpdated_At = {
  __typename?: 'PromoCodeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PromoCodeConnection>;
};

export type PromoCodeConversation = {
  __typename?: 'PromoCodeConversation';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  promo_code_redemptions?: Maybe<Array<Maybe<PromoCodeRedemptions>>>;
};


export type PromoCodeConversationPromo_Code_RedemptionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PromoCodeConversationAggregator = {
  __typename?: 'PromoCodeConversationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PromoCodeConversationConnection = {
  __typename?: 'PromoCodeConversationConnection';
  values?: Maybe<Array<Maybe<PromoCodeConversation>>>;
  groupBy?: Maybe<PromoCodeConversationGroupBy>;
  aggregate?: Maybe<PromoCodeConversationAggregator>;
};

export type PromoCodeConversationConnectionCode = {
  __typename?: 'PromoCodeConversationConnectionCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PromoCodeConversationConnection>;
};

export type PromoCodeConversationConnectionCreated_At = {
  __typename?: 'PromoCodeConversationConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PromoCodeConversationConnection>;
};

export type PromoCodeConversationConnectionId = {
  __typename?: 'PromoCodeConversationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PromoCodeConversationConnection>;
};

export type PromoCodeConversationConnectionUpdated_At = {
  __typename?: 'PromoCodeConversationConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PromoCodeConversationConnection>;
};

export type PromoCodeConversationGroupBy = {
  __typename?: 'PromoCodeConversationGroupBy';
  id?: Maybe<Array<Maybe<PromoCodeConversationConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PromoCodeConversationConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PromoCodeConversationConnectionUpdated_At>>>;
  code?: Maybe<Array<Maybe<PromoCodeConversationConnectionCode>>>;
};

export type PromoCodeConversationInput = {
  code?: Maybe<Scalars['String']>;
  promo_code_redemptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PromoCodeGroupBy = {
  __typename?: 'PromoCodeGroupBy';
  id?: Maybe<Array<Maybe<PromoCodeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PromoCodeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PromoCodeConnectionUpdated_At>>>;
  code?: Maybe<Array<Maybe<PromoCodeConnectionCode>>>;
  issued_date?: Maybe<Array<Maybe<PromoCodeConnectionIssued_Date>>>;
  claimed?: Maybe<Array<Maybe<PromoCodeConnectionClaimed>>>;
  promo_matches?: Maybe<Array<Maybe<PromoCodeConnectionPromo_Matches>>>;
};

export type PromoCodeInput = {
  code?: Maybe<Scalars['String']>;
  issued_date?: Maybe<Scalars['DateTime']>;
  claimed?: Maybe<Scalars['Boolean']>;
  promo_matches?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PromoCodeRedemptionInput = {
  promo_code_conversation?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PromoCodeRedemptions = {
  __typename?: 'PromoCodeRedemptions';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  promo_code_conversation?: Maybe<PromoCodeConversation>;
  users_permissions_user?: Maybe<UsersPermissionsUser>;
};

export type PromoCodeRedemptionsAggregator = {
  __typename?: 'PromoCodeRedemptionsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PromoCodeRedemptionsConnection = {
  __typename?: 'PromoCodeRedemptionsConnection';
  values?: Maybe<Array<Maybe<PromoCodeRedemptions>>>;
  groupBy?: Maybe<PromoCodeRedemptionsGroupBy>;
  aggregate?: Maybe<PromoCodeRedemptionsAggregator>;
};

export type PromoCodeRedemptionsConnectionCreated_At = {
  __typename?: 'PromoCodeRedemptionsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PromoCodeRedemptionsConnection>;
};

export type PromoCodeRedemptionsConnectionId = {
  __typename?: 'PromoCodeRedemptionsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PromoCodeRedemptionsConnection>;
};

export type PromoCodeRedemptionsConnectionPromo_Code_Conversation = {
  __typename?: 'PromoCodeRedemptionsConnectionPromo_code_conversation';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PromoCodeRedemptionsConnection>;
};

export type PromoCodeRedemptionsConnectionUpdated_At = {
  __typename?: 'PromoCodeRedemptionsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PromoCodeRedemptionsConnection>;
};

export type PromoCodeRedemptionsConnectionUsers_Permissions_User = {
  __typename?: 'PromoCodeRedemptionsConnectionUsers_permissions_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PromoCodeRedemptionsConnection>;
};

export type PromoCodeRedemptionsGroupBy = {
  __typename?: 'PromoCodeRedemptionsGroupBy';
  id?: Maybe<Array<Maybe<PromoCodeRedemptionsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PromoCodeRedemptionsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PromoCodeRedemptionsConnectionUpdated_At>>>;
  promo_code_conversation?: Maybe<Array<Maybe<PromoCodeRedemptionsConnectionPromo_Code_Conversation>>>;
  users_permissions_user?: Maybe<Array<Maybe<PromoCodeRedemptionsConnectionUsers_Permissions_User>>>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type PurchasedServiceInput = {
  uid?: Maybe<Scalars['String']>;
  date_start?: Maybe<Scalars['DateTime']>;
  date_expire?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PurchasedServices = {
  __typename?: 'PurchasedServices';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  uid?: Maybe<Scalars['String']>;
  date_start?: Maybe<Scalars['DateTime']>;
  date_expire?: Maybe<Scalars['DateTime']>;
};

export type PurchasedServicesAggregator = {
  __typename?: 'PurchasedServicesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PurchasedServicesConnection = {
  __typename?: 'PurchasedServicesConnection';
  values?: Maybe<Array<Maybe<PurchasedServices>>>;
  groupBy?: Maybe<PurchasedServicesGroupBy>;
  aggregate?: Maybe<PurchasedServicesAggregator>;
};

export type PurchasedServicesConnectionCreated_At = {
  __typename?: 'PurchasedServicesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchasedServicesConnection>;
};

export type PurchasedServicesConnectionDate_Expire = {
  __typename?: 'PurchasedServicesConnectionDate_expire';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchasedServicesConnection>;
};

export type PurchasedServicesConnectionDate_Start = {
  __typename?: 'PurchasedServicesConnectionDate_start';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchasedServicesConnection>;
};

export type PurchasedServicesConnectionId = {
  __typename?: 'PurchasedServicesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchasedServicesConnection>;
};

export type PurchasedServicesConnectionUid = {
  __typename?: 'PurchasedServicesConnectionUid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PurchasedServicesConnection>;
};

export type PurchasedServicesConnectionUpdated_At = {
  __typename?: 'PurchasedServicesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchasedServicesConnection>;
};

export type PurchasedServicesGroupBy = {
  __typename?: 'PurchasedServicesGroupBy';
  id?: Maybe<Array<Maybe<PurchasedServicesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PurchasedServicesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PurchasedServicesConnectionUpdated_At>>>;
  uid?: Maybe<Array<Maybe<PurchasedServicesConnectionUid>>>;
  date_start?: Maybe<Array<Maybe<PurchasedServicesConnectionDate_Start>>>;
  date_expire?: Maybe<Array<Maybe<PurchasedServicesConnectionDate_Expire>>>;
};

export type PurchasedSubscription = {
  __typename?: 'PurchasedSubscription';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  service_package?: Maybe<ServicePackage>;
  user?: Maybe<UsersPermissionsUser>;
  spent?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['Int']>;
  expiry?: Maybe<Scalars['Date']>;
};

export type PurchasedSubscriptionAggregator = {
  __typename?: 'PurchasedSubscriptionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<PurchasedSubscriptionAggregatorSum>;
  avg?: Maybe<PurchasedSubscriptionAggregatorAvg>;
  min?: Maybe<PurchasedSubscriptionAggregatorMin>;
  max?: Maybe<PurchasedSubscriptionAggregatorMax>;
};

export type PurchasedSubscriptionAggregatorAvg = {
  __typename?: 'PurchasedSubscriptionAggregatorAvg';
  spent?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

export type PurchasedSubscriptionAggregatorMax = {
  __typename?: 'PurchasedSubscriptionAggregatorMax';
  spent?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

export type PurchasedSubscriptionAggregatorMin = {
  __typename?: 'PurchasedSubscriptionAggregatorMin';
  spent?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

export type PurchasedSubscriptionAggregatorSum = {
  __typename?: 'PurchasedSubscriptionAggregatorSum';
  spent?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

export type PurchasedSubscriptionConnection = {
  __typename?: 'PurchasedSubscriptionConnection';
  values?: Maybe<Array<Maybe<PurchasedSubscription>>>;
  groupBy?: Maybe<PurchasedSubscriptionGroupBy>;
  aggregate?: Maybe<PurchasedSubscriptionAggregator>;
};

export type PurchasedSubscriptionConnectionBalance = {
  __typename?: 'PurchasedSubscriptionConnectionBalance';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PurchasedSubscriptionConnection>;
};

export type PurchasedSubscriptionConnectionCreated_At = {
  __typename?: 'PurchasedSubscriptionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchasedSubscriptionConnection>;
};

export type PurchasedSubscriptionConnectionExpiry = {
  __typename?: 'PurchasedSubscriptionConnectionExpiry';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchasedSubscriptionConnection>;
};

export type PurchasedSubscriptionConnectionId = {
  __typename?: 'PurchasedSubscriptionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchasedSubscriptionConnection>;
};

export type PurchasedSubscriptionConnectionService_Package = {
  __typename?: 'PurchasedSubscriptionConnectionService_package';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchasedSubscriptionConnection>;
};

export type PurchasedSubscriptionConnectionSpent = {
  __typename?: 'PurchasedSubscriptionConnectionSpent';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PurchasedSubscriptionConnection>;
};

export type PurchasedSubscriptionConnectionUpdated_At = {
  __typename?: 'PurchasedSubscriptionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchasedSubscriptionConnection>;
};

export type PurchasedSubscriptionConnectionUser = {
  __typename?: 'PurchasedSubscriptionConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchasedSubscriptionConnection>;
};

export type PurchasedSubscriptionGroupBy = {
  __typename?: 'PurchasedSubscriptionGroupBy';
  id?: Maybe<Array<Maybe<PurchasedSubscriptionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PurchasedSubscriptionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PurchasedSubscriptionConnectionUpdated_At>>>;
  service_package?: Maybe<Array<Maybe<PurchasedSubscriptionConnectionService_Package>>>;
  user?: Maybe<Array<Maybe<PurchasedSubscriptionConnectionUser>>>;
  spent?: Maybe<Array<Maybe<PurchasedSubscriptionConnectionSpent>>>;
  balance?: Maybe<Array<Maybe<PurchasedSubscriptionConnectionBalance>>>;
  expiry?: Maybe<Array<Maybe<PurchasedSubscriptionConnectionExpiry>>>;
};

export type PurchasedSubscriptionInput = {
  service_package?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  spent?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['Int']>;
  expiry?: Maybe<Scalars['Date']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Query = {
  __typename?: 'Query';
  applicationConfig?: Maybe<ApplicationConfig>;
  bookmark?: Maybe<Bookmark>;
  bookmarks?: Maybe<Array<Maybe<Bookmark>>>;
  bookmarksConnection?: Maybe<BookmarkConnection>;
  businessUseCase?: Maybe<BusinessUseCase>;
  businessUseCases?: Maybe<Array<Maybe<BusinessUseCase>>>;
  businessUseCasesConnection?: Maybe<BusinessUseCaseConnection>;
  career?: Maybe<Careers>;
  careers?: Maybe<Array<Maybe<Careers>>>;
  careersConnection?: Maybe<CareersConnection>;
  catalystAllocation?: Maybe<CatalystAllocation>;
  catalystAllocations?: Maybe<Array<Maybe<CatalystAllocation>>>;
  catalystAllocationsConnection?: Maybe<CatalystAllocationConnection>;
  catalystConversation?: Maybe<CatalystConversations>;
  catalystConversations?: Maybe<Array<Maybe<CatalystConversations>>>;
  catalystConversationsConnection?: Maybe<CatalystConversationsConnection>;
  chatMessage?: Maybe<ChatMessages>;
  chatMessages?: Maybe<Array<Maybe<ChatMessages>>>;
  chatMessagesConnection?: Maybe<ChatMessagesConnection>;
  chat?: Maybe<Chat>;
  chats?: Maybe<Array<Maybe<Chat>>>;
  chatsConnection?: Maybe<ChatConnection>;
  conversationMessage?: Maybe<ConversationMessage>;
  conversationMessages?: Maybe<Array<Maybe<ConversationMessage>>>;
  conversationMessagesConnection?: Maybe<ConversationMessageConnection>;
  conversation?: Maybe<Conversations>;
  conversations?: Maybe<Array<Maybe<Conversations>>>;
  conversationsConnection?: Maybe<ConversationsConnection>;
  corporateDepartment?: Maybe<CorporateDepartment>;
  corporateDepartments?: Maybe<Array<Maybe<CorporateDepartment>>>;
  corporateDepartmentsConnection?: Maybe<CorporateDepartmentConnection>;
  corporate?: Maybe<Corporate>;
  corporates?: Maybe<Array<Maybe<Corporate>>>;
  corporatesConnection?: Maybe<CorporateConnection>;
  country?: Maybe<Country>;
  countries?: Maybe<Array<Maybe<Country>>>;
  countriesConnection?: Maybe<CountryConnection>;
  credit?: Maybe<Credits>;
  credits?: Maybe<Array<Maybe<Credits>>>;
  creditsConnection?: Maybe<CreditsConnection>;
  documentSharing?: Maybe<DocumentSharing>;
  documentSharings?: Maybe<Array<Maybe<DocumentSharing>>>;
  documentSharingsConnection?: Maybe<DocumentSharingConnection>;
  enquiry?: Maybe<Enquiries>;
  enquiries?: Maybe<Array<Maybe<Enquiries>>>;
  enquiriesConnection?: Maybe<EnquiriesConnection>;
  goal?: Maybe<Goals>;
  goals?: Maybe<Array<Maybe<Goals>>>;
  goalsConnection?: Maybe<GoalsConnection>;
  impactArea?: Maybe<ImpactArea>;
  impactAreas?: Maybe<Array<Maybe<ImpactArea>>>;
  impactAreasConnection?: Maybe<ImpactAreaConnection>;
  industry?: Maybe<Industry>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  industriesConnection?: Maybe<IndustryConnection>;
  jobPosting?: Maybe<JobPosting>;
  jobPostings?: Maybe<Array<Maybe<JobPosting>>>;
  jobPostingsConnection?: Maybe<JobPostingConnection>;
  matchMakingResult?: Maybe<MatchMakingResult>;
  matchMakingResults?: Maybe<Array<Maybe<MatchMakingResult>>>;
  matchMakingResultsConnection?: Maybe<MatchMakingResultConnection>;
  maturityLevel?: Maybe<MaturityLevel>;
  maturityLevels?: Maybe<Array<Maybe<MaturityLevel>>>;
  maturityLevelsConnection?: Maybe<MaturityLevelConnection>;
  newsArticle?: Maybe<NewsArticle>;
  newsArticles?: Maybe<Array<Maybe<NewsArticle>>>;
  newsArticlesConnection?: Maybe<NewsArticleConnection>;
  notificationPreference?: Maybe<NotificationPreferences>;
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreferences>>>;
  notificationPreferencesConnection?: Maybe<NotificationPreferencesConnection>;
  onBoardingSession?: Maybe<OnBoardingSession>;
  onBoardingSessions?: Maybe<Array<Maybe<OnBoardingSession>>>;
  onBoardingSessionsConnection?: Maybe<OnBoardingSessionConnection>;
  personProfile?: Maybe<PersonProfile>;
  personProfiles?: Maybe<Array<Maybe<PersonProfile>>>;
  personProfilesConnection?: Maybe<PersonProfileConnection>;
  pricingModel?: Maybe<PricingModel>;
  pricingModels?: Maybe<Array<Maybe<PricingModel>>>;
  pricingModelsConnection?: Maybe<PricingModelConnection>;
  promoCodeConversation?: Maybe<PromoCodeConversation>;
  promoCodeConversations?: Maybe<Array<Maybe<PromoCodeConversation>>>;
  promoCodeConversationsConnection?: Maybe<PromoCodeConversationConnection>;
  promoCodeRedemption?: Maybe<PromoCodeRedemptions>;
  promoCodeRedemptions?: Maybe<Array<Maybe<PromoCodeRedemptions>>>;
  promoCodeRedemptionsConnection?: Maybe<PromoCodeRedemptionsConnection>;
  promoCode?: Maybe<PromoCode>;
  promoCodes?: Maybe<Array<Maybe<PromoCode>>>;
  promoCodesConnection?: Maybe<PromoCodeConnection>;
  purchasedService?: Maybe<PurchasedServices>;
  purchasedServices?: Maybe<Array<Maybe<PurchasedServices>>>;
  purchasedServicesConnection?: Maybe<PurchasedServicesConnection>;
  purchasedSubscription?: Maybe<PurchasedSubscription>;
  purchasedSubscriptions?: Maybe<Array<Maybe<PurchasedSubscription>>>;
  purchasedSubscriptionsConnection?: Maybe<PurchasedSubscriptionConnection>;
  rating?: Maybe<Rating>;
  ratings?: Maybe<Array<Maybe<Rating>>>;
  ratingsConnection?: Maybe<RatingConnection>;
  regionServicePrice?: Maybe<RegionServicePrice>;
  regionServicePrices?: Maybe<Array<Maybe<RegionServicePrice>>>;
  regionServicePricesConnection?: Maybe<RegionServicePriceConnection>;
  region?: Maybe<Region>;
  regions?: Maybe<Array<Maybe<Region>>>;
  regionsConnection?: Maybe<RegionConnection>;
  sdgObjective?: Maybe<SdgObjectives>;
  sdgObjectives?: Maybe<Array<Maybe<SdgObjectives>>>;
  sdgObjectivesConnection?: Maybe<SdgObjectivesConnection>;
  serviceCollaboration?: Maybe<ServiceCollaboration>;
  serviceCollaborations?: Maybe<Array<Maybe<ServiceCollaboration>>>;
  serviceCollaborationsConnection?: Maybe<ServiceCollaborationConnection>;
  servicePackage?: Maybe<ServicePackage>;
  servicePackages?: Maybe<Array<Maybe<ServicePackage>>>;
  servicePackagesConnection?: Maybe<ServicePackageConnection>;
  servicesInterest?: Maybe<ServicesInterest>;
  servicesInterests?: Maybe<Array<Maybe<ServicesInterest>>>;
  servicesInterestsConnection?: Maybe<ServicesInterestConnection>;
  service?: Maybe<Services>;
  services?: Maybe<Array<Maybe<Services>>>;
  servicesConnection?: Maybe<ServicesConnection>;
  startConversationTermsCondition?: Maybe<StartConversationTermsConditions>;
  startupProfile?: Maybe<StartupProfile>;
  startupProfiles?: Maybe<Array<Maybe<StartupProfile>>>;
  startupProfilesConnection?: Maybe<StartupProfileConnection>;
  technologyReadinessLevel?: Maybe<TechnologyReadinessLevel>;
  technologyReadinessLevels?: Maybe<Array<Maybe<TechnologyReadinessLevel>>>;
  technologyReadinessLevelsConnection?: Maybe<TechnologyReadinessLevelConnection>;
  technologyRequest?: Maybe<TechnologyRequest>;
  technologyRequests?: Maybe<Array<Maybe<TechnologyRequest>>>;
  technologyRequestsConnection?: Maybe<TechnologyRequestConnection>;
  technologySolution?: Maybe<TechnologySolution>;
  technologySolutions?: Maybe<Array<Maybe<TechnologySolution>>>;
  technologySolutionsConnection?: Maybe<TechnologySolutionConnection>;
  technologyType?: Maybe<TechnologyType>;
  technologyTypes?: Maybe<Array<Maybe<TechnologyType>>>;
  technologyTypesConnection?: Maybe<TechnologyTypeConnection>;
  transaction?: Maybe<Transactions>;
  transactions?: Maybe<Array<Maybe<Transactions>>>;
  transactionsConnection?: Maybe<TransactionsConnection>;
  userSubmittedGoal?: Maybe<UserSubmittedGoals>;
  userSubmittedGoals?: Maybe<Array<Maybe<UserSubmittedGoals>>>;
  userSubmittedGoalsConnection?: Maybe<UserSubmittedGoalsConnection>;
  verificationAction?: Maybe<VerificationAction>;
  verificationActions?: Maybe<Array<Maybe<VerificationAction>>>;
  verificationActionsConnection?: Maybe<VerificationActionConnection>;
  viewCount?: Maybe<ViewCounts>;
  viewCounts?: Maybe<Array<Maybe<ViewCounts>>>;
  viewCountsConnection?: Maybe<ViewCountsConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  me?: Maybe<UsersPermissionsMe>;
  currentProfileBookmarks?: Maybe<Array<Maybe<Bookmark>>>;
  findCurrentUserBookmarksContent?: Maybe<FindCurrentUserBookmarksContentPayload>;
  getCurrentCatalystConversations: Array<Maybe<CatalystConversations>>;
  getOrCreateChatMessagesWithCategory?: Maybe<GetChatMessagesPayload>;
  getConversationWithStartupCorps?: Maybe<ConversationStartupCorp>;
  getConversation?: Maybe<Conversations>;
  myCorporateProfile?: Maybe<MyCorporateProfile>;
  myCreditBalance: Scalars['Int'];
  evalMatchMakeResult?: Maybe<EvalMatchResult>;
  searchMatches?: Maybe<SearchMatchesPayload>;
  generateMatchesExport?: Maybe<MatchesCsv>;
  findOneMatchResultWithRole?: Maybe<FindMatchMakingResultWithRolePayload>;
  getCurrentUserMessages?: Maybe<PagedMessages>;
  getCurrentUserUnreadMessages?: Maybe<PagedMessages>;
  findOnboardingSessionByUUID?: Maybe<FindOnboardingSessionByUuidPayload>;
  tryGetNewOnboardingSession?: Maybe<TryGetNewOnboardingSessionPayload>;
  myProfile?: Maybe<MyProfile>;
  myConversations?: Maybe<Array<Maybe<ConversationSummary>>>;
  getMyPurchasedSubscription?: Maybe<PurchasedSubscription>;
  getMyServiceCollaborations: Array<Maybe<ServiceCollaboration>>;
  getServicePackages?: Maybe<Array<Maybe<ServicePackage>>>;
  getServices?: Maybe<Array<Maybe<GetServicesPayload>>>;
  myStartupProfile?: Maybe<MyStartupProfile>;
  getTechRequestsMatches?: Maybe<MatchResults>;
  myTechSolutions?: Maybe<Array<Maybe<TechnologySolution>>>;
  getTechSolutionsMatches?: Maybe<MatchResults>;
  countTechSolutionsMatches?: Maybe<CountTechSolutionMatches>;
  corporateSearchTechnologySolutions?: Maybe<Array<Maybe<TechnologySolution>>>;
  corporateFindOneTechnologySolution?: Maybe<CorporateFindOneTechnologySolution>;
};


export type QueryApplicationConfigArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryBookmarkArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryBookmarksArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryBookmarksConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBusinessUseCaseArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryBusinessUseCasesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryBusinessUseCasesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCareerArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCareersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCareersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalystAllocationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCatalystAllocationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCatalystAllocationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalystConversationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCatalystConversationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCatalystConversationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryChatMessageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryChatMessagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryChatMessagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryChatArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryChatsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryChatsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryConversationMessageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryConversationMessagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryConversationMessagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryConversationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryConversationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryConversationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCorporateDepartmentArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCorporateDepartmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCorporateDepartmentsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCorporateArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCorporatesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCorporatesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCountryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCountriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCountriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCreditArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCreditsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCreditsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDocumentSharingArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryDocumentSharingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryDocumentSharingsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEnquiryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryEnquiriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryEnquiriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGoalArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryGoalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGoalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryImpactAreaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryImpactAreasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryImpactAreasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryIndustryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryIndustriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryJobPostingArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryJobPostingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryJobPostingsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryMatchMakingResultArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryMatchMakingResultsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryMatchMakingResultsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryMaturityLevelArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryMaturityLevelsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryMaturityLevelsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNewsArticleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryNewsArticlesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryNewsArticlesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNotificationPreferenceArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotificationPreferencesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotificationPreferencesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOnBoardingSessionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryOnBoardingSessionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryOnBoardingSessionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPersonProfileArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPersonProfilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPersonProfilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPricingModelArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPricingModelsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPricingModelsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPromoCodeConversationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPromoCodeConversationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPromoCodeConversationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPromoCodeRedemptionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPromoCodeRedemptionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPromoCodeRedemptionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPromoCodeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPromoCodesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPromoCodesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPurchasedServiceArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPurchasedServicesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPurchasedServicesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPurchasedSubscriptionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPurchasedSubscriptionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPurchasedSubscriptionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRatingArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRatingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRatingsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRegionServicePriceArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRegionServicePricesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRegionServicePricesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRegionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRegionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRegionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySdgObjectiveArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerySdgObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerySdgObjectivesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryServiceCollaborationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryServiceCollaborationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryServiceCollaborationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryServicePackageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryServicePackagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryServicePackagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryServicesInterestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryServicesInterestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryServicesInterestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryServiceArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryServicesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryServicesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryStartConversationTermsConditionArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryStartupProfileArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryStartupProfilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryStartupProfilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTechnologyReadinessLevelArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTechnologyReadinessLevelsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTechnologyReadinessLevelsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTechnologyRequestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTechnologyRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTechnologyRequestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTechnologySolutionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTechnologySolutionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTechnologySolutionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTechnologyTypeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTechnologyTypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTechnologyTypesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTransactionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTransactionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTransactionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserSubmittedGoalArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUserSubmittedGoalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryUserSubmittedGoalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVerificationActionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryVerificationActionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryVerificationActionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryViewCountArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryViewCountsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryViewCountsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetOrCreateChatMessagesWithCategoryArgs = {
  input: GetOrCreateChatMessagesWithCategoryInput;
};


export type QueryGetConversationWithStartupCorpsArgs = {
  id: Scalars['Int'];
};


export type QueryGetConversationArgs = {
  id: Scalars['ID'];
};


export type QueryEvalMatchMakeResultArgs = {
  input?: Maybe<EvalMatchMakeResultInput>;
};


export type QuerySearchMatchesArgs = {
  input?: Maybe<SearchMatchesInput>;
};


export type QueryFindOneMatchResultWithRoleArgs = {
  id: Scalars['ID'];
};


export type QueryFindOnboardingSessionByUuidArgs = {
  uuid: Scalars['String'];
};


export type QueryTryGetNewOnboardingSessionArgs = {
  uuid: Scalars['String'];
};


export type QueryGetTechRequestsMatchesArgs = {
  id: Scalars['ID'];
};


export type QueryGetTechSolutionsMatchesArgs = {
  id: Scalars['ID'];
};


export type QueryCountTechSolutionsMatchesArgs = {
  id: Scalars['ID'];
};


export type QueryCorporateSearchTechnologySolutionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCorporateFindOneTechnologySolutionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};

export type Rating = {
  __typename?: 'Rating';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  value?: Maybe<Scalars['Int']>;
  article_type?: Maybe<Enum_Rating_Article_Type>;
  item_id?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
};

export type RatingAggregator = {
  __typename?: 'RatingAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<RatingAggregatorSum>;
  avg?: Maybe<RatingAggregatorAvg>;
  min?: Maybe<RatingAggregatorMin>;
  max?: Maybe<RatingAggregatorMax>;
};

export type RatingAggregatorAvg = {
  __typename?: 'RatingAggregatorAvg';
  value?: Maybe<Scalars['Float']>;
};

export type RatingAggregatorMax = {
  __typename?: 'RatingAggregatorMax';
  value?: Maybe<Scalars['Float']>;
};

export type RatingAggregatorMin = {
  __typename?: 'RatingAggregatorMin';
  value?: Maybe<Scalars['Float']>;
};

export type RatingAggregatorSum = {
  __typename?: 'RatingAggregatorSum';
  value?: Maybe<Scalars['Float']>;
};

export type RatingConnection = {
  __typename?: 'RatingConnection';
  values?: Maybe<Array<Maybe<Rating>>>;
  groupBy?: Maybe<RatingGroupBy>;
  aggregate?: Maybe<RatingAggregator>;
};

export type RatingConnectionArticle_Type = {
  __typename?: 'RatingConnectionArticle_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RatingConnection>;
};

export type RatingConnectionComments = {
  __typename?: 'RatingConnectionComments';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RatingConnection>;
};

export type RatingConnectionCreated_At = {
  __typename?: 'RatingConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RatingConnection>;
};

export type RatingConnectionId = {
  __typename?: 'RatingConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RatingConnection>;
};

export type RatingConnectionItem_Id = {
  __typename?: 'RatingConnectionItem_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RatingConnection>;
};

export type RatingConnectionUpdated_At = {
  __typename?: 'RatingConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RatingConnection>;
};

export type RatingConnectionValue = {
  __typename?: 'RatingConnectionValue';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<RatingConnection>;
};

export type RatingGroupBy = {
  __typename?: 'RatingGroupBy';
  id?: Maybe<Array<Maybe<RatingConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RatingConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RatingConnectionUpdated_At>>>;
  value?: Maybe<Array<Maybe<RatingConnectionValue>>>;
  article_type?: Maybe<Array<Maybe<RatingConnectionArticle_Type>>>;
  item_id?: Maybe<Array<Maybe<RatingConnectionItem_Id>>>;
  comments?: Maybe<Array<Maybe<RatingConnectionComments>>>;
};

export type RatingInput = {
  value?: Maybe<Scalars['Int']>;
  article_type?: Maybe<Enum_Rating_Article_Type>;
  item_id?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type RedeemStartConversationInput = {
  code: Scalars['String'];
  techSolutionId?: Maybe<Scalars['ID']>;
  techRequestId?: Maybe<Scalars['ID']>;
  matchId?: Maybe<Scalars['ID']>;
};

export type RedeemStartConversationPayload = {
  __typename?: 'RedeemStartConversationPayload';
  result?: Maybe<Scalars['Boolean']>;
  conversationId?: Maybe<Scalars['ID']>;
};

export type RefreshMatchesInput = {
  type?: Maybe<Scalars['String']>;
  technology_id?: Maybe<Scalars['String']>;
  isReturnMatches?: Maybe<Scalars['Boolean']>;
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  countries?: Maybe<Array<Maybe<Country>>>;
};


export type RegionCountriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RegionAggregator = {
  __typename?: 'RegionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RegionConnection = {
  __typename?: 'RegionConnection';
  values?: Maybe<Array<Maybe<Region>>>;
  groupBy?: Maybe<RegionGroupBy>;
  aggregate?: Maybe<RegionAggregator>;
};

export type RegionConnectionCode = {
  __typename?: 'RegionConnectionCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionCreated_At = {
  __typename?: 'RegionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionCurrency = {
  __typename?: 'RegionConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionId = {
  __typename?: 'RegionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionName = {
  __typename?: 'RegionConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionPublished_At = {
  __typename?: 'RegionConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionUpdated_At = {
  __typename?: 'RegionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionGroupBy = {
  __typename?: 'RegionGroupBy';
  id?: Maybe<Array<Maybe<RegionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RegionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RegionConnectionUpdated_At>>>;
  code?: Maybe<Array<Maybe<RegionConnectionCode>>>;
  name?: Maybe<Array<Maybe<RegionConnectionName>>>;
  currency?: Maybe<Array<Maybe<RegionConnectionCurrency>>>;
  published_at?: Maybe<Array<Maybe<RegionConnectionPublished_At>>>;
};

export type RegionInput = {
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currency?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type RegionServicePrice = {
  __typename?: 'RegionServicePrice';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  service?: Maybe<Services>;
  price?: Maybe<Scalars['Float']>;
  region_code?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type RegionServicePriceAggregator = {
  __typename?: 'RegionServicePriceAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<RegionServicePriceAggregatorSum>;
  avg?: Maybe<RegionServicePriceAggregatorAvg>;
  min?: Maybe<RegionServicePriceAggregatorMin>;
  max?: Maybe<RegionServicePriceAggregatorMax>;
};

export type RegionServicePriceAggregatorAvg = {
  __typename?: 'RegionServicePriceAggregatorAvg';
  price?: Maybe<Scalars['Float']>;
};

export type RegionServicePriceAggregatorMax = {
  __typename?: 'RegionServicePriceAggregatorMax';
  price?: Maybe<Scalars['Float']>;
};

export type RegionServicePriceAggregatorMin = {
  __typename?: 'RegionServicePriceAggregatorMin';
  price?: Maybe<Scalars['Float']>;
};

export type RegionServicePriceAggregatorSum = {
  __typename?: 'RegionServicePriceAggregatorSum';
  price?: Maybe<Scalars['Float']>;
};

export type RegionServicePriceConnection = {
  __typename?: 'RegionServicePriceConnection';
  values?: Maybe<Array<Maybe<RegionServicePrice>>>;
  groupBy?: Maybe<RegionServicePriceGroupBy>;
  aggregate?: Maybe<RegionServicePriceAggregator>;
};

export type RegionServicePriceConnectionCreated_At = {
  __typename?: 'RegionServicePriceConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RegionServicePriceConnection>;
};

export type RegionServicePriceConnectionId = {
  __typename?: 'RegionServicePriceConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RegionServicePriceConnection>;
};

export type RegionServicePriceConnectionPrice = {
  __typename?: 'RegionServicePriceConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<RegionServicePriceConnection>;
};

export type RegionServicePriceConnectionPublished_At = {
  __typename?: 'RegionServicePriceConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RegionServicePriceConnection>;
};

export type RegionServicePriceConnectionRegion_Code = {
  __typename?: 'RegionServicePriceConnectionRegion_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionServicePriceConnection>;
};

export type RegionServicePriceConnectionService = {
  __typename?: 'RegionServicePriceConnectionService';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RegionServicePriceConnection>;
};

export type RegionServicePriceConnectionUpdated_At = {
  __typename?: 'RegionServicePriceConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RegionServicePriceConnection>;
};

export type RegionServicePriceGroupBy = {
  __typename?: 'RegionServicePriceGroupBy';
  id?: Maybe<Array<Maybe<RegionServicePriceConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RegionServicePriceConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RegionServicePriceConnectionUpdated_At>>>;
  service?: Maybe<Array<Maybe<RegionServicePriceConnectionService>>>;
  price?: Maybe<Array<Maybe<RegionServicePriceConnectionPrice>>>;
  region_code?: Maybe<Array<Maybe<RegionServicePriceConnectionRegion_Code>>>;
  published_at?: Maybe<Array<Maybe<RegionServicePriceConnectionPublished_At>>>;
};

export type RegionServicePriceInput = {
  service?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  region_code?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ResetPasswordInput = {
  password?: Maybe<Scalars['String']>;
  retypePassword?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type SdgObjectiveInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type SdgObjectives = {
  __typename?: 'SdgObjectives';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type SdgObjectivesAggregator = {
  __typename?: 'SdgObjectivesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SdgObjectivesConnection = {
  __typename?: 'SdgObjectivesConnection';
  values?: Maybe<Array<Maybe<SdgObjectives>>>;
  groupBy?: Maybe<SdgObjectivesGroupBy>;
  aggregate?: Maybe<SdgObjectivesAggregator>;
};

export type SdgObjectivesConnectionCreated_At = {
  __typename?: 'SdgObjectivesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SdgObjectivesConnection>;
};

export type SdgObjectivesConnectionId = {
  __typename?: 'SdgObjectivesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SdgObjectivesConnection>;
};

export type SdgObjectivesConnectionName = {
  __typename?: 'SdgObjectivesConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SdgObjectivesConnection>;
};

export type SdgObjectivesConnectionUpdated_At = {
  __typename?: 'SdgObjectivesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SdgObjectivesConnection>;
};

export type SdgObjectivesGroupBy = {
  __typename?: 'SdgObjectivesGroupBy';
  id?: Maybe<Array<Maybe<SdgObjectivesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SdgObjectivesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SdgObjectivesConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<SdgObjectivesConnectionName>>>;
};

export type SearchMatchesInput = {
  type: Scalars['String'];
  id: Scalars['ID'];
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type SearchMatchesPayload = {
  __typename?: 'SearchMatchesPayload';
  technologyRequests?: Maybe<Array<Maybe<TechnologyRequest>>>;
  technologySolutions?: Maybe<Array<Maybe<TechnologySolution>>>;
  total: Scalars['Int'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type SendMessageInput = {
  category: Enum_Chat_Category;
  referenceId: Scalars['ID'];
  body: Scalars['String'];
};

export type ServiceCollaboration = {
  __typename?: 'ServiceCollaboration';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  service?: Maybe<Services>;
  catalyst?: Maybe<UsersPermissionsUser>;
  client?: Maybe<UsersPermissionsUser>;
  structure?: Maybe<Array<Maybe<ComponentServiceCollaborationStructure>>>;
  scope?: Maybe<ComponentServiceCollaborationScope>;
  deliverables?: Maybe<ComponentServiceCollaborationDeliverables>;
  feedback?: Maybe<ComponentServiceCollaborationFeedback>;
  chat?: Maybe<Chat>;
  startup_profile?: Maybe<StartupProfile>;
  corporate_profile?: Maybe<Corporate>;
};

export type ServiceCollaborationAggregator = {
  __typename?: 'ServiceCollaborationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ServiceCollaborationConnection = {
  __typename?: 'ServiceCollaborationConnection';
  values?: Maybe<Array<Maybe<ServiceCollaboration>>>;
  groupBy?: Maybe<ServiceCollaborationGroupBy>;
  aggregate?: Maybe<ServiceCollaborationAggregator>;
};

export type ServiceCollaborationConnectionCatalyst = {
  __typename?: 'ServiceCollaborationConnectionCatalyst';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionChat = {
  __typename?: 'ServiceCollaborationConnectionChat';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionClient = {
  __typename?: 'ServiceCollaborationConnectionClient';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionCorporate_Profile = {
  __typename?: 'ServiceCollaborationConnectionCorporate_profile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionCreated_At = {
  __typename?: 'ServiceCollaborationConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionDeliverables = {
  __typename?: 'ServiceCollaborationConnectionDeliverables';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionFeedback = {
  __typename?: 'ServiceCollaborationConnectionFeedback';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionId = {
  __typename?: 'ServiceCollaborationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionScope = {
  __typename?: 'ServiceCollaborationConnectionScope';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionService = {
  __typename?: 'ServiceCollaborationConnectionService';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionStartup_Profile = {
  __typename?: 'ServiceCollaborationConnectionStartup_profile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationConnectionUpdated_At = {
  __typename?: 'ServiceCollaborationConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServiceCollaborationConnection>;
};

export type ServiceCollaborationGroupBy = {
  __typename?: 'ServiceCollaborationGroupBy';
  id?: Maybe<Array<Maybe<ServiceCollaborationConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ServiceCollaborationConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ServiceCollaborationConnectionUpdated_At>>>;
  service?: Maybe<Array<Maybe<ServiceCollaborationConnectionService>>>;
  catalyst?: Maybe<Array<Maybe<ServiceCollaborationConnectionCatalyst>>>;
  client?: Maybe<Array<Maybe<ServiceCollaborationConnectionClient>>>;
  scope?: Maybe<Array<Maybe<ServiceCollaborationConnectionScope>>>;
  deliverables?: Maybe<Array<Maybe<ServiceCollaborationConnectionDeliverables>>>;
  feedback?: Maybe<Array<Maybe<ServiceCollaborationConnectionFeedback>>>;
  chat?: Maybe<Array<Maybe<ServiceCollaborationConnectionChat>>>;
  startup_profile?: Maybe<Array<Maybe<ServiceCollaborationConnectionStartup_Profile>>>;
  corporate_profile?: Maybe<Array<Maybe<ServiceCollaborationConnectionCorporate_Profile>>>;
};

export type ServiceCollaborationInput = {
  service?: Maybe<Scalars['ID']>;
  catalyst?: Maybe<Scalars['ID']>;
  client?: Maybe<Scalars['ID']>;
  structure?: Maybe<Array<Maybe<ComponentServiceCollaborationStructureInput>>>;
  scope?: Maybe<ComponentServiceCollaborationScopeInput>;
  deliverables?: Maybe<ComponentServiceCollaborationDeliverableInput>;
  feedback?: Maybe<ComponentServiceCollaborationFeedbackInput>;
  chat?: Maybe<Scalars['ID']>;
  startup_profile?: Maybe<Scalars['ID']>;
  corporate_profile?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ServiceInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_Services_Role>;
  price?: Maybe<Scalars['Float']>;
  image?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  region_prices?: Maybe<Array<Maybe<ComponentRegionPricingRegionPriceInput>>>;
  service_collaboration?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ServicePackage = {
  __typename?: 'ServicePackage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  role_type?: Maybe<Enum_Servicepackage_Role_Type>;
  unlimited_credits?: Maybe<Scalars['Boolean']>;
  service_package_price_mode?: Maybe<Array<Maybe<ComponentServicePackageServicePackagePaymentMode>>>;
  region_code?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type ServicePackageAggregator = {
  __typename?: 'ServicePackageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ServicePackageConnection = {
  __typename?: 'ServicePackageConnection';
  values?: Maybe<Array<Maybe<ServicePackage>>>;
  groupBy?: Maybe<ServicePackageGroupBy>;
  aggregate?: Maybe<ServicePackageAggregator>;
};

export type ServicePackageConnectionCreated_At = {
  __typename?: 'ServicePackageConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServicePackageConnection>;
};

export type ServicePackageConnectionId = {
  __typename?: 'ServicePackageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServicePackageConnection>;
};

export type ServicePackageConnectionName = {
  __typename?: 'ServicePackageConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicePackageConnection>;
};

export type ServicePackageConnectionRegion_Code = {
  __typename?: 'ServicePackageConnectionRegion_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicePackageConnection>;
};

export type ServicePackageConnectionRole_Type = {
  __typename?: 'ServicePackageConnectionRole_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicePackageConnection>;
};

export type ServicePackageConnectionSlug = {
  __typename?: 'ServicePackageConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicePackageConnection>;
};

export type ServicePackageConnectionUnlimited_Credits = {
  __typename?: 'ServicePackageConnectionUnlimited_credits';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ServicePackageConnection>;
};

export type ServicePackageConnectionUpdated_At = {
  __typename?: 'ServicePackageConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServicePackageConnection>;
};

export type ServicePackageGroupBy = {
  __typename?: 'ServicePackageGroupBy';
  id?: Maybe<Array<Maybe<ServicePackageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ServicePackageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ServicePackageConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<ServicePackageConnectionName>>>;
  role_type?: Maybe<Array<Maybe<ServicePackageConnectionRole_Type>>>;
  unlimited_credits?: Maybe<Array<Maybe<ServicePackageConnectionUnlimited_Credits>>>;
  region_code?: Maybe<Array<Maybe<ServicePackageConnectionRegion_Code>>>;
  slug?: Maybe<Array<Maybe<ServicePackageConnectionSlug>>>;
};

export type ServicePackageInput = {
  name?: Maybe<Scalars['String']>;
  role_type?: Maybe<Enum_Servicepackage_Role_Type>;
  unlimited_credits?: Maybe<Scalars['Boolean']>;
  service_package_price_mode?: Maybe<Array<Maybe<ComponentServicePackageServicePackagePaymentModeInput>>>;
  region_code?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Services = {
  __typename?: 'Services';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_Services_Role>;
  price?: Maybe<Scalars['Float']>;
  image?: Maybe<UploadFile>;
  slug?: Maybe<Scalars['String']>;
  region_prices?: Maybe<Array<Maybe<ComponentRegionPricingRegionPrices>>>;
  service_collaboration?: Maybe<ServiceCollaboration>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type ServicesAggregator = {
  __typename?: 'ServicesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ServicesAggregatorSum>;
  avg?: Maybe<ServicesAggregatorAvg>;
  min?: Maybe<ServicesAggregatorMin>;
  max?: Maybe<ServicesAggregatorMax>;
};

export type ServicesAggregatorAvg = {
  __typename?: 'ServicesAggregatorAvg';
  price?: Maybe<Scalars['Float']>;
};

export type ServicesAggregatorMax = {
  __typename?: 'ServicesAggregatorMax';
  price?: Maybe<Scalars['Float']>;
};

export type ServicesAggregatorMin = {
  __typename?: 'ServicesAggregatorMin';
  price?: Maybe<Scalars['Float']>;
};

export type ServicesAggregatorSum = {
  __typename?: 'ServicesAggregatorSum';
  price?: Maybe<Scalars['Float']>;
};

export type ServicesConnection = {
  __typename?: 'ServicesConnection';
  values?: Maybe<Array<Maybe<Services>>>;
  groupBy?: Maybe<ServicesGroupBy>;
  aggregate?: Maybe<ServicesAggregator>;
};

export type ServicesConnectionCreated_At = {
  __typename?: 'ServicesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionDescription = {
  __typename?: 'ServicesConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionId = {
  __typename?: 'ServicesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionImage = {
  __typename?: 'ServicesConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionPrice = {
  __typename?: 'ServicesConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionPublished_At = {
  __typename?: 'ServicesConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionRole = {
  __typename?: 'ServicesConnectionRole';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionService_Collaboration = {
  __typename?: 'ServicesConnectionService_collaboration';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionSlug = {
  __typename?: 'ServicesConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionTitle = {
  __typename?: 'ServicesConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesConnectionUpdated_At = {
  __typename?: 'ServicesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServicesConnection>;
};

export type ServicesGroupBy = {
  __typename?: 'ServicesGroupBy';
  id?: Maybe<Array<Maybe<ServicesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ServicesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ServicesConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<ServicesConnectionTitle>>>;
  description?: Maybe<Array<Maybe<ServicesConnectionDescription>>>;
  role?: Maybe<Array<Maybe<ServicesConnectionRole>>>;
  price?: Maybe<Array<Maybe<ServicesConnectionPrice>>>;
  image?: Maybe<Array<Maybe<ServicesConnectionImage>>>;
  slug?: Maybe<Array<Maybe<ServicesConnectionSlug>>>;
  service_collaboration?: Maybe<Array<Maybe<ServicesConnectionService_Collaboration>>>;
  published_at?: Maybe<Array<Maybe<ServicesConnectionPublished_At>>>;
};

export type ServicesInterest = {
  __typename?: 'ServicesInterest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  services?: Maybe<Scalars['JSON']>;
  requested_conversation_with?: Maybe<Scalars['JSON']>;
};

export type ServicesInterestAggregator = {
  __typename?: 'ServicesInterestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ServicesInterestConnection = {
  __typename?: 'ServicesInterestConnection';
  values?: Maybe<Array<Maybe<ServicesInterest>>>;
  groupBy?: Maybe<ServicesInterestGroupBy>;
  aggregate?: Maybe<ServicesInterestAggregator>;
};

export type ServicesInterestConnectionCreated_At = {
  __typename?: 'ServicesInterestConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServicesInterestConnection>;
};

export type ServicesInterestConnectionEmail = {
  __typename?: 'ServicesInterestConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ServicesInterestConnection>;
};

export type ServicesInterestConnectionId = {
  __typename?: 'ServicesInterestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ServicesInterestConnection>;
};

export type ServicesInterestConnectionRequested_Conversation_With = {
  __typename?: 'ServicesInterestConnectionRequested_conversation_with';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<ServicesInterestConnection>;
};

export type ServicesInterestConnectionServices = {
  __typename?: 'ServicesInterestConnectionServices';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<ServicesInterestConnection>;
};

export type ServicesInterestConnectionUpdated_At = {
  __typename?: 'ServicesInterestConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ServicesInterestConnection>;
};

export type ServicesInterestGroupBy = {
  __typename?: 'ServicesInterestGroupBy';
  id?: Maybe<Array<Maybe<ServicesInterestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ServicesInterestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ServicesInterestConnectionUpdated_At>>>;
  email?: Maybe<Array<Maybe<ServicesInterestConnectionEmail>>>;
  services?: Maybe<Array<Maybe<ServicesInterestConnectionServices>>>;
  requested_conversation_with?: Maybe<Array<Maybe<ServicesInterestConnectionRequested_Conversation_With>>>;
};

export type ServicesInterestInput = {
  email?: Maybe<Scalars['String']>;
  services?: Maybe<Scalars['JSON']>;
  requested_conversation_with?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type SetMessagesReadInput = {
  ids?: Maybe<Array<Scalars['String']>>;
};

export type SettingsInput = {
  notifications?: Maybe<NotificationPreferenceInput>;
};

export type StartConversationInput = {
  techSolutionId: Scalars['ID'];
  techRequestId: Scalars['ID'];
};

export type StartConversationPayload = {
  __typename?: 'StartConversationPayload';
  id: Scalars['ID'];
};

export type StartConversationTermsConditionInput = {
  content?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type StartConversationTermsConditions = {
  __typename?: 'StartConversationTermsConditions';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  content?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type StartupProfile = {
  __typename?: 'StartupProfile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  avatar?: Maybe<UploadFile>;
  psuedo_name?: Maybe<Scalars['String']>;
  operating_locations?: Maybe<Scalars['String']>;
  employee_count?: Maybe<Scalars['Int']>;
  links?: Maybe<ComponentGenericLinks>;
  worked_with_corporates?: Maybe<Scalars['Boolean']>;
  clients?: Maybe<Scalars['String']>;
  incubators_accelerators?: Maybe<Scalars['String']>;
  investment_received?: Maybe<Scalars['Long']>;
  maturity_level?: Maybe<MaturityLevel>;
  rating?: Maybe<Scalars['Float']>;
  investment_stage?: Maybe<Scalars['String']>;
  client_count?: Maybe<Scalars['Int']>;
  employee_count_range?: Maybe<Scalars['String']>;
  went_incubator_accelerator?: Maybe<Scalars['Boolean']>;
  investment_received_currency?: Maybe<Scalars['String']>;
  esg_rating?: Maybe<Enum_Startupprofile_Esg_Rating>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  person_profiles?: Maybe<Array<Maybe<PersonProfile>>>;
  technology_solutions?: Maybe<Array<Maybe<TechnologySolution>>>;
  catalyst_allocations?: Maybe<Array<Maybe<CatalystAllocation>>>;
  sdg_objectives?: Maybe<Array<Maybe<SdgObjectives>>>;
};


export type StartupProfileIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StartupProfilePerson_ProfilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StartupProfileTechnology_SolutionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StartupProfileCatalyst_AllocationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StartupProfileSdg_ObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type StartupProfileAggregator = {
  __typename?: 'StartupProfileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<StartupProfileAggregatorSum>;
  avg?: Maybe<StartupProfileAggregatorAvg>;
  min?: Maybe<StartupProfileAggregatorMin>;
  max?: Maybe<StartupProfileAggregatorMax>;
};

export type StartupProfileAggregatorAvg = {
  __typename?: 'StartupProfileAggregatorAvg';
  employee_count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  client_count?: Maybe<Scalars['Float']>;
};

export type StartupProfileAggregatorMax = {
  __typename?: 'StartupProfileAggregatorMax';
  employee_count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  client_count?: Maybe<Scalars['Float']>;
};

export type StartupProfileAggregatorMin = {
  __typename?: 'StartupProfileAggregatorMin';
  employee_count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  client_count?: Maybe<Scalars['Float']>;
};

export type StartupProfileAggregatorSum = {
  __typename?: 'StartupProfileAggregatorSum';
  employee_count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  client_count?: Maybe<Scalars['Float']>;
};

export type StartupProfileConnection = {
  __typename?: 'StartupProfileConnection';
  values?: Maybe<Array<Maybe<StartupProfile>>>;
  groupBy?: Maybe<StartupProfileGroupBy>;
  aggregate?: Maybe<StartupProfileAggregator>;
};

export type StartupProfileConnectionAvatar = {
  __typename?: 'StartupProfileConnectionAvatar';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionClient_Count = {
  __typename?: 'StartupProfileConnectionClient_count';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionClients = {
  __typename?: 'StartupProfileConnectionClients';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionCountry = {
  __typename?: 'StartupProfileConnectionCountry';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionCreated_At = {
  __typename?: 'StartupProfileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionDescription = {
  __typename?: 'StartupProfileConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionEmployee_Count = {
  __typename?: 'StartupProfileConnectionEmployee_count';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionEmployee_Count_Range = {
  __typename?: 'StartupProfileConnectionEmployee_count_range';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionEsg_Rating = {
  __typename?: 'StartupProfileConnectionEsg_rating';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionId = {
  __typename?: 'StartupProfileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionIncubators_Accelerators = {
  __typename?: 'StartupProfileConnectionIncubators_accelerators';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionInvestment_Received = {
  __typename?: 'StartupProfileConnectionInvestment_received';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionInvestment_Received_Currency = {
  __typename?: 'StartupProfileConnectionInvestment_received_currency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionInvestment_Stage = {
  __typename?: 'StartupProfileConnectionInvestment_stage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionLinks = {
  __typename?: 'StartupProfileConnectionLinks';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionLogo = {
  __typename?: 'StartupProfileConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionMaturity_Level = {
  __typename?: 'StartupProfileConnectionMaturity_level';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionName = {
  __typename?: 'StartupProfileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionOperating_Locations = {
  __typename?: 'StartupProfileConnectionOperating_locations';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionPsuedo_Name = {
  __typename?: 'StartupProfileConnectionPsuedo_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionRating = {
  __typename?: 'StartupProfileConnectionRating';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionStart_Date = {
  __typename?: 'StartupProfileConnectionStart_date';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionUpdated_At = {
  __typename?: 'StartupProfileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionWent_Incubator_Accelerator = {
  __typename?: 'StartupProfileConnectionWent_incubator_accelerator';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileConnectionWorked_With_Corporates = {
  __typename?: 'StartupProfileConnectionWorked_with_corporates';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<StartupProfileConnection>;
};

export type StartupProfileGroupBy = {
  __typename?: 'StartupProfileGroupBy';
  id?: Maybe<Array<Maybe<StartupProfileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<StartupProfileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<StartupProfileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<StartupProfileConnectionName>>>;
  start_date?: Maybe<Array<Maybe<StartupProfileConnectionStart_Date>>>;
  description?: Maybe<Array<Maybe<StartupProfileConnectionDescription>>>;
  country?: Maybe<Array<Maybe<StartupProfileConnectionCountry>>>;
  logo?: Maybe<Array<Maybe<StartupProfileConnectionLogo>>>;
  avatar?: Maybe<Array<Maybe<StartupProfileConnectionAvatar>>>;
  psuedo_name?: Maybe<Array<Maybe<StartupProfileConnectionPsuedo_Name>>>;
  operating_locations?: Maybe<Array<Maybe<StartupProfileConnectionOperating_Locations>>>;
  employee_count?: Maybe<Array<Maybe<StartupProfileConnectionEmployee_Count>>>;
  links?: Maybe<Array<Maybe<StartupProfileConnectionLinks>>>;
  worked_with_corporates?: Maybe<Array<Maybe<StartupProfileConnectionWorked_With_Corporates>>>;
  clients?: Maybe<Array<Maybe<StartupProfileConnectionClients>>>;
  incubators_accelerators?: Maybe<Array<Maybe<StartupProfileConnectionIncubators_Accelerators>>>;
  investment_received?: Maybe<Array<Maybe<StartupProfileConnectionInvestment_Received>>>;
  maturity_level?: Maybe<Array<Maybe<StartupProfileConnectionMaturity_Level>>>;
  rating?: Maybe<Array<Maybe<StartupProfileConnectionRating>>>;
  investment_stage?: Maybe<Array<Maybe<StartupProfileConnectionInvestment_Stage>>>;
  client_count?: Maybe<Array<Maybe<StartupProfileConnectionClient_Count>>>;
  employee_count_range?: Maybe<Array<Maybe<StartupProfileConnectionEmployee_Count_Range>>>;
  went_incubator_accelerator?: Maybe<Array<Maybe<StartupProfileConnectionWent_Incubator_Accelerator>>>;
  investment_received_currency?: Maybe<Array<Maybe<StartupProfileConnectionInvestment_Received_Currency>>>;
  esg_rating?: Maybe<Array<Maybe<StartupProfileConnectionEsg_Rating>>>;
};

export type StartupProfileInput = {
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  logo?: Maybe<Scalars['ID']>;
  avatar?: Maybe<Scalars['ID']>;
  person_profiles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  psuedo_name?: Maybe<Scalars['String']>;
  operating_locations?: Maybe<Scalars['String']>;
  employee_count?: Maybe<Scalars['Int']>;
  links?: Maybe<ComponentGenericLinkInput>;
  worked_with_corporates?: Maybe<Scalars['Boolean']>;
  clients?: Maybe<Scalars['String']>;
  incubators_accelerators?: Maybe<Scalars['String']>;
  investment_received?: Maybe<Scalars['Long']>;
  maturity_level?: Maybe<Scalars['ID']>;
  technology_solutions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rating?: Maybe<Scalars['Float']>;
  investment_stage?: Maybe<Scalars['String']>;
  client_count?: Maybe<Scalars['Int']>;
  employee_count_range?: Maybe<Scalars['String']>;
  went_incubator_accelerator?: Maybe<Scalars['Boolean']>;
  investment_received_currency?: Maybe<Scalars['String']>;
  catalyst_allocations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  esg_rating?: Maybe<Enum_Startupprofile_Esg_Rating>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type SubmitInterestInput = {
  services: Array<Maybe<SubmitInterestItem>>;
  requested_conversation_with: Scalars['JSON'];
};

export type SubmitInterestItem = {
  name: Scalars['String'];
};

export type TechnologyReadinessLevel = {
  __typename?: 'TechnologyReadinessLevel';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type TechnologyReadinessLevelAggregator = {
  __typename?: 'TechnologyReadinessLevelAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TechnologyReadinessLevelConnection = {
  __typename?: 'TechnologyReadinessLevelConnection';
  values?: Maybe<Array<Maybe<TechnologyReadinessLevel>>>;
  groupBy?: Maybe<TechnologyReadinessLevelGroupBy>;
  aggregate?: Maybe<TechnologyReadinessLevelAggregator>;
};

export type TechnologyReadinessLevelConnectionCreated_At = {
  __typename?: 'TechnologyReadinessLevelConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologyReadinessLevelConnection>;
};

export type TechnologyReadinessLevelConnectionId = {
  __typename?: 'TechnologyReadinessLevelConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyReadinessLevelConnection>;
};

export type TechnologyReadinessLevelConnectionName = {
  __typename?: 'TechnologyReadinessLevelConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyReadinessLevelConnection>;
};

export type TechnologyReadinessLevelConnectionUpdated_At = {
  __typename?: 'TechnologyReadinessLevelConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologyReadinessLevelConnection>;
};

export type TechnologyReadinessLevelGroupBy = {
  __typename?: 'TechnologyReadinessLevelGroupBy';
  id?: Maybe<Array<Maybe<TechnologyReadinessLevelConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TechnologyReadinessLevelConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TechnologyReadinessLevelConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<TechnologyReadinessLevelConnectionName>>>;
};

export type TechnologyReadinessLevelInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TechnologyRequest = {
  __typename?: 'TechnologyRequest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  has_ip?: Maybe<Scalars['Boolean']>;
  can_whitelabel?: Maybe<Scalars['Boolean']>;
  want_poc?: Maybe<Scalars['Boolean']>;
  want_seller?: Maybe<Scalars['Boolean']>;
  want_lease?: Maybe<Scalars['Boolean']>;
  has_api?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  budget_min?: Maybe<Scalars['Float']>;
  budget_max?: Maybe<Scalars['Float']>;
  budget_is_disclose?: Maybe<Scalars['Boolean']>;
  business_challange_description?: Maybe<Scalars['String']>;
  projected_startdate?: Maybe<Scalars['Date']>;
  projected_complete_date?: Maybe<Scalars['Date']>;
  country_implementation?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  business_type?: Maybe<Scalars['String']>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_others?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
  other_tech_option?: Maybe<Scalars['String']>;
  description_project?: Maybe<Scalars['String']>;
  description_how_to_resolve_problem?: Maybe<Scalars['String']>;
  description_customer?: Maybe<Scalars['String']>;
  description_successful_outcome?: Maybe<Scalars['String']>;
  description_similiar_solutions?: Maybe<Scalars['String']>;
  description_risk_challenges?: Maybe<Scalars['String']>;
  want_explore?: Maybe<Scalars['Boolean']>;
  budget_is_poc?: Maybe<Scalars['Boolean']>;
  budget_is_lease?: Maybe<Scalars['Boolean']>;
  hero_image?: Maybe<UploadFile>;
  is_published?: Maybe<Scalars['Boolean']>;
  budget_is_buy?: Maybe<Scalars['Boolean']>;
  impact_level?: Maybe<Scalars['String']>;
  project_budget?: Maybe<Array<Maybe<ComponentTechnologySolutionProjectBudget>>>;
  impact_area?: Maybe<ImpactArea>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  want_investment?: Maybe<Scalars['Boolean']>;
  is_others?: Maybe<Scalars['String']>;
  corporate_profile?: Maybe<Corporate>;
  is_match_triggered?: Maybe<Scalars['Boolean']>;
  want_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  goal_other?: Maybe<Scalars['String']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  technology_types?: Maybe<Array<Maybe<TechnologyType>>>;
  business_use_cases?: Maybe<Array<Maybe<BusinessUseCase>>>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  corporate_departments?: Maybe<Array<Maybe<CorporateDepartment>>>;
  specification_files?: Maybe<Array<Maybe<UploadFile>>>;
  goals?: Maybe<Array<Maybe<Goals>>>;
  conversations?: Maybe<Array<Maybe<Conversations>>>;
  sdg_objectives?: Maybe<Array<Maybe<SdgObjectives>>>;
};


export type TechnologyRequestTechnology_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologyRequestBusiness_Use_CasesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologyRequestIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologyRequestCorporate_DepartmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologyRequestSpecification_FilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologyRequestGoalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologyRequestConversationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologyRequestSdg_ObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TechnologyRequestAggregator = {
  __typename?: 'TechnologyRequestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<TechnologyRequestAggregatorSum>;
  avg?: Maybe<TechnologyRequestAggregatorAvg>;
  min?: Maybe<TechnologyRequestAggregatorMin>;
  max?: Maybe<TechnologyRequestAggregatorMax>;
};

export type TechnologyRequestAggregatorAvg = {
  __typename?: 'TechnologyRequestAggregatorAvg';
  budget_min?: Maybe<Scalars['Float']>;
  budget_max?: Maybe<Scalars['Float']>;
};

export type TechnologyRequestAggregatorMax = {
  __typename?: 'TechnologyRequestAggregatorMax';
  budget_min?: Maybe<Scalars['Float']>;
  budget_max?: Maybe<Scalars['Float']>;
};

export type TechnologyRequestAggregatorMin = {
  __typename?: 'TechnologyRequestAggregatorMin';
  budget_min?: Maybe<Scalars['Float']>;
  budget_max?: Maybe<Scalars['Float']>;
};

export type TechnologyRequestAggregatorSum = {
  __typename?: 'TechnologyRequestAggregatorSum';
  budget_min?: Maybe<Scalars['Float']>;
  budget_max?: Maybe<Scalars['Float']>;
};

export type TechnologyRequestConnection = {
  __typename?: 'TechnologyRequestConnection';
  values?: Maybe<Array<Maybe<TechnologyRequest>>>;
  groupBy?: Maybe<TechnologyRequestGroupBy>;
  aggregate?: Maybe<TechnologyRequestAggregator>;
};

export type TechnologyRequestConnectionBudget_Is_Buy = {
  __typename?: 'TechnologyRequestConnectionBudget_is_buy';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionBudget_Is_Disclose = {
  __typename?: 'TechnologyRequestConnectionBudget_is_disclose';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionBudget_Is_Lease = {
  __typename?: 'TechnologyRequestConnectionBudget_is_lease';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionBudget_Is_Poc = {
  __typename?: 'TechnologyRequestConnectionBudget_is_poc';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionBudget_Max = {
  __typename?: 'TechnologyRequestConnectionBudget_max';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionBudget_Min = {
  __typename?: 'TechnologyRequestConnectionBudget_min';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionBusiness_Challange_Description = {
  __typename?: 'TechnologyRequestConnectionBusiness_challange_description';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionBusiness_Type = {
  __typename?: 'TechnologyRequestConnectionBusiness_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionCan_Whitelabel = {
  __typename?: 'TechnologyRequestConnectionCan_whitelabel';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionCorporate_Profile = {
  __typename?: 'TechnologyRequestConnectionCorporate_profile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionCountry_Implementation = {
  __typename?: 'TechnologyRequestConnectionCountry_implementation';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionCreated_At = {
  __typename?: 'TechnologyRequestConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionCurrency = {
  __typename?: 'TechnologyRequestConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionDescription_Customer = {
  __typename?: 'TechnologyRequestConnectionDescription_customer';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionDescription_How_To_Resolve_Problem = {
  __typename?: 'TechnologyRequestConnectionDescription_how_to_resolve_problem';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionDescription_Project = {
  __typename?: 'TechnologyRequestConnectionDescription_project';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionDescription_Risk_Challenges = {
  __typename?: 'TechnologyRequestConnectionDescription_risk_challenges';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionDescription_Similiar_Solutions = {
  __typename?: 'TechnologyRequestConnectionDescription_similiar_solutions';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionDescription_Successful_Outcome = {
  __typename?: 'TechnologyRequestConnectionDescription_successful_outcome';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionEnd_Date = {
  __typename?: 'TechnologyRequestConnectionEnd_date';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionGoal_Other = {
  __typename?: 'TechnologyRequestConnectionGoal_other';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionHas_Api = {
  __typename?: 'TechnologyRequestConnectionHas_api';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionHas_Ip = {
  __typename?: 'TechnologyRequestConnectionHas_ip';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionHero_Image = {
  __typename?: 'TechnologyRequestConnectionHero_image';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionId = {
  __typename?: 'TechnologyRequestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionImpact_Area = {
  __typename?: 'TechnologyRequestConnectionImpact_area';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionImpact_Level = {
  __typename?: 'TechnologyRequestConnectionImpact_level';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionIs_Cloud = {
  __typename?: 'TechnologyRequestConnectionIs_cloud';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionIs_Completed = {
  __typename?: 'TechnologyRequestConnectionIs_completed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionIs_Gdpr = {
  __typename?: 'TechnologyRequestConnectionIs_gdpr';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionIs_Match_Triggered = {
  __typename?: 'TechnologyRequestConnectionIs_match_triggered';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionIs_Others = {
  __typename?: 'TechnologyRequestConnectionIs_others';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionIs_Plugandplay = {
  __typename?: 'TechnologyRequestConnectionIs_plugandplay';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionIs_Published = {
  __typename?: 'TechnologyRequestConnectionIs_published';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionIs_Spin_Off = {
  __typename?: 'TechnologyRequestConnectionIs_spin_off';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionName = {
  __typename?: 'TechnologyRequestConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionOther_Tech_Option = {
  __typename?: 'TechnologyRequestConnectionOther_tech_option';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionProjected_Complete_Date = {
  __typename?: 'TechnologyRequestConnectionProjected_complete_date';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionProjected_Startdate = {
  __typename?: 'TechnologyRequestConnectionProjected_startdate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionPublished_At = {
  __typename?: 'TechnologyRequestConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionSdg_Driven = {
  __typename?: 'TechnologyRequestConnectionSdg_driven';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionSpecifications = {
  __typename?: 'TechnologyRequestConnectionSpecifications';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionStart_Date = {
  __typename?: 'TechnologyRequestConnectionStart_date';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionTechnology_Solution_Model_B2b = {
  __typename?: 'TechnologyRequestConnectionTechnology_solution_model_b2b';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionTechnology_Solution_Model_B2b2c = {
  __typename?: 'TechnologyRequestConnectionTechnology_solution_model_b2b2c';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionTechnology_Solution_Model_B2c = {
  __typename?: 'TechnologyRequestConnectionTechnology_solution_model_b2c';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionTechnology_Solution_Model_Others = {
  __typename?: 'TechnologyRequestConnectionTechnology_solution_model_others';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionUpdated_At = {
  __typename?: 'TechnologyRequestConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionWant_Access_Alkelio_Services = {
  __typename?: 'TechnologyRequestConnectionWant_access_alkelio_services';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionWant_Explore = {
  __typename?: 'TechnologyRequestConnectionWant_explore';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionWant_Investment = {
  __typename?: 'TechnologyRequestConnectionWant_investment';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionWant_Lease = {
  __typename?: 'TechnologyRequestConnectionWant_lease';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionWant_Poc = {
  __typename?: 'TechnologyRequestConnectionWant_poc';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestConnectionWant_Seller = {
  __typename?: 'TechnologyRequestConnectionWant_seller';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologyRequestConnection>;
};

export type TechnologyRequestGroupBy = {
  __typename?: 'TechnologyRequestGroupBy';
  id?: Maybe<Array<Maybe<TechnologyRequestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TechnologyRequestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TechnologyRequestConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<TechnologyRequestConnectionName>>>;
  has_ip?: Maybe<Array<Maybe<TechnologyRequestConnectionHas_Ip>>>;
  can_whitelabel?: Maybe<Array<Maybe<TechnologyRequestConnectionCan_Whitelabel>>>;
  want_poc?: Maybe<Array<Maybe<TechnologyRequestConnectionWant_Poc>>>;
  want_seller?: Maybe<Array<Maybe<TechnologyRequestConnectionWant_Seller>>>;
  want_lease?: Maybe<Array<Maybe<TechnologyRequestConnectionWant_Lease>>>;
  has_api?: Maybe<Array<Maybe<TechnologyRequestConnectionHas_Api>>>;
  is_plugandplay?: Maybe<Array<Maybe<TechnologyRequestConnectionIs_Plugandplay>>>;
  budget_min?: Maybe<Array<Maybe<TechnologyRequestConnectionBudget_Min>>>;
  budget_max?: Maybe<Array<Maybe<TechnologyRequestConnectionBudget_Max>>>;
  budget_is_disclose?: Maybe<Array<Maybe<TechnologyRequestConnectionBudget_Is_Disclose>>>;
  business_challange_description?: Maybe<Array<Maybe<TechnologyRequestConnectionBusiness_Challange_Description>>>;
  projected_startdate?: Maybe<Array<Maybe<TechnologyRequestConnectionProjected_Startdate>>>;
  projected_complete_date?: Maybe<Array<Maybe<TechnologyRequestConnectionProjected_Complete_Date>>>;
  country_implementation?: Maybe<Array<Maybe<TechnologyRequestConnectionCountry_Implementation>>>;
  specifications?: Maybe<Array<Maybe<TechnologyRequestConnectionSpecifications>>>;
  business_type?: Maybe<Array<Maybe<TechnologyRequestConnectionBusiness_Type>>>;
  is_gdpr?: Maybe<Array<Maybe<TechnologyRequestConnectionIs_Gdpr>>>;
  is_cloud?: Maybe<Array<Maybe<TechnologyRequestConnectionIs_Cloud>>>;
  technology_solution_model_b2b?: Maybe<Array<Maybe<TechnologyRequestConnectionTechnology_Solution_Model_B2b>>>;
  technology_solution_model_b2c?: Maybe<Array<Maybe<TechnologyRequestConnectionTechnology_Solution_Model_B2c>>>;
  technology_solution_model_b2b2c?: Maybe<Array<Maybe<TechnologyRequestConnectionTechnology_Solution_Model_B2b2c>>>;
  technology_solution_model_others?: Maybe<Array<Maybe<TechnologyRequestConnectionTechnology_Solution_Model_Others>>>;
  currency?: Maybe<Array<Maybe<TechnologyRequestConnectionCurrency>>>;
  start_date?: Maybe<Array<Maybe<TechnologyRequestConnectionStart_Date>>>;
  end_date?: Maybe<Array<Maybe<TechnologyRequestConnectionEnd_Date>>>;
  other_tech_option?: Maybe<Array<Maybe<TechnologyRequestConnectionOther_Tech_Option>>>;
  description_project?: Maybe<Array<Maybe<TechnologyRequestConnectionDescription_Project>>>;
  description_how_to_resolve_problem?: Maybe<Array<Maybe<TechnologyRequestConnectionDescription_How_To_Resolve_Problem>>>;
  description_customer?: Maybe<Array<Maybe<TechnologyRequestConnectionDescription_Customer>>>;
  description_successful_outcome?: Maybe<Array<Maybe<TechnologyRequestConnectionDescription_Successful_Outcome>>>;
  description_similiar_solutions?: Maybe<Array<Maybe<TechnologyRequestConnectionDescription_Similiar_Solutions>>>;
  description_risk_challenges?: Maybe<Array<Maybe<TechnologyRequestConnectionDescription_Risk_Challenges>>>;
  want_explore?: Maybe<Array<Maybe<TechnologyRequestConnectionWant_Explore>>>;
  budget_is_poc?: Maybe<Array<Maybe<TechnologyRequestConnectionBudget_Is_Poc>>>;
  budget_is_lease?: Maybe<Array<Maybe<TechnologyRequestConnectionBudget_Is_Lease>>>;
  hero_image?: Maybe<Array<Maybe<TechnologyRequestConnectionHero_Image>>>;
  is_published?: Maybe<Array<Maybe<TechnologyRequestConnectionIs_Published>>>;
  budget_is_buy?: Maybe<Array<Maybe<TechnologyRequestConnectionBudget_Is_Buy>>>;
  impact_level?: Maybe<Array<Maybe<TechnologyRequestConnectionImpact_Level>>>;
  impact_area?: Maybe<Array<Maybe<TechnologyRequestConnectionImpact_Area>>>;
  is_spin_off?: Maybe<Array<Maybe<TechnologyRequestConnectionIs_Spin_Off>>>;
  want_investment?: Maybe<Array<Maybe<TechnologyRequestConnectionWant_Investment>>>;
  is_others?: Maybe<Array<Maybe<TechnologyRequestConnectionIs_Others>>>;
  corporate_profile?: Maybe<Array<Maybe<TechnologyRequestConnectionCorporate_Profile>>>;
  is_match_triggered?: Maybe<Array<Maybe<TechnologyRequestConnectionIs_Match_Triggered>>>;
  want_access_alkelio_services?: Maybe<Array<Maybe<TechnologyRequestConnectionWant_Access_Alkelio_Services>>>;
  goal_other?: Maybe<Array<Maybe<TechnologyRequestConnectionGoal_Other>>>;
  is_completed?: Maybe<Array<Maybe<TechnologyRequestConnectionIs_Completed>>>;
  sdg_driven?: Maybe<Array<Maybe<TechnologyRequestConnectionSdg_Driven>>>;
  published_at?: Maybe<Array<Maybe<TechnologyRequestConnectionPublished_At>>>;
};

export type TechnologyRequestInput = {
  name?: Maybe<Scalars['String']>;
  technology_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  has_ip?: Maybe<Scalars['Boolean']>;
  can_whitelabel?: Maybe<Scalars['Boolean']>;
  want_poc?: Maybe<Scalars['Boolean']>;
  want_seller?: Maybe<Scalars['Boolean']>;
  want_lease?: Maybe<Scalars['Boolean']>;
  has_api?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  business_use_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  corporate_departments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  budget_min?: Maybe<Scalars['Float']>;
  budget_max?: Maybe<Scalars['Float']>;
  budget_is_disclose?: Maybe<Scalars['Boolean']>;
  business_challange_description?: Maybe<Scalars['String']>;
  projected_startdate?: Maybe<Scalars['Date']>;
  projected_complete_date?: Maybe<Scalars['Date']>;
  country_implementation?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  specification_files?: Maybe<Array<Maybe<Scalars['ID']>>>;
  business_type?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_others?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
  other_tech_option?: Maybe<Scalars['String']>;
  description_project?: Maybe<Scalars['String']>;
  description_how_to_resolve_problem?: Maybe<Scalars['String']>;
  description_customer?: Maybe<Scalars['String']>;
  description_successful_outcome?: Maybe<Scalars['String']>;
  description_similiar_solutions?: Maybe<Scalars['String']>;
  description_risk_challenges?: Maybe<Scalars['String']>;
  want_explore?: Maybe<Scalars['Boolean']>;
  conversations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  budget_is_poc?: Maybe<Scalars['Boolean']>;
  budget_is_lease?: Maybe<Scalars['Boolean']>;
  hero_image?: Maybe<Scalars['ID']>;
  is_published?: Maybe<Scalars['Boolean']>;
  budget_is_buy?: Maybe<Scalars['Boolean']>;
  impact_level?: Maybe<Scalars['String']>;
  project_budget?: Maybe<Array<Maybe<ComponentTechnologySolutionProjectBudgetInput>>>;
  impact_area?: Maybe<Scalars['ID']>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  want_investment?: Maybe<Scalars['Boolean']>;
  is_others?: Maybe<Scalars['String']>;
  corporate_profile?: Maybe<Scalars['ID']>;
  is_match_triggered?: Maybe<Scalars['Boolean']>;
  want_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  goal_other?: Maybe<Scalars['String']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TechnologySolution = {
  __typename?: 'TechnologySolution';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  purpose_poc?: Maybe<Scalars['Boolean']>;
  purpose_sell?: Maybe<Scalars['Boolean']>;
  purpose_lease?: Maybe<Scalars['Boolean']>;
  has_ip?: Maybe<Scalars['Boolean']>;
  is_whitelabel?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  has_api?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  hero_image?: Maybe<UploadFile>;
  embed_demo_url?: Maybe<Scalars['String']>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  spin_off_source?: Maybe<Scalars['String']>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  key_features?: Maybe<Scalars['String']>;
  versions_release_dates?: Maybe<Scalars['String']>;
  supported_operating_systems?: Maybe<Scalars['String']>;
  total_investment?: Maybe<Scalars['String']>;
  resources_required?: Maybe<Scalars['String']>;
  resource_transfer_details?: Maybe<Scalars['String']>;
  licensing_type_details?: Maybe<Scalars['String']>;
  reason_to_sell?: Maybe<Scalars['String']>;
  assets_to_sell?: Maybe<Scalars['String']>;
  is_consumer_data_collected?: Maybe<Scalars['Boolean']>;
  is_tech_transferrable?: Maybe<Scalars['Boolean']>;
  price_poc_min?: Maybe<Scalars['Float']>;
  price_poc_max?: Maybe<Scalars['Float']>;
  price_lease_min?: Maybe<Scalars['Float']>;
  price_lease_max?: Maybe<Scalars['Float']>;
  demo_video?: Maybe<UploadFile>;
  is_others?: Maybe<Scalars['String']>;
  purpose_certify?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['String']>;
  price_sell_min?: Maybe<Scalars['Float']>;
  price_sell_max?: Maybe<Scalars['Float']>;
  is_published?: Maybe<Scalars['Boolean']>;
  benefits_description?: Maybe<Scalars['String']>;
  purpose_investment?: Maybe<Scalars['Boolean']>;
  project_budget?: Maybe<Array<Maybe<ComponentTechnologySolutionProjectBudget>>>;
  testimonial?: Maybe<ComponentTechnologySolutionTestimonial>;
  invest_information?: Maybe<ComponentTechnologySolutionInvestInformation>;
  technology_readiness?: Maybe<Scalars['String']>;
  use_case_count?: Maybe<Scalars['Int']>;
  use?: Maybe<Scalars['Boolean']>;
  is_use_case_on_request?: Maybe<Scalars['Boolean']>;
  is_consumer_data_collected_remarks?: Maybe<Scalars['String']>;
  is_tech_transferrable_remarks?: Maybe<Scalars['String']>;
  want_to_transfer_resources?: Maybe<Scalars['String']>;
  company_performance_annual_sales?: Maybe<Scalars['String']>;
  is_match_triggered?: Maybe<Scalars['Boolean']>;
  startup_profile?: Maybe<StartupProfile>;
  rating?: Maybe<Scalars['Float']>;
  tested_by_alkelio?: Maybe<Scalars['Boolean']>;
  technology_solution_pricing_model?: Maybe<Array<Maybe<ComponentPricingTechnologySolutionPricingModel>>>;
  purpose_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  purpose_explore?: Maybe<Scalars['Boolean']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  case_studies?: Maybe<ComponentTechnologySolutionCaseStudies>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  media?: Maybe<Array<Maybe<UploadFile>>>;
  technology_types?: Maybe<Array<Maybe<TechnologyType>>>;
  industries?: Maybe<Array<Maybe<Industry>>>;
  business_use_cases?: Maybe<Array<Maybe<BusinessUseCase>>>;
  corporate_departments?: Maybe<Array<Maybe<CorporateDepartment>>>;
  pricing_models?: Maybe<Array<Maybe<PricingModel>>>;
  demo_document?: Maybe<Array<Maybe<UploadFile>>>;
  conversations?: Maybe<Array<Maybe<Conversations>>>;
  sdg_objectives?: Maybe<Array<Maybe<SdgObjectives>>>;
};


export type TechnologySolutionMediaArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologySolutionTechnology_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologySolutionIndustriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologySolutionBusiness_Use_CasesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologySolutionCorporate_DepartmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologySolutionPricing_ModelsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologySolutionDemo_DocumentArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologySolutionConversationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TechnologySolutionSdg_ObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TechnologySolutionAggregator = {
  __typename?: 'TechnologySolutionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<TechnologySolutionAggregatorSum>;
  avg?: Maybe<TechnologySolutionAggregatorAvg>;
  min?: Maybe<TechnologySolutionAggregatorMin>;
  max?: Maybe<TechnologySolutionAggregatorMax>;
};

export type TechnologySolutionAggregatorAvg = {
  __typename?: 'TechnologySolutionAggregatorAvg';
  price_poc_min?: Maybe<Scalars['Float']>;
  price_poc_max?: Maybe<Scalars['Float']>;
  price_lease_min?: Maybe<Scalars['Float']>;
  price_lease_max?: Maybe<Scalars['Float']>;
  price_sell_min?: Maybe<Scalars['Float']>;
  price_sell_max?: Maybe<Scalars['Float']>;
  use_case_count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

export type TechnologySolutionAggregatorMax = {
  __typename?: 'TechnologySolutionAggregatorMax';
  price_poc_min?: Maybe<Scalars['Float']>;
  price_poc_max?: Maybe<Scalars['Float']>;
  price_lease_min?: Maybe<Scalars['Float']>;
  price_lease_max?: Maybe<Scalars['Float']>;
  price_sell_min?: Maybe<Scalars['Float']>;
  price_sell_max?: Maybe<Scalars['Float']>;
  use_case_count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

export type TechnologySolutionAggregatorMin = {
  __typename?: 'TechnologySolutionAggregatorMin';
  price_poc_min?: Maybe<Scalars['Float']>;
  price_poc_max?: Maybe<Scalars['Float']>;
  price_lease_min?: Maybe<Scalars['Float']>;
  price_lease_max?: Maybe<Scalars['Float']>;
  price_sell_min?: Maybe<Scalars['Float']>;
  price_sell_max?: Maybe<Scalars['Float']>;
  use_case_count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

export type TechnologySolutionAggregatorSum = {
  __typename?: 'TechnologySolutionAggregatorSum';
  price_poc_min?: Maybe<Scalars['Float']>;
  price_poc_max?: Maybe<Scalars['Float']>;
  price_lease_min?: Maybe<Scalars['Float']>;
  price_lease_max?: Maybe<Scalars['Float']>;
  price_sell_min?: Maybe<Scalars['Float']>;
  price_sell_max?: Maybe<Scalars['Float']>;
  use_case_count?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

export type TechnologySolutionConnection = {
  __typename?: 'TechnologySolutionConnection';
  values?: Maybe<Array<Maybe<TechnologySolution>>>;
  groupBy?: Maybe<TechnologySolutionGroupBy>;
  aggregate?: Maybe<TechnologySolutionAggregator>;
};

export type TechnologySolutionConnectionAssets_To_Sell = {
  __typename?: 'TechnologySolutionConnectionAssets_to_sell';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionBenefits_Description = {
  __typename?: 'TechnologySolutionConnectionBenefits_description';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionCase_Studies = {
  __typename?: 'TechnologySolutionConnectionCase_studies';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionCompany_Performance_Annual_Sales = {
  __typename?: 'TechnologySolutionConnectionCompany_performance_annual_sales';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionCreated_At = {
  __typename?: 'TechnologySolutionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionCurrency = {
  __typename?: 'TechnologySolutionConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionDemo_Video = {
  __typename?: 'TechnologySolutionConnectionDemo_video';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionDescription = {
  __typename?: 'TechnologySolutionConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionEmbed_Demo_Url = {
  __typename?: 'TechnologySolutionConnectionEmbed_demo_url';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionHas_Api = {
  __typename?: 'TechnologySolutionConnectionHas_api';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionHas_Ip = {
  __typename?: 'TechnologySolutionConnectionHas_ip';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionHero_Image = {
  __typename?: 'TechnologySolutionConnectionHero_image';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionId = {
  __typename?: 'TechnologySolutionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionInvest_Information = {
  __typename?: 'TechnologySolutionConnectionInvest_information';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Cloud = {
  __typename?: 'TechnologySolutionConnectionIs_cloud';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Completed = {
  __typename?: 'TechnologySolutionConnectionIs_completed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Consumer_Data_Collected = {
  __typename?: 'TechnologySolutionConnectionIs_consumer_data_collected';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Consumer_Data_Collected_Remarks = {
  __typename?: 'TechnologySolutionConnectionIs_consumer_data_collected_remarks';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Gdpr = {
  __typename?: 'TechnologySolutionConnectionIs_gdpr';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Match_Triggered = {
  __typename?: 'TechnologySolutionConnectionIs_match_triggered';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Others = {
  __typename?: 'TechnologySolutionConnectionIs_others';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Plugandplay = {
  __typename?: 'TechnologySolutionConnectionIs_plugandplay';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Published = {
  __typename?: 'TechnologySolutionConnectionIs_published';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Spin_Off = {
  __typename?: 'TechnologySolutionConnectionIs_spin_off';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Tech_Transferrable = {
  __typename?: 'TechnologySolutionConnectionIs_tech_transferrable';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Tech_Transferrable_Remarks = {
  __typename?: 'TechnologySolutionConnectionIs_tech_transferrable_remarks';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Use_Case_On_Request = {
  __typename?: 'TechnologySolutionConnectionIs_use_case_on_request';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionIs_Whitelabel = {
  __typename?: 'TechnologySolutionConnectionIs_whitelabel';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionKey_Features = {
  __typename?: 'TechnologySolutionConnectionKey_features';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionLicensing_Type_Details = {
  __typename?: 'TechnologySolutionConnectionLicensing_type_details';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionName = {
  __typename?: 'TechnologySolutionConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPrice_Lease_Max = {
  __typename?: 'TechnologySolutionConnectionPrice_lease_max';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPrice_Lease_Min = {
  __typename?: 'TechnologySolutionConnectionPrice_lease_min';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPrice_Poc_Max = {
  __typename?: 'TechnologySolutionConnectionPrice_poc_max';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPrice_Poc_Min = {
  __typename?: 'TechnologySolutionConnectionPrice_poc_min';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPrice_Sell_Max = {
  __typename?: 'TechnologySolutionConnectionPrice_sell_max';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPrice_Sell_Min = {
  __typename?: 'TechnologySolutionConnectionPrice_sell_min';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPublished_At = {
  __typename?: 'TechnologySolutionConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPurpose_Access_Alkelio_Services = {
  __typename?: 'TechnologySolutionConnectionPurpose_access_alkelio_services';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPurpose_Certify = {
  __typename?: 'TechnologySolutionConnectionPurpose_certify';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPurpose_Explore = {
  __typename?: 'TechnologySolutionConnectionPurpose_explore';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPurpose_Investment = {
  __typename?: 'TechnologySolutionConnectionPurpose_investment';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPurpose_Lease = {
  __typename?: 'TechnologySolutionConnectionPurpose_lease';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPurpose_Poc = {
  __typename?: 'TechnologySolutionConnectionPurpose_poc';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionPurpose_Sell = {
  __typename?: 'TechnologySolutionConnectionPurpose_sell';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionRating = {
  __typename?: 'TechnologySolutionConnectionRating';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionReason_To_Sell = {
  __typename?: 'TechnologySolutionConnectionReason_to_sell';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionResource_Transfer_Details = {
  __typename?: 'TechnologySolutionConnectionResource_transfer_details';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionResources_Required = {
  __typename?: 'TechnologySolutionConnectionResources_required';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionSdg_Driven = {
  __typename?: 'TechnologySolutionConnectionSdg_driven';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionSpin_Off_Source = {
  __typename?: 'TechnologySolutionConnectionSpin_off_source';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionStartup_Profile = {
  __typename?: 'TechnologySolutionConnectionStartup_profile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionSupported_Operating_Systems = {
  __typename?: 'TechnologySolutionConnectionSupported_operating_systems';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionTechnology_Readiness = {
  __typename?: 'TechnologySolutionConnectionTechnology_readiness';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionTested_By_Alkelio = {
  __typename?: 'TechnologySolutionConnectionTested_by_alkelio';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionTestimonial = {
  __typename?: 'TechnologySolutionConnectionTestimonial';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionTotal_Investment = {
  __typename?: 'TechnologySolutionConnectionTotal_investment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionUpdated_At = {
  __typename?: 'TechnologySolutionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionUse = {
  __typename?: 'TechnologySolutionConnectionUse';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionUse_Case_Count = {
  __typename?: 'TechnologySolutionConnectionUse_case_count';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionVersions_Release_Dates = {
  __typename?: 'TechnologySolutionConnectionVersions_release_dates';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionConnectionWant_To_Transfer_Resources = {
  __typename?: 'TechnologySolutionConnectionWant_to_transfer_resources';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologySolutionConnection>;
};

export type TechnologySolutionGroupBy = {
  __typename?: 'TechnologySolutionGroupBy';
  id?: Maybe<Array<Maybe<TechnologySolutionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TechnologySolutionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TechnologySolutionConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<TechnologySolutionConnectionName>>>;
  purpose_poc?: Maybe<Array<Maybe<TechnologySolutionConnectionPurpose_Poc>>>;
  purpose_sell?: Maybe<Array<Maybe<TechnologySolutionConnectionPurpose_Sell>>>;
  purpose_lease?: Maybe<Array<Maybe<TechnologySolutionConnectionPurpose_Lease>>>;
  has_ip?: Maybe<Array<Maybe<TechnologySolutionConnectionHas_Ip>>>;
  is_whitelabel?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Whitelabel>>>;
  description?: Maybe<Array<Maybe<TechnologySolutionConnectionDescription>>>;
  has_api?: Maybe<Array<Maybe<TechnologySolutionConnectionHas_Api>>>;
  is_plugandplay?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Plugandplay>>>;
  hero_image?: Maybe<Array<Maybe<TechnologySolutionConnectionHero_Image>>>;
  embed_demo_url?: Maybe<Array<Maybe<TechnologySolutionConnectionEmbed_Demo_Url>>>;
  is_spin_off?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Spin_Off>>>;
  spin_off_source?: Maybe<Array<Maybe<TechnologySolutionConnectionSpin_Off_Source>>>;
  is_gdpr?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Gdpr>>>;
  is_cloud?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Cloud>>>;
  key_features?: Maybe<Array<Maybe<TechnologySolutionConnectionKey_Features>>>;
  versions_release_dates?: Maybe<Array<Maybe<TechnologySolutionConnectionVersions_Release_Dates>>>;
  supported_operating_systems?: Maybe<Array<Maybe<TechnologySolutionConnectionSupported_Operating_Systems>>>;
  total_investment?: Maybe<Array<Maybe<TechnologySolutionConnectionTotal_Investment>>>;
  resources_required?: Maybe<Array<Maybe<TechnologySolutionConnectionResources_Required>>>;
  resource_transfer_details?: Maybe<Array<Maybe<TechnologySolutionConnectionResource_Transfer_Details>>>;
  licensing_type_details?: Maybe<Array<Maybe<TechnologySolutionConnectionLicensing_Type_Details>>>;
  reason_to_sell?: Maybe<Array<Maybe<TechnologySolutionConnectionReason_To_Sell>>>;
  assets_to_sell?: Maybe<Array<Maybe<TechnologySolutionConnectionAssets_To_Sell>>>;
  is_consumer_data_collected?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Consumer_Data_Collected>>>;
  is_tech_transferrable?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Tech_Transferrable>>>;
  price_poc_min?: Maybe<Array<Maybe<TechnologySolutionConnectionPrice_Poc_Min>>>;
  price_poc_max?: Maybe<Array<Maybe<TechnologySolutionConnectionPrice_Poc_Max>>>;
  price_lease_min?: Maybe<Array<Maybe<TechnologySolutionConnectionPrice_Lease_Min>>>;
  price_lease_max?: Maybe<Array<Maybe<TechnologySolutionConnectionPrice_Lease_Max>>>;
  demo_video?: Maybe<Array<Maybe<TechnologySolutionConnectionDemo_Video>>>;
  is_others?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Others>>>;
  purpose_certify?: Maybe<Array<Maybe<TechnologySolutionConnectionPurpose_Certify>>>;
  currency?: Maybe<Array<Maybe<TechnologySolutionConnectionCurrency>>>;
  price_sell_min?: Maybe<Array<Maybe<TechnologySolutionConnectionPrice_Sell_Min>>>;
  price_sell_max?: Maybe<Array<Maybe<TechnologySolutionConnectionPrice_Sell_Max>>>;
  is_published?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Published>>>;
  benefits_description?: Maybe<Array<Maybe<TechnologySolutionConnectionBenefits_Description>>>;
  purpose_investment?: Maybe<Array<Maybe<TechnologySolutionConnectionPurpose_Investment>>>;
  testimonial?: Maybe<Array<Maybe<TechnologySolutionConnectionTestimonial>>>;
  invest_information?: Maybe<Array<Maybe<TechnologySolutionConnectionInvest_Information>>>;
  technology_readiness?: Maybe<Array<Maybe<TechnologySolutionConnectionTechnology_Readiness>>>;
  use_case_count?: Maybe<Array<Maybe<TechnologySolutionConnectionUse_Case_Count>>>;
  use?: Maybe<Array<Maybe<TechnologySolutionConnectionUse>>>;
  is_use_case_on_request?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Use_Case_On_Request>>>;
  is_consumer_data_collected_remarks?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Consumer_Data_Collected_Remarks>>>;
  is_tech_transferrable_remarks?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Tech_Transferrable_Remarks>>>;
  want_to_transfer_resources?: Maybe<Array<Maybe<TechnologySolutionConnectionWant_To_Transfer_Resources>>>;
  company_performance_annual_sales?: Maybe<Array<Maybe<TechnologySolutionConnectionCompany_Performance_Annual_Sales>>>;
  is_match_triggered?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Match_Triggered>>>;
  startup_profile?: Maybe<Array<Maybe<TechnologySolutionConnectionStartup_Profile>>>;
  rating?: Maybe<Array<Maybe<TechnologySolutionConnectionRating>>>;
  tested_by_alkelio?: Maybe<Array<Maybe<TechnologySolutionConnectionTested_By_Alkelio>>>;
  purpose_access_alkelio_services?: Maybe<Array<Maybe<TechnologySolutionConnectionPurpose_Access_Alkelio_Services>>>;
  purpose_explore?: Maybe<Array<Maybe<TechnologySolutionConnectionPurpose_Explore>>>;
  is_completed?: Maybe<Array<Maybe<TechnologySolutionConnectionIs_Completed>>>;
  case_studies?: Maybe<Array<Maybe<TechnologySolutionConnectionCase_Studies>>>;
  sdg_driven?: Maybe<Array<Maybe<TechnologySolutionConnectionSdg_Driven>>>;
  published_at?: Maybe<Array<Maybe<TechnologySolutionConnectionPublished_At>>>;
};

export type TechnologySolutionInput = {
  name?: Maybe<Scalars['String']>;
  purpose_poc?: Maybe<Scalars['Boolean']>;
  purpose_sell?: Maybe<Scalars['Boolean']>;
  purpose_lease?: Maybe<Scalars['Boolean']>;
  has_ip?: Maybe<Scalars['Boolean']>;
  is_whitelabel?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  has_api?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  hero_image?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Scalars['ID']>>>;
  embed_demo_url?: Maybe<Scalars['String']>;
  technology_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  business_use_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  corporate_departments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pricing_models?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  spin_off_source?: Maybe<Scalars['String']>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  key_features?: Maybe<Scalars['String']>;
  versions_release_dates?: Maybe<Scalars['String']>;
  supported_operating_systems?: Maybe<Scalars['String']>;
  total_investment?: Maybe<Scalars['String']>;
  resources_required?: Maybe<Scalars['String']>;
  resource_transfer_details?: Maybe<Scalars['String']>;
  licensing_type_details?: Maybe<Scalars['String']>;
  reason_to_sell?: Maybe<Scalars['String']>;
  assets_to_sell?: Maybe<Scalars['String']>;
  is_consumer_data_collected?: Maybe<Scalars['Boolean']>;
  is_tech_transferrable?: Maybe<Scalars['Boolean']>;
  price_poc_min?: Maybe<Scalars['Float']>;
  price_poc_max?: Maybe<Scalars['Float']>;
  price_lease_min?: Maybe<Scalars['Float']>;
  price_lease_max?: Maybe<Scalars['Float']>;
  demo_video?: Maybe<Scalars['ID']>;
  demo_document?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_others?: Maybe<Scalars['String']>;
  purpose_certify?: Maybe<Scalars['Boolean']>;
  conversations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currency?: Maybe<Scalars['String']>;
  price_sell_min?: Maybe<Scalars['Float']>;
  price_sell_max?: Maybe<Scalars['Float']>;
  is_published?: Maybe<Scalars['Boolean']>;
  benefits_description?: Maybe<Scalars['String']>;
  purpose_investment?: Maybe<Scalars['Boolean']>;
  project_budget?: Maybe<Array<Maybe<ComponentTechnologySolutionProjectBudgetInput>>>;
  testimonial?: Maybe<ComponentTechnologySolutionTestimonialInput>;
  invest_information?: Maybe<ComponentTechnologySolutionInvestInformationInput>;
  technology_readiness?: Maybe<Scalars['String']>;
  use_case_count?: Maybe<Scalars['Int']>;
  use?: Maybe<Scalars['Boolean']>;
  is_use_case_on_request?: Maybe<Scalars['Boolean']>;
  is_consumer_data_collected_remarks?: Maybe<Scalars['String']>;
  is_tech_transferrable_remarks?: Maybe<Scalars['String']>;
  want_to_transfer_resources?: Maybe<Scalars['String']>;
  company_performance_annual_sales?: Maybe<Scalars['String']>;
  is_match_triggered?: Maybe<Scalars['Boolean']>;
  startup_profile?: Maybe<Scalars['ID']>;
  rating?: Maybe<Scalars['Float']>;
  tested_by_alkelio?: Maybe<Scalars['Boolean']>;
  technology_solution_pricing_model?: Maybe<Array<Maybe<ComponentPricingTechnologySolutionPricingModelInput>>>;
  purpose_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  purpose_explore?: Maybe<Scalars['Boolean']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  case_studies?: Maybe<ComponentTechnologySolutionCaseStudyInput>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TechnologyType = {
  __typename?: 'TechnologyType';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type TechnologyTypeAggregator = {
  __typename?: 'TechnologyTypeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TechnologyTypeConnection = {
  __typename?: 'TechnologyTypeConnection';
  values?: Maybe<Array<Maybe<TechnologyType>>>;
  groupBy?: Maybe<TechnologyTypeGroupBy>;
  aggregate?: Maybe<TechnologyTypeAggregator>;
};

export type TechnologyTypeConnectionCreated_At = {
  __typename?: 'TechnologyTypeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologyTypeConnection>;
};

export type TechnologyTypeConnectionId = {
  __typename?: 'TechnologyTypeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TechnologyTypeConnection>;
};

export type TechnologyTypeConnectionName = {
  __typename?: 'TechnologyTypeConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TechnologyTypeConnection>;
};

export type TechnologyTypeConnectionUpdated_At = {
  __typename?: 'TechnologyTypeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TechnologyTypeConnection>;
};

export type TechnologyTypeGroupBy = {
  __typename?: 'TechnologyTypeGroupBy';
  id?: Maybe<Array<Maybe<TechnologyTypeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TechnologyTypeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TechnologyTypeConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<TechnologyTypeConnectionName>>>;
};

export type TechnologyTypeInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type TransactionInput = {
  amount?: Maybe<Scalars['Float']>;
  uid?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Transactions_Status>;
  type?: Maybe<Enum_Transactions_Type>;
  currency?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
  external_transaction_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Transactions = {
  __typename?: 'Transactions';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  amount?: Maybe<Scalars['Float']>;
  uid?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Transactions_Status>;
  type?: Maybe<Enum_Transactions_Type>;
  currency?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
  external_transaction_id?: Maybe<Scalars['String']>;
};

export type TransactionsAggregator = {
  __typename?: 'TransactionsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<TransactionsAggregatorSum>;
  avg?: Maybe<TransactionsAggregatorAvg>;
  min?: Maybe<TransactionsAggregatorMin>;
  max?: Maybe<TransactionsAggregatorMax>;
};

export type TransactionsAggregatorAvg = {
  __typename?: 'TransactionsAggregatorAvg';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionsAggregatorMax = {
  __typename?: 'TransactionsAggregatorMax';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionsAggregatorMin = {
  __typename?: 'TransactionsAggregatorMin';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionsAggregatorSum = {
  __typename?: 'TransactionsAggregatorSum';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionsConnection = {
  __typename?: 'TransactionsConnection';
  values?: Maybe<Array<Maybe<Transactions>>>;
  groupBy?: Maybe<TransactionsGroupBy>;
  aggregate?: Maybe<TransactionsAggregator>;
};

export type TransactionsConnectionAmount = {
  __typename?: 'TransactionsConnectionAmount';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionCreated_At = {
  __typename?: 'TransactionsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionCurrency = {
  __typename?: 'TransactionsConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionExternal_Transaction_Id = {
  __typename?: 'TransactionsConnectionExternal_transaction_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionId = {
  __typename?: 'TransactionsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionMeta = {
  __typename?: 'TransactionsConnectionMeta';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionStatus = {
  __typename?: 'TransactionsConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionTitle = {
  __typename?: 'TransactionsConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionType = {
  __typename?: 'TransactionsConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionUid = {
  __typename?: 'TransactionsConnectionUid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionUpdated_At = {
  __typename?: 'TransactionsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsGroupBy = {
  __typename?: 'TransactionsGroupBy';
  id?: Maybe<Array<Maybe<TransactionsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TransactionsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TransactionsConnectionUpdated_At>>>;
  amount?: Maybe<Array<Maybe<TransactionsConnectionAmount>>>;
  uid?: Maybe<Array<Maybe<TransactionsConnectionUid>>>;
  status?: Maybe<Array<Maybe<TransactionsConnectionStatus>>>;
  type?: Maybe<Array<Maybe<TransactionsConnectionType>>>;
  currency?: Maybe<Array<Maybe<TransactionsConnectionCurrency>>>;
  meta?: Maybe<Array<Maybe<TransactionsConnectionMeta>>>;
  title?: Maybe<Array<Maybe<TransactionsConnectionTitle>>>;
  external_transaction_id?: Maybe<Array<Maybe<TransactionsConnectionExternal_Transaction_Id>>>;
};

export type TryGetNewOnboardingSessionPayload = {
  __typename?: 'TryGetNewOnboardingSessionPayload';
  uuid?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
};

export type UpdateMyServiceCollaborationInput = {
  id: Scalars['ID'];
  structure?: Maybe<Array<Maybe<EditComponentServiceCollaborationStructureInput>>>;
  scope?: Maybe<EditComponentServiceCollaborationScopeInput>;
  deliverables?: Maybe<EditComponentServiceCollaborationDeliverableInput>;
  feedback?: Maybe<EditComponentServiceCollaborationFeedbackInput>;
};


export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  person_profile?: Maybe<Scalars['ID']>;
  conversation_messages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  verification_action?: Maybe<Scalars['ID']>;
  catalyst_conversation?: Maybe<Scalars['ID']>;
  catalyst_allocations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notification_preference?: Maybe<Scalars['ID']>;
  promo_code_redemptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UserSubmittedGoalInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UserSubmittedGoals = {
  __typename?: 'UserSubmittedGoals';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type UserSubmittedGoalsAggregator = {
  __typename?: 'UserSubmittedGoalsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UserSubmittedGoalsConnection = {
  __typename?: 'UserSubmittedGoalsConnection';
  values?: Maybe<Array<Maybe<UserSubmittedGoals>>>;
  groupBy?: Maybe<UserSubmittedGoalsGroupBy>;
  aggregate?: Maybe<UserSubmittedGoalsAggregator>;
};

export type UserSubmittedGoalsConnectionCreated_At = {
  __typename?: 'UserSubmittedGoalsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UserSubmittedGoalsConnection>;
};

export type UserSubmittedGoalsConnectionId = {
  __typename?: 'UserSubmittedGoalsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UserSubmittedGoalsConnection>;
};

export type UserSubmittedGoalsConnectionName = {
  __typename?: 'UserSubmittedGoalsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UserSubmittedGoalsConnection>;
};

export type UserSubmittedGoalsConnectionUpdated_At = {
  __typename?: 'UserSubmittedGoalsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UserSubmittedGoalsConnection>;
};

export type UserSubmittedGoalsGroupBy = {
  __typename?: 'UserSubmittedGoalsGroupBy';
  id?: Maybe<Array<Maybe<UserSubmittedGoalsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UserSubmittedGoalsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UserSubmittedGoalsConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UserSubmittedGoalsConnectionName>>>;
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  person_profile?: Maybe<PersonProfile>;
  verification_action?: Maybe<VerificationAction>;
  catalyst_conversation?: Maybe<CatalystConversations>;
  notification_preference?: Maybe<NotificationPreferences>;
  conversation_messages?: Maybe<Array<Maybe<ConversationMessage>>>;
  catalyst_allocations?: Maybe<Array<Maybe<CatalystAllocation>>>;
  promo_code_redemptions?: Maybe<Array<Maybe<PromoCodeRedemptions>>>;
};


export type UsersPermissionsUserConversation_MessagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserCatalyst_AllocationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserPromo_Code_RedemptionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCatalyst_Conversation = {
  __typename?: 'UsersPermissionsUserConnectionCatalyst_conversation';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionNotification_Preference = {
  __typename?: 'UsersPermissionsUserConnectionNotification_preference';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionPerson_Profile = {
  __typename?: 'UsersPermissionsUserConnectionPerson_profile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionVerification_Action = {
  __typename?: 'UsersPermissionsUserConnectionVerification_action';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  person_profile?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPerson_Profile>>>;
  verification_action?: Maybe<Array<Maybe<UsersPermissionsUserConnectionVerification_Action>>>;
  catalyst_conversation?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCatalyst_Conversation>>>;
  notification_preference?: Maybe<Array<Maybe<UsersPermissionsUserConnectionNotification_Preference>>>;
};

export type VerificationAction = {
  __typename?: 'VerificationAction';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  uuid?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Boolean']>;
  expiresAt?: Maybe<Scalars['Long']>;
};

export type VerificationActionAggregator = {
  __typename?: 'VerificationActionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VerificationActionConnection = {
  __typename?: 'VerificationActionConnection';
  values?: Maybe<Array<Maybe<VerificationAction>>>;
  groupBy?: Maybe<VerificationActionGroupBy>;
  aggregate?: Maybe<VerificationActionAggregator>;
};

export type VerificationActionConnectionCode = {
  __typename?: 'VerificationActionConnectionCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VerificationActionConnection>;
};

export type VerificationActionConnectionCreated_At = {
  __typename?: 'VerificationActionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VerificationActionConnection>;
};

export type VerificationActionConnectionExpiresAt = {
  __typename?: 'VerificationActionConnectionExpiresAt';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VerificationActionConnection>;
};

export type VerificationActionConnectionId = {
  __typename?: 'VerificationActionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VerificationActionConnection>;
};

export type VerificationActionConnectionUpdated_At = {
  __typename?: 'VerificationActionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VerificationActionConnection>;
};

export type VerificationActionConnectionUsed = {
  __typename?: 'VerificationActionConnectionUsed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<VerificationActionConnection>;
};

export type VerificationActionConnectionUser = {
  __typename?: 'VerificationActionConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VerificationActionConnection>;
};

export type VerificationActionConnectionUuid = {
  __typename?: 'VerificationActionConnectionUuid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VerificationActionConnection>;
};

export type VerificationActionGroupBy = {
  __typename?: 'VerificationActionGroupBy';
  id?: Maybe<Array<Maybe<VerificationActionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<VerificationActionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<VerificationActionConnectionUpdated_At>>>;
  code?: Maybe<Array<Maybe<VerificationActionConnectionCode>>>;
  user?: Maybe<Array<Maybe<VerificationActionConnectionUser>>>;
  uuid?: Maybe<Array<Maybe<VerificationActionConnectionUuid>>>;
  used?: Maybe<Array<Maybe<VerificationActionConnectionUsed>>>;
  expiresAt?: Maybe<Array<Maybe<VerificationActionConnectionExpiresAt>>>;
};

export type VerificationActionInput = {
  code?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Boolean']>;
  expiresAt?: Maybe<Scalars['Long']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ViewCountInput = {
  count?: Maybe<Scalars['Long']>;
  article_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ViewCounts = {
  __typename?: 'ViewCounts';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  count?: Maybe<Scalars['Long']>;
  article_id?: Maybe<Scalars['String']>;
};

export type ViewCountsAggregator = {
  __typename?: 'ViewCountsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ViewCountsConnection = {
  __typename?: 'ViewCountsConnection';
  values?: Maybe<Array<Maybe<ViewCounts>>>;
  groupBy?: Maybe<ViewCountsGroupBy>;
  aggregate?: Maybe<ViewCountsAggregator>;
};

export type ViewCountsConnectionArticle_Id = {
  __typename?: 'ViewCountsConnectionArticle_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ViewCountsConnection>;
};

export type ViewCountsConnectionCount = {
  __typename?: 'ViewCountsConnectionCount';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ViewCountsConnection>;
};

export type ViewCountsConnectionCreated_At = {
  __typename?: 'ViewCountsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ViewCountsConnection>;
};

export type ViewCountsConnectionId = {
  __typename?: 'ViewCountsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ViewCountsConnection>;
};

export type ViewCountsConnectionUpdated_At = {
  __typename?: 'ViewCountsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ViewCountsConnection>;
};

export type ViewCountsGroupBy = {
  __typename?: 'ViewCountsGroupBy';
  id?: Maybe<Array<Maybe<ViewCountsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ViewCountsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ViewCountsConnectionUpdated_At>>>;
  count?: Maybe<Array<Maybe<ViewCountsConnectionCount>>>;
  article_id?: Maybe<Array<Maybe<ViewCountsConnectionArticle_Id>>>;
};


export type BookmarkContent = {
  __typename?: 'bookmarkContent';
  id: Scalars['ID'];
  type?: Maybe<Enum_Bookmark_Type>;
  category?: Maybe<Enum_Bookmark_Category>;
  item_id?: Maybe<Scalars['String']>;
  technologySolution?: Maybe<TechnologySolutionSummary>;
  technologyRequest?: Maybe<TechnologyRequestSummary>;
  technologySolutionMatch?: Maybe<TechnologySolutionMatchSummary>;
  technologyRequestMatch?: Maybe<TechnologyRequestMatchSummary>;
};

export type CompleteOnboardingSessionByUuidPayload = {
  __typename?: 'completeOnboardingSessionByUUIDPayload';
  uuid?: Maybe<Scalars['String']>;
  jwt?: Maybe<Scalars['String']>;
};

export type CorporateProfileSummary = {
  __typename?: 'corporateProfileSummary';
  country_jurisdiction?: Maybe<Scalars['String']>;
  employee_count_range?: Maybe<Scalars['String']>;
};

export type CreateBookmarkInput = {
  data?: Maybe<BookmarkInput>;
};

export type CreateBookmarkPayload = {
  __typename?: 'createBookmarkPayload';
  bookmark?: Maybe<Bookmark>;
};

export type CreateBusinessUseCaseInput = {
  data?: Maybe<BusinessUseCaseInput>;
};

export type CreateBusinessUseCasePayload = {
  __typename?: 'createBusinessUseCasePayload';
  businessUseCase?: Maybe<BusinessUseCase>;
};

export type CreateCareerInput = {
  data?: Maybe<CareerInput>;
};

export type CreateCareerPayload = {
  __typename?: 'createCareerPayload';
  career?: Maybe<Careers>;
};

export type CreateCatalystAllocationInput = {
  data?: Maybe<CatalystAllocationInput>;
};

export type CreateCatalystAllocationPayload = {
  __typename?: 'createCatalystAllocationPayload';
  catalystAllocation?: Maybe<CatalystAllocation>;
};

export type CreateCatalystConversationInput = {
  data?: Maybe<CatalystConversationInput>;
};

export type CreateCatalystConversationPayload = {
  __typename?: 'createCatalystConversationPayload';
  catalystConversation?: Maybe<CatalystConversations>;
};

export type CreateChatInput = {
  data?: Maybe<ChatInput>;
};

export type CreateChatMessageInput = {
  data?: Maybe<ChatMessageInput>;
};

export type CreateChatMessagePayload = {
  __typename?: 'createChatMessagePayload';
  chatMessage?: Maybe<ChatMessages>;
};

export type CreateChatPayload = {
  __typename?: 'createChatPayload';
  chat?: Maybe<Chat>;
};

export type CreateConversationInput = {
  data?: Maybe<ConversationInput>;
};

export type CreateConversationMessageInput = {
  data?: Maybe<ConversationMessageInput>;
};

export type CreateConversationMessagePayload = {
  __typename?: 'createConversationMessagePayload';
  conversationMessage?: Maybe<ConversationMessage>;
};

export type CreateConversationPayload = {
  __typename?: 'createConversationPayload';
  conversation?: Maybe<Conversations>;
};

export type CreateCorporateDepartmentInput = {
  data?: Maybe<CorporateDepartmentInput>;
};

export type CreateCorporateDepartmentPayload = {
  __typename?: 'createCorporateDepartmentPayload';
  corporateDepartment?: Maybe<CorporateDepartment>;
};

export type CreateCorporateInput = {
  data?: Maybe<CorporateInput>;
};

export type CreateCorporatePayload = {
  __typename?: 'createCorporatePayload';
  corporate?: Maybe<Corporate>;
};

export type CreateCountryInput = {
  data?: Maybe<CountryInput>;
};

export type CreateCountryPayload = {
  __typename?: 'createCountryPayload';
  country?: Maybe<Country>;
};

export type CreateCreditInput = {
  data?: Maybe<CreditInput>;
};

export type CreateCreditPayload = {
  __typename?: 'createCreditPayload';
  credit?: Maybe<Credits>;
};

export type CreateDocumentSharingInput = {
  data?: Maybe<DocumentSharingInput>;
};

export type CreateDocumentSharingPayload = {
  __typename?: 'createDocumentSharingPayload';
  documentSharing?: Maybe<DocumentSharing>;
};

export type CreateEnquiryInput = {
  data?: Maybe<EnquiryInput>;
};

export type CreateEnquiryPayload = {
  __typename?: 'createEnquiryPayload';
  enquiry?: Maybe<Enquiries>;
};

export type CreateGoalInput = {
  data?: Maybe<GoalInput>;
};

export type CreateGoalPayload = {
  __typename?: 'createGoalPayload';
  goal?: Maybe<Goals>;
};

export type CreateImpactAreaInput = {
  data?: Maybe<ImpactAreaInput>;
};

export type CreateImpactAreaPayload = {
  __typename?: 'createImpactAreaPayload';
  impactArea?: Maybe<ImpactArea>;
};

export type CreateIndustryInput = {
  data?: Maybe<IndustryInput>;
};

export type CreateIndustryPayload = {
  __typename?: 'createIndustryPayload';
  industry?: Maybe<Industry>;
};

export type CreateJobPostingInput = {
  data?: Maybe<JobPostingInput>;
};

export type CreateJobPostingPayload = {
  __typename?: 'createJobPostingPayload';
  jobPosting?: Maybe<JobPosting>;
};

export type CreateMatchMakingResultInput = {
  data?: Maybe<MatchMakingResultInput>;
};

export type CreateMatchMakingResultPayload = {
  __typename?: 'createMatchMakingResultPayload';
  matchMakingResult?: Maybe<MatchMakingResult>;
};

export type CreateMaturityLevelInput = {
  data?: Maybe<MaturityLevelInput>;
};

export type CreateMaturityLevelPayload = {
  __typename?: 'createMaturityLevelPayload';
  maturityLevel?: Maybe<MaturityLevel>;
};

export type CreateNewsArticleInput = {
  data?: Maybe<NewsArticleInput>;
};

export type CreateNewsArticlePayload = {
  __typename?: 'createNewsArticlePayload';
  newsArticle?: Maybe<NewsArticle>;
};

export type CreateNotificationPreferenceInput = {
  data?: Maybe<NotificationPreferenceInput>;
};

export type CreateNotificationPreferencePayload = {
  __typename?: 'createNotificationPreferencePayload';
  notificationPreference?: Maybe<NotificationPreferences>;
};

export type CreateOnBoardingSessionInput = {
  data?: Maybe<OnBoardingSessionInput>;
};

export type CreateOnBoardingSessionPayload = {
  __typename?: 'createOnBoardingSessionPayload';
  onBoardingSession?: Maybe<OnBoardingSession>;
};

export type CreatePersonProfileInput = {
  data?: Maybe<PersonProfileInput>;
};

export type CreatePersonProfilePayload = {
  __typename?: 'createPersonProfilePayload';
  personProfile?: Maybe<PersonProfile>;
};

export type CreatePricingModelInput = {
  data?: Maybe<PricingModelInput>;
};

export type CreatePricingModelPayload = {
  __typename?: 'createPricingModelPayload';
  pricingModel?: Maybe<PricingModel>;
};

export type CreatePromoCodeConversationInput = {
  data?: Maybe<PromoCodeConversationInput>;
};

export type CreatePromoCodeConversationPayload = {
  __typename?: 'createPromoCodeConversationPayload';
  promoCodeConversation?: Maybe<PromoCodeConversation>;
};

export type CreatePromoCodeInput = {
  data?: Maybe<PromoCodeInput>;
};

export type CreatePromoCodePayload = {
  __typename?: 'createPromoCodePayload';
  promoCode?: Maybe<PromoCode>;
};

export type CreatePromoCodeRedemptionInput = {
  data?: Maybe<PromoCodeRedemptionInput>;
};

export type CreatePromoCodeRedemptionPayload = {
  __typename?: 'createPromoCodeRedemptionPayload';
  promoCodeRedemption?: Maybe<PromoCodeRedemptions>;
};

export type CreatePurchasedServiceInput = {
  data?: Maybe<PurchasedServiceInput>;
};

export type CreatePurchasedServicePayload = {
  __typename?: 'createPurchasedServicePayload';
  purchasedService?: Maybe<PurchasedServices>;
};

export type CreatePurchasedSubscriptionInput = {
  data?: Maybe<PurchasedSubscriptionInput>;
};

export type CreatePurchasedSubscriptionPayload = {
  __typename?: 'createPurchasedSubscriptionPayload';
  purchasedSubscription?: Maybe<PurchasedSubscription>;
};

export type CreateRatingInput = {
  data?: Maybe<RatingInput>;
};

export type CreateRatingPayload = {
  __typename?: 'createRatingPayload';
  rating?: Maybe<Rating>;
};

export type CreateRegionInput = {
  data?: Maybe<RegionInput>;
};

export type CreateRegionPayload = {
  __typename?: 'createRegionPayload';
  region?: Maybe<Region>;
};

export type CreateRegionServicePriceInput = {
  data?: Maybe<RegionServicePriceInput>;
};

export type CreateRegionServicePricePayload = {
  __typename?: 'createRegionServicePricePayload';
  regionServicePrice?: Maybe<RegionServicePrice>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateSdgObjectiveInput = {
  data?: Maybe<SdgObjectiveInput>;
};

export type CreateSdgObjectivePayload = {
  __typename?: 'createSdgObjectivePayload';
  sdgObjective?: Maybe<SdgObjectives>;
};

export type CreateServiceCollaborationInput = {
  data?: Maybe<ServiceCollaborationInput>;
};

export type CreateServiceCollaborationPayload = {
  __typename?: 'createServiceCollaborationPayload';
  serviceCollaboration?: Maybe<ServiceCollaboration>;
};

export type CreateServiceInput = {
  data?: Maybe<ServiceInput>;
};

export type CreateServicePackageInput = {
  data?: Maybe<ServicePackageInput>;
};

export type CreateServicePackagePayload = {
  __typename?: 'createServicePackagePayload';
  servicePackage?: Maybe<ServicePackage>;
};

export type CreateServicePayload = {
  __typename?: 'createServicePayload';
  service?: Maybe<Services>;
};

export type CreateServicesInterestInput = {
  data?: Maybe<ServicesInterestInput>;
};

export type CreateServicesInterestPayload = {
  __typename?: 'createServicesInterestPayload';
  servicesInterest?: Maybe<ServicesInterest>;
};

export type CreateStartupProfileInput = {
  data?: Maybe<StartupProfileInput>;
};

export type CreateStartupProfilePayload = {
  __typename?: 'createStartupProfilePayload';
  startupProfile?: Maybe<StartupProfile>;
};

export type CreateTechnologyReadinessLevelInput = {
  data?: Maybe<TechnologyReadinessLevelInput>;
};

export type CreateTechnologyReadinessLevelPayload = {
  __typename?: 'createTechnologyReadinessLevelPayload';
  technologyReadinessLevel?: Maybe<TechnologyReadinessLevel>;
};

export type CreateTechnologyRequestInput = {
  data?: Maybe<TechnologyRequestInput>;
};

export type CreateTechnologyRequestPayload = {
  __typename?: 'createTechnologyRequestPayload';
  technologyRequest?: Maybe<TechnologyRequest>;
};

export type CreateTechnologySolutionInput = {
  data?: Maybe<TechnologySolutionInput>;
};

export type CreateTechnologySolutionPayload = {
  __typename?: 'createTechnologySolutionPayload';
  technologySolution?: Maybe<TechnologySolution>;
};

export type CreateTechnologyTypeInput = {
  data?: Maybe<TechnologyTypeInput>;
};

export type CreateTechnologyTypePayload = {
  __typename?: 'createTechnologyTypePayload';
  technologyType?: Maybe<TechnologyType>;
};

export type CreateTransactionInput = {
  data?: Maybe<TransactionInput>;
};

export type CreateTransactionPayload = {
  __typename?: 'createTransactionPayload';
  transaction?: Maybe<Transactions>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type CreateUserSubmittedGoalInput = {
  data?: Maybe<UserSubmittedGoalInput>;
};

export type CreateUserSubmittedGoalPayload = {
  __typename?: 'createUserSubmittedGoalPayload';
  userSubmittedGoal?: Maybe<UserSubmittedGoals>;
};

export type CreateVerificationActionInput = {
  data?: Maybe<VerificationActionInput>;
};

export type CreateVerificationActionPayload = {
  __typename?: 'createVerificationActionPayload';
  verificationAction?: Maybe<VerificationAction>;
};

export type CreateViewCountInput = {
  data?: Maybe<ViewCountInput>;
};

export type CreateViewCountPayload = {
  __typename?: 'createViewCountPayload';
  viewCount?: Maybe<ViewCounts>;
};

export type DeleteApplicationConfigPayload = {
  __typename?: 'deleteApplicationConfigPayload';
  applicationConfig?: Maybe<ApplicationConfig>;
};

export type DeleteBookmarkInput = {
  where?: Maybe<InputId>;
};

export type DeleteBookmarkPayload = {
  __typename?: 'deleteBookmarkPayload';
  bookmark?: Maybe<Bookmark>;
};

export type DeleteBusinessUseCaseInput = {
  where?: Maybe<InputId>;
};

export type DeleteBusinessUseCasePayload = {
  __typename?: 'deleteBusinessUseCasePayload';
  businessUseCase?: Maybe<BusinessUseCase>;
};

export type DeleteCareerInput = {
  where?: Maybe<InputId>;
};

export type DeleteCareerPayload = {
  __typename?: 'deleteCareerPayload';
  career?: Maybe<Careers>;
};

export type DeleteCatalystAllocationInput = {
  where?: Maybe<InputId>;
};

export type DeleteCatalystAllocationPayload = {
  __typename?: 'deleteCatalystAllocationPayload';
  catalystAllocation?: Maybe<CatalystAllocation>;
};

export type DeleteCatalystConversationInput = {
  where?: Maybe<InputId>;
};

export type DeleteCatalystConversationPayload = {
  __typename?: 'deleteCatalystConversationPayload';
  catalystConversation?: Maybe<CatalystConversations>;
};

export type DeleteChatInput = {
  where?: Maybe<InputId>;
};

export type DeleteChatMessageInput = {
  where?: Maybe<InputId>;
};

export type DeleteChatMessagePayload = {
  __typename?: 'deleteChatMessagePayload';
  chatMessage?: Maybe<ChatMessages>;
};

export type DeleteChatPayload = {
  __typename?: 'deleteChatPayload';
  chat?: Maybe<Chat>;
};

export type DeleteConversationInput = {
  where?: Maybe<InputId>;
};

export type DeleteConversationMessageInput = {
  where?: Maybe<InputId>;
};

export type DeleteConversationMessagePayload = {
  __typename?: 'deleteConversationMessagePayload';
  conversationMessage?: Maybe<ConversationMessage>;
};

export type DeleteConversationPayload = {
  __typename?: 'deleteConversationPayload';
  conversation?: Maybe<Conversations>;
};

export type DeleteCorporateDepartmentInput = {
  where?: Maybe<InputId>;
};

export type DeleteCorporateDepartmentPayload = {
  __typename?: 'deleteCorporateDepartmentPayload';
  corporateDepartment?: Maybe<CorporateDepartment>;
};

export type DeleteCorporateInput = {
  where?: Maybe<InputId>;
};

export type DeleteCorporatePayload = {
  __typename?: 'deleteCorporatePayload';
  corporate?: Maybe<Corporate>;
};

export type DeleteCountryInput = {
  where?: Maybe<InputId>;
};

export type DeleteCountryPayload = {
  __typename?: 'deleteCountryPayload';
  country?: Maybe<Country>;
};

export type DeleteCreditInput = {
  where?: Maybe<InputId>;
};

export type DeleteCreditPayload = {
  __typename?: 'deleteCreditPayload';
  credit?: Maybe<Credits>;
};

export type DeleteDocumentSharingInput = {
  where?: Maybe<InputId>;
};

export type DeleteDocumentSharingPayload = {
  __typename?: 'deleteDocumentSharingPayload';
  documentSharing?: Maybe<DocumentSharing>;
};

export type DeleteEnquiryInput = {
  where?: Maybe<InputId>;
};

export type DeleteEnquiryPayload = {
  __typename?: 'deleteEnquiryPayload';
  enquiry?: Maybe<Enquiries>;
};

export type DeleteFileInput = {
  where?: Maybe<InputId>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type DeleteGoalInput = {
  where?: Maybe<InputId>;
};

export type DeleteGoalPayload = {
  __typename?: 'deleteGoalPayload';
  goal?: Maybe<Goals>;
};

export type DeleteImpactAreaInput = {
  where?: Maybe<InputId>;
};

export type DeleteImpactAreaPayload = {
  __typename?: 'deleteImpactAreaPayload';
  impactArea?: Maybe<ImpactArea>;
};

export type DeleteIndustryInput = {
  where?: Maybe<InputId>;
};

export type DeleteIndustryPayload = {
  __typename?: 'deleteIndustryPayload';
  industry?: Maybe<Industry>;
};

export type DeleteJobPostingInput = {
  where?: Maybe<InputId>;
};

export type DeleteJobPostingPayload = {
  __typename?: 'deleteJobPostingPayload';
  jobPosting?: Maybe<JobPosting>;
};

export type DeleteMatchMakingResultInput = {
  where?: Maybe<InputId>;
};

export type DeleteMatchMakingResultPayload = {
  __typename?: 'deleteMatchMakingResultPayload';
  matchMakingResult?: Maybe<MatchMakingResult>;
};

export type DeleteMaturityLevelInput = {
  where?: Maybe<InputId>;
};

export type DeleteMaturityLevelPayload = {
  __typename?: 'deleteMaturityLevelPayload';
  maturityLevel?: Maybe<MaturityLevel>;
};

export type DeleteNewsArticleInput = {
  where?: Maybe<InputId>;
};

export type DeleteNewsArticlePayload = {
  __typename?: 'deleteNewsArticlePayload';
  newsArticle?: Maybe<NewsArticle>;
};

export type DeleteNotificationPreferenceInput = {
  where?: Maybe<InputId>;
};

export type DeleteNotificationPreferencePayload = {
  __typename?: 'deleteNotificationPreferencePayload';
  notificationPreference?: Maybe<NotificationPreferences>;
};

export type DeleteOnBoardingSessionInput = {
  where?: Maybe<InputId>;
};

export type DeleteOnBoardingSessionPayload = {
  __typename?: 'deleteOnBoardingSessionPayload';
  onBoardingSession?: Maybe<OnBoardingSession>;
};

export type DeletePersonProfileInput = {
  where?: Maybe<InputId>;
};

export type DeletePersonProfilePayload = {
  __typename?: 'deletePersonProfilePayload';
  personProfile?: Maybe<PersonProfile>;
};

export type DeletePricingModelInput = {
  where?: Maybe<InputId>;
};

export type DeletePricingModelPayload = {
  __typename?: 'deletePricingModelPayload';
  pricingModel?: Maybe<PricingModel>;
};

export type DeletePromoCodeConversationInput = {
  where?: Maybe<InputId>;
};

export type DeletePromoCodeConversationPayload = {
  __typename?: 'deletePromoCodeConversationPayload';
  promoCodeConversation?: Maybe<PromoCodeConversation>;
};

export type DeletePromoCodeInput = {
  where?: Maybe<InputId>;
};

export type DeletePromoCodePayload = {
  __typename?: 'deletePromoCodePayload';
  promoCode?: Maybe<PromoCode>;
};

export type DeletePromoCodeRedemptionInput = {
  where?: Maybe<InputId>;
};

export type DeletePromoCodeRedemptionPayload = {
  __typename?: 'deletePromoCodeRedemptionPayload';
  promoCodeRedemption?: Maybe<PromoCodeRedemptions>;
};

export type DeletePurchasedServiceInput = {
  where?: Maybe<InputId>;
};

export type DeletePurchasedServicePayload = {
  __typename?: 'deletePurchasedServicePayload';
  purchasedService?: Maybe<PurchasedServices>;
};

export type DeletePurchasedSubscriptionInput = {
  where?: Maybe<InputId>;
};

export type DeletePurchasedSubscriptionPayload = {
  __typename?: 'deletePurchasedSubscriptionPayload';
  purchasedSubscription?: Maybe<PurchasedSubscription>;
};

export type DeleteRatingInput = {
  where?: Maybe<InputId>;
};

export type DeleteRatingPayload = {
  __typename?: 'deleteRatingPayload';
  rating?: Maybe<Rating>;
};

export type DeleteRegionInput = {
  where?: Maybe<InputId>;
};

export type DeleteRegionPayload = {
  __typename?: 'deleteRegionPayload';
  region?: Maybe<Region>;
};

export type DeleteRegionServicePriceInput = {
  where?: Maybe<InputId>;
};

export type DeleteRegionServicePricePayload = {
  __typename?: 'deleteRegionServicePricePayload';
  regionServicePrice?: Maybe<RegionServicePrice>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteSdgObjectiveInput = {
  where?: Maybe<InputId>;
};

export type DeleteSdgObjectivePayload = {
  __typename?: 'deleteSdgObjectivePayload';
  sdgObjective?: Maybe<SdgObjectives>;
};

export type DeleteServiceCollaborationInput = {
  where?: Maybe<InputId>;
};

export type DeleteServiceCollaborationPayload = {
  __typename?: 'deleteServiceCollaborationPayload';
  serviceCollaboration?: Maybe<ServiceCollaboration>;
};

export type DeleteServiceInput = {
  where?: Maybe<InputId>;
};

export type DeleteServicePackageInput = {
  where?: Maybe<InputId>;
};

export type DeleteServicePackagePayload = {
  __typename?: 'deleteServicePackagePayload';
  servicePackage?: Maybe<ServicePackage>;
};

export type DeleteServicePayload = {
  __typename?: 'deleteServicePayload';
  service?: Maybe<Services>;
};

export type DeleteServicesInterestInput = {
  where?: Maybe<InputId>;
};

export type DeleteServicesInterestPayload = {
  __typename?: 'deleteServicesInterestPayload';
  servicesInterest?: Maybe<ServicesInterest>;
};

export type DeleteStartConversationTermsConditionPayload = {
  __typename?: 'deleteStartConversationTermsConditionPayload';
  startConversationTermsCondition?: Maybe<StartConversationTermsConditions>;
};

export type DeleteStartupProfileInput = {
  where?: Maybe<InputId>;
};

export type DeleteStartupProfilePayload = {
  __typename?: 'deleteStartupProfilePayload';
  startupProfile?: Maybe<StartupProfile>;
};

export type DeleteTechnologyReadinessLevelInput = {
  where?: Maybe<InputId>;
};

export type DeleteTechnologyReadinessLevelPayload = {
  __typename?: 'deleteTechnologyReadinessLevelPayload';
  technologyReadinessLevel?: Maybe<TechnologyReadinessLevel>;
};

export type DeleteTechnologyRequestInput = {
  where?: Maybe<InputId>;
};

export type DeleteTechnologyRequestPayload = {
  __typename?: 'deleteTechnologyRequestPayload';
  technologyRequest?: Maybe<TechnologyRequest>;
};

export type DeleteTechnologySolutionInput = {
  where?: Maybe<InputId>;
};

export type DeleteTechnologySolutionPayload = {
  __typename?: 'deleteTechnologySolutionPayload';
  technologySolution?: Maybe<TechnologySolution>;
};

export type DeleteTechnologyTypeInput = {
  where?: Maybe<InputId>;
};

export type DeleteTechnologyTypePayload = {
  __typename?: 'deleteTechnologyTypePayload';
  technologyType?: Maybe<TechnologyType>;
};

export type DeleteTransactionInput = {
  where?: Maybe<InputId>;
};

export type DeleteTransactionPayload = {
  __typename?: 'deleteTransactionPayload';
  transaction?: Maybe<Transactions>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteUserSubmittedGoalInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserSubmittedGoalPayload = {
  __typename?: 'deleteUserSubmittedGoalPayload';
  userSubmittedGoal?: Maybe<UserSubmittedGoals>;
};

export type DeleteVerificationActionInput = {
  where?: Maybe<InputId>;
};

export type DeleteVerificationActionPayload = {
  __typename?: 'deleteVerificationActionPayload';
  verificationAction?: Maybe<VerificationAction>;
};

export type DeleteViewCountInput = {
  where?: Maybe<InputId>;
};

export type DeleteViewCountPayload = {
  __typename?: 'deleteViewCountPayload';
  viewCount?: Maybe<ViewCounts>;
};

export type EditApplicationConfigInput = {
  payment_stripe_key?: Maybe<Scalars['String']>;
  enable_payments?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditBookmarkInput = {
  type?: Maybe<Enum_Bookmark_Type>;
  item_id?: Maybe<Scalars['Int']>;
  category?: Maybe<Enum_Bookmark_Category>;
  person_profile?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditBusinessUseCaseInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCareerInput = {
  job_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCatalystAllocationInput = {
  users_permissions_user?: Maybe<Scalars['ID']>;
  corporate_profiles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  startup_profile?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCatalystConversationInput = {
  users_permissions_user?: Maybe<Scalars['ID']>;
  conversation?: Maybe<Scalars['ID']>;
  active?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditChatInput = {
  category?: Maybe<Enum_Chat_Category>;
  reference_id?: Maybe<Scalars['String']>;
  users?: Maybe<Scalars['JSON']>;
  chat_messages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditChatMessageInput = {
  body?: Maybe<Scalars['String']>;
  from_user?: Maybe<Scalars['ID']>;
  chat?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentConversationFormFormAgreementInput = {
  id?: Maybe<Scalars['ID']>;
  client_name?: Maybe<Scalars['String']>;
  client_company?: Maybe<Scalars['String']>;
  client_address?: Maybe<Scalars['String']>;
  client_agree?: Maybe<Scalars['Boolean']>;
  supplier_name?: Maybe<Scalars['String']>;
  supplier_company?: Maybe<Scalars['String']>;
  supplier_address?: Maybe<Scalars['String']>;
  supplier_agree?: Maybe<Scalars['Boolean']>;
  supplier_email?: Maybe<Scalars['String']>;
  client_email?: Maybe<Scalars['String']>;
  uploaded_contracts?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentConversationFormFormBusinessUseCaseInput = {
  id?: Maybe<Scalars['ID']>;
  business_challenge?: Maybe<Scalars['String']>;
  idea?: Maybe<Scalars['String']>;
  objectives?: Maybe<Scalars['String']>;
  corporate_tasks?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  other_solutions?: Maybe<Scalars['String']>;
  successful_outcome?: Maybe<Scalars['String']>;
  risks?: Maybe<Scalars['String']>;
  description_project?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  how_to_resolve?: Maybe<Scalars['String']>;
  technology_solution_models?: Maybe<Scalars['String']>;
};

export type EditComponentConversationFormFormProposalInput = {
  id?: Maybe<Scalars['ID']>;
  proposal?: Maybe<Array<Maybe<Scalars['ID']>>>;
  price?: Maybe<Scalars['Long']>;
  currency?: Maybe<Scalars['String']>;
  deliverables?: Maybe<Scalars['String']>;
};

export type EditComponentConversationFormFormScopeInput = {
  id?: Maybe<Scalars['ID']>;
  timing_from?: Maybe<Scalars['Date']>;
  timing_to?: Maybe<Scalars['Date']>;
  team_startup?: Maybe<Array<Maybe<EditComponentConversationFormFormScopePersonInput>>>;
  team_corporate?: Maybe<Array<Maybe<EditComponentConversationFormFormScopePersonInput>>>;
  budget_from?: Maybe<Scalars['Long']>;
  budget_to?: Maybe<Scalars['Long']>;
  budget_currency?: Maybe<Scalars['String']>;
  technical_requirements_startup?: Maybe<EditComponentConversationFormFormScopeRequirementInput>;
  technical_requirements_corporate?: Maybe<EditComponentConversationFormFormScopeRequirementInput>;
  legal_requirements_startup?: Maybe<EditComponentConversationFormFormScopeRequirementInput>;
  legal_requirements_corporate?: Maybe<EditComponentConversationFormFormScopeRequirementInput>;
  other_requirements_startup?: Maybe<EditComponentConversationFormFormScopeRequirementInput>;
  other_requirements_corporate?: Maybe<EditComponentConversationFormFormScopeRequirementInput>;
  kpis?: Maybe<Scalars['JSON']>;
};

export type EditComponentConversationFormFormScopePersonInput = {
  id?: Maybe<Scalars['ID']>;
  role?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['ID']>;
};

export type EditComponentConversationFormFormScopeRequirementInput = {
  id?: Maybe<Scalars['ID']>;
  requirement?: Maybe<Scalars['String']>;
  attachment?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentGenericLinkInput = {
  id?: Maybe<Scalars['ID']>;
  website?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
};

export type EditComponentPricingTechnologySolutionPricingModelInput = {
  id?: Maybe<Scalars['ID']>;
  pricing_model?: Maybe<Scalars['ID']>;
  min_budget?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type EditComponentRegionPricingRegionPriceInput = {
  id?: Maybe<Scalars['ID']>;
  region?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type EditComponentServiceCollaborationDatePeriodInput = {
  id?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
};

export type EditComponentServiceCollaborationDeliverableInput = {
  id?: Maybe<Scalars['ID']>;
  proposals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comments?: Maybe<Scalars['String']>;
};

export type EditComponentServiceCollaborationFeedbackInput = {
  id?: Maybe<Scalars['ID']>;
  feedback?: Maybe<Scalars['String']>;
  need_rework?: Maybe<Scalars['Boolean']>;
  rating?: Maybe<Scalars['Float']>;
};

export type EditComponentServiceCollaborationMethodologyInput = {
  id?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
};

export type EditComponentServiceCollaborationPersonInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  profile_image?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
};

export type EditComponentServiceCollaborationScopeInput = {
  id?: Maybe<Scalars['ID']>;
  client_team?: Maybe<Array<Maybe<EditComponentServiceCollaborationPersonInput>>>;
  alkelio_team?: Maybe<Array<Maybe<EditComponentServiceCollaborationPersonInput>>>;
  project_timing?: Maybe<EditComponentServiceCollaborationDatePeriodInput>;
  calender_project?: Maybe<Array<Maybe<Scalars['ID']>>>;
  info?: Maybe<Array<Maybe<EditComponentServiceCollaborationTextWithFileInput>>>;
};

export type EditComponentServiceCollaborationStructureInput = {
  id?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
};

export type EditComponentServiceCollaborationTeamInput = {
  id?: Maybe<Scalars['ID']>;
  member?: Maybe<Array<Maybe<EditComponentServiceCollaborationPersonInput>>>;
};

export type EditComponentServiceCollaborationTextWithFileInput = {
  id?: Maybe<Scalars['ID']>;
  response?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  question_from_catalyst?: Maybe<Scalars['String']>;
};

export type EditComponentServicePackageAdHocServiceSelectionInput = {
  id?: Maybe<Scalars['ID']>;
  adhoc_service_id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type EditComponentServicePackageServicePackagePaymentModeInput = {
  id?: Maybe<Scalars['ID']>;
  payment_interval?: Maybe<Enum_Componentservicepackageservicepackagepaymentmode_Payment_Interval>;
  price?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Int']>;
  credit_refresh_interval?: Maybe<Enum_Componentservicepackageservicepackagepaymentmode_Credit_Refresh_Interval>;
};

export type EditComponentTechnologySolutionCaseStudyInput = {
  id?: Maybe<Scalars['ID']>;
  have_case_studies?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  page_url?: Maybe<Scalars['String']>;
  free_text?: Maybe<Scalars['String']>;
  uploads?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentTechnologySolutionInvestInformationInput = {
  id?: Maybe<Scalars['ID']>;
  documents_business_plans?: Maybe<Array<Maybe<Scalars['ID']>>>;
  documents_investor_pitch_deck?: Maybe<Array<Maybe<Scalars['ID']>>>;
  amount_to_raise?: Maybe<Scalars['Long']>;
  amount_to_raise_currency?: Maybe<Scalars['String']>;
};

export type EditComponentTechnologySolutionProjectBudgetInput = {
  id?: Maybe<Scalars['ID']>;
  budget?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  option?: Maybe<Scalars['String']>;
};

export type EditComponentTechnologySolutionTestimonialInput = {
  id?: Maybe<Scalars['ID']>;
  have_testimonials?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  page_url?: Maybe<Scalars['String']>;
  free_text?: Maybe<Scalars['String']>;
  uploads?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditConversationInput = {
  hashtag?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  conversation_messages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  business_use_case?: Maybe<EditComponentConversationFormFormBusinessUseCaseInput>;
  scope?: Maybe<EditComponentConversationFormFormScopeInput>;
  proposal?: Maybe<EditComponentConversationFormFormProposalInput>;
  agreement?: Maybe<EditComponentConversationFormFormAgreementInput>;
  technology_request?: Maybe<Scalars['ID']>;
  technology_solution?: Maybe<Scalars['ID']>;
  current_section?: Maybe<Scalars['String']>;
  nda_signed_startup?: Maybe<Scalars['Boolean']>;
  nda_signed_corporate?: Maybe<Scalars['Boolean']>;
  catalyst_conversation?: Maybe<Scalars['ID']>;
  nda_signed_startup_date?: Maybe<Scalars['DateTime']>;
  nda_signed_corporate_date?: Maybe<Scalars['DateTime']>;
  nda_signed_startup_by?: Maybe<Scalars['String']>;
  nda_signed_corporate_by?: Maybe<Scalars['String']>;
  nda_corporate_upload?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditConversationMessageInput = {
  body?: Maybe<Scalars['String']>;
  sent_datetime?: Maybe<Scalars['DateTime']>;
  conversation?: Maybe<Scalars['ID']>;
  by_user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCorporateDepartmentInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCorporateInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  person_profiles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  country?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  avatar?: Maybe<Scalars['ID']>;
  psuedo_name?: Maybe<Scalars['String']>;
  country_jurisdiction?: Maybe<Scalars['String']>;
  employee_count_range?: Maybe<Scalars['String']>;
  technology_requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rating?: Maybe<Scalars['Float']>;
  worked_with_startups?: Maybe<Scalars['Boolean']>;
  links?: Maybe<EditComponentGenericLinkInput>;
  esg_rating?: Maybe<Enum_Corporate_Esg_Rating>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCountryInput = {
  full_name?: Maybe<Scalars['String']>;
  iso_code?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCreditInput = {
  value?: Maybe<Scalars['Int']>;
  date_start?: Maybe<Scalars['DateTime']>;
  date_expire?: Maybe<Scalars['DateTime']>;
  uid?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditDocumentSharingInput = {
  document?: Maybe<Scalars['ID']>;
  users_permissions_users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  title?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditEnquiryInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditGoalInput = {
  Name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditImpactAreaInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditIndustryInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditJobPostingInput = {
  job_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditMatchMakingResultInput = {
  is_saved?: Maybe<Scalars['Boolean']>;
  is_rejected?: Maybe<Scalars['Boolean']>;
  technology_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  business_use_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  corporate_departments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  match_purpose_poc?: Maybe<Scalars['Boolean']>;
  match_purpose_sell?: Maybe<Scalars['Boolean']>;
  match_purpose_lease?: Maybe<Scalars['Boolean']>;
  match_has_ip?: Maybe<Scalars['Boolean']>;
  match_can_whitelabel?: Maybe<Scalars['Boolean']>;
  match_has_api?: Maybe<Scalars['Boolean']>;
  match_is_plugandplay?: Maybe<Scalars['Boolean']>;
  match_is_gdpr?: Maybe<Scalars['Boolean']>;
  match_is_cloud?: Maybe<Scalars['Boolean']>;
  compound_key?: Maybe<Scalars['String']>;
  is_manual_match?: Maybe<Scalars['Boolean']>;
  technology_request?: Maybe<Scalars['ID']>;
  technology_solution?: Maybe<Scalars['ID']>;
  match_rating_from_tech_req?: Maybe<Scalars['Float']>;
  match_rating_from_tech_solution?: Maybe<Scalars['Float']>;
  match_sdg_driven?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditMaturityLevelInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditNewsArticleInput = {
  headline?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  main_image?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditNotificationPreferenceInput = {
  team_notifications?: Maybe<Scalars['String']>;
  platform_notifications?: Maybe<Scalars['String']>;
  potential_partner?: Maybe<Scalars['String']>;
  partner_collaboration?: Maybe<Scalars['String']>;
  chat?: Maybe<Scalars['String']>;
  activity?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditOnBoardingSessionInput = {
  payload?: Maybe<Scalars['JSON']>;
  uuid?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPersonProfileInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  corporate_department?: Maybe<Scalars['ID']>;
  contact_number?: Maybe<Scalars['String']>;
  is_decisionmaker?: Maybe<Scalars['Boolean']>;
  photo?: Maybe<Scalars['ID']>;
  role?: Maybe<Scalars['String']>;
  industry_interests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user?: Maybe<Scalars['ID']>;
  is_decision_influencer?: Maybe<Scalars['Boolean']>;
  decision_role_type?: Maybe<Scalars['String']>;
  profile_type?: Maybe<Enum_Personprofile_Profile_Type>;
  bookmarks?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPricingModelInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPromoCodeConversationInput = {
  code?: Maybe<Scalars['String']>;
  promo_code_redemptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPromoCodeInput = {
  code?: Maybe<Scalars['String']>;
  issued_date?: Maybe<Scalars['DateTime']>;
  claimed?: Maybe<Scalars['Boolean']>;
  promo_matches?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPromoCodeRedemptionInput = {
  promo_code_conversation?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPurchasedServiceInput = {
  uid?: Maybe<Scalars['String']>;
  date_start?: Maybe<Scalars['DateTime']>;
  date_expire?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPurchasedSubscriptionInput = {
  service_package?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  spent?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['Int']>;
  expiry?: Maybe<Scalars['Date']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRatingInput = {
  value?: Maybe<Scalars['Int']>;
  article_type?: Maybe<Enum_Rating_Article_Type>;
  item_id?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRegionInput = {
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currency?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRegionServicePriceInput = {
  service?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  region_code?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditSdgObjectiveInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditServiceCollaborationInput = {
  service?: Maybe<Scalars['ID']>;
  catalyst?: Maybe<Scalars['ID']>;
  client?: Maybe<Scalars['ID']>;
  structure?: Maybe<Array<Maybe<EditComponentServiceCollaborationStructureInput>>>;
  scope?: Maybe<EditComponentServiceCollaborationScopeInput>;
  deliverables?: Maybe<EditComponentServiceCollaborationDeliverableInput>;
  feedback?: Maybe<EditComponentServiceCollaborationFeedbackInput>;
  chat?: Maybe<Scalars['ID']>;
  startup_profile?: Maybe<Scalars['ID']>;
  corporate_profile?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditServiceInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_Services_Role>;
  price?: Maybe<Scalars['Float']>;
  image?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  region_prices?: Maybe<Array<Maybe<EditComponentRegionPricingRegionPriceInput>>>;
  service_collaboration?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditServicePackageInput = {
  name?: Maybe<Scalars['String']>;
  role_type?: Maybe<Enum_Servicepackage_Role_Type>;
  unlimited_credits?: Maybe<Scalars['Boolean']>;
  service_package_price_mode?: Maybe<Array<Maybe<EditComponentServicePackageServicePackagePaymentModeInput>>>;
  region_code?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditServicesInterestInput = {
  email?: Maybe<Scalars['String']>;
  services?: Maybe<Scalars['JSON']>;
  requested_conversation_with?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditStartConversationTermsConditionInput = {
  content?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditStartupProfileInput = {
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  logo?: Maybe<Scalars['ID']>;
  avatar?: Maybe<Scalars['ID']>;
  person_profiles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  psuedo_name?: Maybe<Scalars['String']>;
  operating_locations?: Maybe<Scalars['String']>;
  employee_count?: Maybe<Scalars['Int']>;
  links?: Maybe<EditComponentGenericLinkInput>;
  worked_with_corporates?: Maybe<Scalars['Boolean']>;
  clients?: Maybe<Scalars['String']>;
  incubators_accelerators?: Maybe<Scalars['String']>;
  investment_received?: Maybe<Scalars['Long']>;
  maturity_level?: Maybe<Scalars['ID']>;
  technology_solutions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rating?: Maybe<Scalars['Float']>;
  investment_stage?: Maybe<Scalars['String']>;
  client_count?: Maybe<Scalars['Int']>;
  employee_count_range?: Maybe<Scalars['String']>;
  went_incubator_accelerator?: Maybe<Scalars['Boolean']>;
  investment_received_currency?: Maybe<Scalars['String']>;
  catalyst_allocations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  esg_rating?: Maybe<Enum_Startupprofile_Esg_Rating>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTechnologyReadinessLevelInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTechnologyRequestInput = {
  name?: Maybe<Scalars['String']>;
  technology_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  has_ip?: Maybe<Scalars['Boolean']>;
  can_whitelabel?: Maybe<Scalars['Boolean']>;
  want_poc?: Maybe<Scalars['Boolean']>;
  want_seller?: Maybe<Scalars['Boolean']>;
  want_lease?: Maybe<Scalars['Boolean']>;
  has_api?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  business_use_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  corporate_departments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  budget_min?: Maybe<Scalars['Float']>;
  budget_max?: Maybe<Scalars['Float']>;
  budget_is_disclose?: Maybe<Scalars['Boolean']>;
  business_challange_description?: Maybe<Scalars['String']>;
  projected_startdate?: Maybe<Scalars['Date']>;
  projected_complete_date?: Maybe<Scalars['Date']>;
  country_implementation?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  specification_files?: Maybe<Array<Maybe<Scalars['ID']>>>;
  business_type?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_b2b2c?: Maybe<Scalars['Boolean']>;
  technology_solution_model_others?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
  other_tech_option?: Maybe<Scalars['String']>;
  description_project?: Maybe<Scalars['String']>;
  description_how_to_resolve_problem?: Maybe<Scalars['String']>;
  description_customer?: Maybe<Scalars['String']>;
  description_successful_outcome?: Maybe<Scalars['String']>;
  description_similiar_solutions?: Maybe<Scalars['String']>;
  description_risk_challenges?: Maybe<Scalars['String']>;
  want_explore?: Maybe<Scalars['Boolean']>;
  conversations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  budget_is_poc?: Maybe<Scalars['Boolean']>;
  budget_is_lease?: Maybe<Scalars['Boolean']>;
  hero_image?: Maybe<Scalars['ID']>;
  is_published?: Maybe<Scalars['Boolean']>;
  budget_is_buy?: Maybe<Scalars['Boolean']>;
  impact_level?: Maybe<Scalars['String']>;
  project_budget?: Maybe<Array<Maybe<EditComponentTechnologySolutionProjectBudgetInput>>>;
  impact_area?: Maybe<Scalars['ID']>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  want_investment?: Maybe<Scalars['Boolean']>;
  is_others?: Maybe<Scalars['String']>;
  corporate_profile?: Maybe<Scalars['ID']>;
  is_match_triggered?: Maybe<Scalars['Boolean']>;
  want_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  goal_other?: Maybe<Scalars['String']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTechnologySolutionInput = {
  name?: Maybe<Scalars['String']>;
  purpose_poc?: Maybe<Scalars['Boolean']>;
  purpose_sell?: Maybe<Scalars['Boolean']>;
  purpose_lease?: Maybe<Scalars['Boolean']>;
  has_ip?: Maybe<Scalars['Boolean']>;
  is_whitelabel?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  has_api?: Maybe<Scalars['Boolean']>;
  is_plugandplay?: Maybe<Scalars['Boolean']>;
  hero_image?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Scalars['ID']>>>;
  embed_demo_url?: Maybe<Scalars['String']>;
  technology_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  industries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  business_use_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  corporate_departments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pricing_models?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_spin_off?: Maybe<Scalars['Boolean']>;
  spin_off_source?: Maybe<Scalars['String']>;
  is_gdpr?: Maybe<Scalars['Boolean']>;
  is_cloud?: Maybe<Scalars['Boolean']>;
  key_features?: Maybe<Scalars['String']>;
  versions_release_dates?: Maybe<Scalars['String']>;
  supported_operating_systems?: Maybe<Scalars['String']>;
  total_investment?: Maybe<Scalars['String']>;
  resources_required?: Maybe<Scalars['String']>;
  resource_transfer_details?: Maybe<Scalars['String']>;
  licensing_type_details?: Maybe<Scalars['String']>;
  reason_to_sell?: Maybe<Scalars['String']>;
  assets_to_sell?: Maybe<Scalars['String']>;
  is_consumer_data_collected?: Maybe<Scalars['Boolean']>;
  is_tech_transferrable?: Maybe<Scalars['Boolean']>;
  price_poc_min?: Maybe<Scalars['Float']>;
  price_poc_max?: Maybe<Scalars['Float']>;
  price_lease_min?: Maybe<Scalars['Float']>;
  price_lease_max?: Maybe<Scalars['Float']>;
  demo_video?: Maybe<Scalars['ID']>;
  demo_document?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_others?: Maybe<Scalars['String']>;
  purpose_certify?: Maybe<Scalars['Boolean']>;
  conversations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currency?: Maybe<Scalars['String']>;
  price_sell_min?: Maybe<Scalars['Float']>;
  price_sell_max?: Maybe<Scalars['Float']>;
  is_published?: Maybe<Scalars['Boolean']>;
  benefits_description?: Maybe<Scalars['String']>;
  purpose_investment?: Maybe<Scalars['Boolean']>;
  project_budget?: Maybe<Array<Maybe<EditComponentTechnologySolutionProjectBudgetInput>>>;
  testimonial?: Maybe<EditComponentTechnologySolutionTestimonialInput>;
  invest_information?: Maybe<EditComponentTechnologySolutionInvestInformationInput>;
  technology_readiness?: Maybe<Scalars['String']>;
  use_case_count?: Maybe<Scalars['Int']>;
  use?: Maybe<Scalars['Boolean']>;
  is_use_case_on_request?: Maybe<Scalars['Boolean']>;
  is_consumer_data_collected_remarks?: Maybe<Scalars['String']>;
  is_tech_transferrable_remarks?: Maybe<Scalars['String']>;
  want_to_transfer_resources?: Maybe<Scalars['String']>;
  company_performance_annual_sales?: Maybe<Scalars['String']>;
  is_match_triggered?: Maybe<Scalars['Boolean']>;
  startup_profile?: Maybe<Scalars['ID']>;
  rating?: Maybe<Scalars['Float']>;
  tested_by_alkelio?: Maybe<Scalars['Boolean']>;
  technology_solution_pricing_model?: Maybe<Array<Maybe<EditComponentPricingTechnologySolutionPricingModelInput>>>;
  purpose_access_alkelio_services?: Maybe<Scalars['Boolean']>;
  purpose_explore?: Maybe<Scalars['Boolean']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  case_studies?: Maybe<EditComponentTechnologySolutionCaseStudyInput>;
  sdg_objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sdg_driven?: Maybe<Scalars['Boolean']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTechnologyTypeInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTransactionInput = {
  amount?: Maybe<Scalars['Float']>;
  uid?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Transactions_Status>;
  type?: Maybe<Enum_Transactions_Type>;
  currency?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
  external_transaction_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  person_profile?: Maybe<Scalars['ID']>;
  conversation_messages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  verification_action?: Maybe<Scalars['ID']>;
  catalyst_conversation?: Maybe<Scalars['ID']>;
  catalyst_allocations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notification_preference?: Maybe<Scalars['ID']>;
  promo_code_redemptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUserSubmittedGoalInput = {
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditVerificationActionInput = {
  code?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Boolean']>;
  expiresAt?: Maybe<Scalars['Long']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditViewCountInput = {
  count?: Maybe<Scalars['Long']>;
  article_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type FindCurrentUserBookmarksContentPayload = {
  __typename?: 'findCurrentUserBookmarksContentPayload';
  bookmarks?: Maybe<Array<Maybe<BookmarkContent>>>;
};

export type FindOnboardingSessionByUuidPayload = {
  __typename?: 'findOnboardingSessionByUUIDPayload';
  payload?: Maybe<Scalars['JSON']>;
};

export type StartupProfileSummary = {
  __typename?: 'startupProfileSummary';
  country?: Maybe<Scalars['String']>;
  maturity_level?: Maybe<Scalars['String']>;
};

export type TechnologyRequestMatchSummary = {
  __typename?: 'technologyRequestMatchSummary';
  id: Scalars['ID'];
  name: Scalars['String'];
  business_challange_description?: Maybe<Scalars['String']>;
  hero_image_url?: Maybe<Scalars['String']>;
  corporateProfile?: Maybe<CorporateProfileSummary>;
  match_rating?: Maybe<Scalars['Float']>;
};

export type TechnologyRequestSummary = {
  __typename?: 'technologyRequestSummary';
  id: Scalars['ID'];
  name: Scalars['String'];
  business_challange_description?: Maybe<Scalars['String']>;
  hero_image_url?: Maybe<Scalars['String']>;
  corporateProfile?: Maybe<CorporateProfileSummary>;
};

export type TechnologySolutionMatchSummary = {
  __typename?: 'technologySolutionMatchSummary';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  hero_image_url?: Maybe<Scalars['String']>;
  startupProfile?: Maybe<StartupProfileSummary>;
  match_rating?: Maybe<Scalars['Float']>;
};

export type TechnologySolutionSummary = {
  __typename?: 'technologySolutionSummary';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  hero_image_url?: Maybe<Scalars['String']>;
  startupProfile?: Maybe<StartupProfileSummary>;
};

export type UpdateApplicationConfigInput = {
  data?: Maybe<EditApplicationConfigInput>;
};

export type UpdateApplicationConfigPayload = {
  __typename?: 'updateApplicationConfigPayload';
  applicationConfig?: Maybe<ApplicationConfig>;
};

export type UpdateBookmarkInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBookmarkInput>;
};

export type UpdateBookmarkPayload = {
  __typename?: 'updateBookmarkPayload';
  bookmark?: Maybe<Bookmark>;
};

export type UpdateBusinessUseCaseInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBusinessUseCaseInput>;
};

export type UpdateBusinessUseCasePayload = {
  __typename?: 'updateBusinessUseCasePayload';
  businessUseCase?: Maybe<BusinessUseCase>;
};

export type UpdateCareerInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCareerInput>;
};

export type UpdateCareerPayload = {
  __typename?: 'updateCareerPayload';
  career?: Maybe<Careers>;
};

export type UpdateCatalystAllocationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalystAllocationInput>;
};

export type UpdateCatalystAllocationPayload = {
  __typename?: 'updateCatalystAllocationPayload';
  catalystAllocation?: Maybe<CatalystAllocation>;
};

export type UpdateCatalystConversationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalystConversationInput>;
};

export type UpdateCatalystConversationPayload = {
  __typename?: 'updateCatalystConversationPayload';
  catalystConversation?: Maybe<CatalystConversations>;
};

export type UpdateChatInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditChatInput>;
};

export type UpdateChatMessageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditChatMessageInput>;
};

export type UpdateChatMessagePayload = {
  __typename?: 'updateChatMessagePayload';
  chatMessage?: Maybe<ChatMessages>;
};

export type UpdateChatPayload = {
  __typename?: 'updateChatPayload';
  chat?: Maybe<Chat>;
};

export type UpdateConversationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditConversationInput>;
};

export type UpdateConversationMessageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditConversationMessageInput>;
};

export type UpdateConversationMessagePayload = {
  __typename?: 'updateConversationMessagePayload';
  conversationMessage?: Maybe<ConversationMessage>;
};

export type UpdateConversationPayload = {
  __typename?: 'updateConversationPayload';
  conversation?: Maybe<Conversations>;
};

export type UpdateCorporateDepartmentInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCorporateDepartmentInput>;
};

export type UpdateCorporateDepartmentPayload = {
  __typename?: 'updateCorporateDepartmentPayload';
  corporateDepartment?: Maybe<CorporateDepartment>;
};

export type UpdateCorporateInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCorporateInput>;
};

export type UpdateCorporatePayload = {
  __typename?: 'updateCorporatePayload';
  corporate?: Maybe<Corporate>;
};

export type UpdateCountryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCountryInput>;
};

export type UpdateCountryPayload = {
  __typename?: 'updateCountryPayload';
  country?: Maybe<Country>;
};

export type UpdateCreditInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCreditInput>;
};

export type UpdateCreditPayload = {
  __typename?: 'updateCreditPayload';
  credit?: Maybe<Credits>;
};

export type UpdateDocumentSharingInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditDocumentSharingInput>;
};

export type UpdateDocumentSharingPayload = {
  __typename?: 'updateDocumentSharingPayload';
  documentSharing?: Maybe<DocumentSharing>;
};

export type UpdateEnquiryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditEnquiryInput>;
};

export type UpdateEnquiryPayload = {
  __typename?: 'updateEnquiryPayload';
  enquiry?: Maybe<Enquiries>;
};

export type UpdateGoalInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditGoalInput>;
};

export type UpdateGoalPayload = {
  __typename?: 'updateGoalPayload';
  goal?: Maybe<Goals>;
};

export type UpdateImpactAreaInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditImpactAreaInput>;
};

export type UpdateImpactAreaPayload = {
  __typename?: 'updateImpactAreaPayload';
  impactArea?: Maybe<ImpactArea>;
};

export type UpdateIndustryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditIndustryInput>;
};

export type UpdateIndustryPayload = {
  __typename?: 'updateIndustryPayload';
  industry?: Maybe<Industry>;
};

export type UpdateJobPostingInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditJobPostingInput>;
};

export type UpdateJobPostingPayload = {
  __typename?: 'updateJobPostingPayload';
  jobPosting?: Maybe<JobPosting>;
};

export type UpdateMatchMakingResultInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditMatchMakingResultInput>;
};

export type UpdateMatchMakingResultPayload = {
  __typename?: 'updateMatchMakingResultPayload';
  matchMakingResult?: Maybe<MatchMakingResult>;
};

export type UpdateMaturityLevelInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditMaturityLevelInput>;
};

export type UpdateMaturityLevelPayload = {
  __typename?: 'updateMaturityLevelPayload';
  maturityLevel?: Maybe<MaturityLevel>;
};

export type UpdateNewsArticleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNewsArticleInput>;
};

export type UpdateNewsArticlePayload = {
  __typename?: 'updateNewsArticlePayload';
  newsArticle?: Maybe<NewsArticle>;
};

export type UpdateNotificationPreferenceInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNotificationPreferenceInput>;
};

export type UpdateNotificationPreferencePayload = {
  __typename?: 'updateNotificationPreferencePayload';
  notificationPreference?: Maybe<NotificationPreferences>;
};

export type UpdateOnBoardingSessionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditOnBoardingSessionInput>;
};

export type UpdateOnBoardingSessionPayload = {
  __typename?: 'updateOnBoardingSessionPayload';
  onBoardingSession?: Maybe<OnBoardingSession>;
};

export type UpdateOnboardingSessionByUuidInput = {
  uuid?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
};

export type UpdateOnboardingSessionByUuidPayload = {
  __typename?: 'updateOnboardingSessionByUUIDPayload';
  payload?: Maybe<Scalars['JSON']>;
};

export type UpdatePersonProfileInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPersonProfileInput>;
};

export type UpdatePersonProfilePayload = {
  __typename?: 'updatePersonProfilePayload';
  personProfile?: Maybe<PersonProfile>;
};

export type UpdatePricingModelInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPricingModelInput>;
};

export type UpdatePricingModelPayload = {
  __typename?: 'updatePricingModelPayload';
  pricingModel?: Maybe<PricingModel>;
};

export type UpdatePromoCodeConversationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPromoCodeConversationInput>;
};

export type UpdatePromoCodeConversationPayload = {
  __typename?: 'updatePromoCodeConversationPayload';
  promoCodeConversation?: Maybe<PromoCodeConversation>;
};

export type UpdatePromoCodeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPromoCodeInput>;
};

export type UpdatePromoCodePayload = {
  __typename?: 'updatePromoCodePayload';
  promoCode?: Maybe<PromoCode>;
};

export type UpdatePromoCodeRedemptionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPromoCodeRedemptionInput>;
};

export type UpdatePromoCodeRedemptionPayload = {
  __typename?: 'updatePromoCodeRedemptionPayload';
  promoCodeRedemption?: Maybe<PromoCodeRedemptions>;
};

export type UpdatePurchasedServiceInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPurchasedServiceInput>;
};

export type UpdatePurchasedServicePayload = {
  __typename?: 'updatePurchasedServicePayload';
  purchasedService?: Maybe<PurchasedServices>;
};

export type UpdatePurchasedSubscriptionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPurchasedSubscriptionInput>;
};

export type UpdatePurchasedSubscriptionPayload = {
  __typename?: 'updatePurchasedSubscriptionPayload';
  purchasedSubscription?: Maybe<PurchasedSubscription>;
};

export type UpdateRatingInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRatingInput>;
};

export type UpdateRatingPayload = {
  __typename?: 'updateRatingPayload';
  rating?: Maybe<Rating>;
};

export type UpdateRegionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRegionInput>;
};

export type UpdateRegionPayload = {
  __typename?: 'updateRegionPayload';
  region?: Maybe<Region>;
};

export type UpdateRegionServicePriceInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRegionServicePriceInput>;
};

export type UpdateRegionServicePricePayload = {
  __typename?: 'updateRegionServicePricePayload';
  regionServicePrice?: Maybe<RegionServicePrice>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateSdgObjectiveInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSdgObjectiveInput>;
};

export type UpdateSdgObjectivePayload = {
  __typename?: 'updateSdgObjectivePayload';
  sdgObjective?: Maybe<SdgObjectives>;
};

export type UpdateServiceCollaborationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditServiceCollaborationInput>;
};

export type UpdateServiceCollaborationPayload = {
  __typename?: 'updateServiceCollaborationPayload';
  serviceCollaboration?: Maybe<ServiceCollaboration>;
};

export type UpdateServiceInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditServiceInput>;
};

export type UpdateServicePackageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditServicePackageInput>;
};

export type UpdateServicePackagePayload = {
  __typename?: 'updateServicePackagePayload';
  servicePackage?: Maybe<ServicePackage>;
};

export type UpdateServicePayload = {
  __typename?: 'updateServicePayload';
  service?: Maybe<Services>;
};

export type UpdateServicesInterestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditServicesInterestInput>;
};

export type UpdateServicesInterestPayload = {
  __typename?: 'updateServicesInterestPayload';
  servicesInterest?: Maybe<ServicesInterest>;
};

export type UpdateStartConversationTermsConditionInput = {
  data?: Maybe<EditStartConversationTermsConditionInput>;
};

export type UpdateStartConversationTermsConditionPayload = {
  __typename?: 'updateStartConversationTermsConditionPayload';
  startConversationTermsCondition?: Maybe<StartConversationTermsConditions>;
};

export type UpdateStartupProfileInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditStartupProfileInput>;
};

export type UpdateStartupProfilePayload = {
  __typename?: 'updateStartupProfilePayload';
  startupProfile?: Maybe<StartupProfile>;
};

export type UpdateTechnologyReadinessLevelInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTechnologyReadinessLevelInput>;
};

export type UpdateTechnologyReadinessLevelPayload = {
  __typename?: 'updateTechnologyReadinessLevelPayload';
  technologyReadinessLevel?: Maybe<TechnologyReadinessLevel>;
};

export type UpdateTechnologyRequestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTechnologyRequestInput>;
};

export type UpdateTechnologyRequestPayload = {
  __typename?: 'updateTechnologyRequestPayload';
  technologyRequest?: Maybe<TechnologyRequest>;
};

export type UpdateTechnologySolutionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTechnologySolutionInput>;
};

export type UpdateTechnologySolutionPayload = {
  __typename?: 'updateTechnologySolutionPayload';
  technologySolution?: Maybe<TechnologySolution>;
};

export type UpdateTechnologyTypeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTechnologyTypeInput>;
};

export type UpdateTechnologyTypePayload = {
  __typename?: 'updateTechnologyTypePayload';
  technologyType?: Maybe<TechnologyType>;
};

export type UpdateTransactionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTransactionInput>;
};

export type UpdateTransactionPayload = {
  __typename?: 'updateTransactionPayload';
  transaction?: Maybe<Transactions>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateUserSubmittedGoalInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserSubmittedGoalInput>;
};

export type UpdateUserSubmittedGoalPayload = {
  __typename?: 'updateUserSubmittedGoalPayload';
  userSubmittedGoal?: Maybe<UserSubmittedGoals>;
};

export type UpdateVerificationActionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditVerificationActionInput>;
};

export type UpdateVerificationActionPayload = {
  __typename?: 'updateVerificationActionPayload';
  verificationAction?: Maybe<VerificationAction>;
};

export type UpdateViewCountInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditViewCountInput>;
};

export type UpdateViewCountPayload = {
  __typename?: 'updateViewCountPayload';
  viewCount?: Maybe<ViewCounts>;
};

export type UseVerificationPayload = {
  __typename?: 'useVerificationPayload';
  jwt: Scalars['String'];
  email: Scalars['String'];
};
